
/* Rivers Refined - Soft Wall Room Designer - app (guided steps, wall drawing, 3D room, share). */
(function () {
'use strict';
const G = window.RRGeom, St = window.RRState;


const WALLS = St.WALLS, SURFACES = St.SURFACES;
// Drawing-only spacing for the planning view. Not a construction figure.
const VIEW_SPACING = { reveal: 0.375, edge: { ceiling: 0.5, floor: 0.5, corner: 0.5, opening: 0.5 } };
const STORE_KEY = 'rr-room-designer-state-v3', OLD_STORE_KEYS = ['rr-room-designer-state-v2', 'rr-room-designer-state-v1'];
const SHELL = (document.body.className.match(/shell-(\w)/) || [])[1] || 'A';
const LIGHT = document.documentElement.getAttribute('data-theme') === 'light';
const REDUCED = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
const PHONE = () => window.innerWidth < 760;
// Shell C (Planner) gives every tool its own row; A and B keep four guided steps.
const STEPS = SHELL === 'C' ? ['room', 'openings', 'headboard', 'design', 'fabric', 'finish', 'drawing', 'send'] : ['room', 'design', 'fabric', 'send'];
const STEP_TITLES = { assistant: 'Design assistant', room: 'Room', openings: 'Openings', headboard: 'Headboard', design: 'Patterns', fabric: 'Fabric', finish: 'Finishes', drawing: 'Drawing', send: 'Send', shop: 'Shop' };
const NEXT_WORDS = { room: 'Next: openings', openings: 'Next: headboard', headboard: 'Next: patterns', design: 'Next: fabric', fabric: 'Next: finishes', finish: 'Next: drawing', drawing: 'Review and send' };
const NEXT_AB = ['Next: design', 'Next: fabric', 'Review and send'];
let PARTS = false; // part numbers on the drawings: the full build only


// ------------------------------------------------------------ state

function readStored(key) {
  try { const raw = localStorage.getItem(key); return raw ? St.upgradeState(JSON.parse(raw)) : null; } catch (e) { return null; }
}
function hashState() {
  const m = /[#&]d=([A-Za-z0-9_-]+)/.exec(location.hash || '');
  return m ? St.decodeState(m[1]) : null;
}
const fromLink = hashState();
let state = fromLink || readStored(STORE_KEY) || OLD_STORE_KEYS.reduce((s, k) => s || readStored(k), null);
const firstVisit = !state;
if (!state) state = St.PRESETS[LIGHT ? 'bedroom' : 'theater']();
const ui = { step: 'room', wall: 'front', zone: 0, target: 'main', editOpening: -1, open: firstVisit || !PHONE(), view: 'wall', mode: '3d',
  patGroup: 'suggested', dims: false, roomMenu: false, more: { sections: false, lighting: false, pillars: false, headboard: false } };
if (fromLink) ui.step = 'send';
let layouts = {};

let saveQueued = false;
let freshStart = false; // after Start over, nothing is saved or put in the address until the next edit
function saveState() {
  if (saveQueued) return; saveQueued = true;
  requestAnimationFrame(() => {
    saveQueued = false;
    if (freshStart) { freshStart = false; return; }
    try { localStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) { /* storage unavailable */ }
    try { history.replaceState(null, '', '#d=' + St.encodeState(state)); } catch (e) { /* sandboxed frame */ }
  });
}
function shareLink() { return location.href.split('#')[0] + '#d=' + St.encodeState(state); }

// undo / redo: whole-state snapshots, edits within half a second fold into one step
const hist = { undo: [], redo: [], last: JSON.stringify(state), t: 0 };
function recordHistory() {
  const cur = JSON.stringify(state);
  if (cur === hist.last) return;
  const now = performance.now();
  if (now - hist.t > 500 || !hist.undo.length) { hist.undo.push(hist.last); if (hist.undo.length > 80) hist.undo.shift(); }
  hist.t = now; hist.redo = []; hist.last = cur;
  renderUtility();
}
function stepHistory(dir) {
  const from = dir < 0 ? hist.undo : hist.redo, to = dir < 0 ? hist.redo : hist.undo;
  if (!from.length) return;
  to.push(JSON.stringify(state));
  state = St.upgradeState(JSON.parse(from.pop())) || state;
  hist.last = JSON.stringify(state); hist.t = 0;
  if (!state.walls[ui.wall]) ui.wall = 'front';
  commit(true, true); refocus(true);
  toast(dir < 0 ? 'Undone' : 'Redone');
}

const isCeil = (k) => k === 'ceiling';
function surfW(k) { return St.surfaceSize(state, k).w; }
function surfH(k) { return St.surfaceSize(state, k).h; }
function wallLabel(k) { return SURFACES.find(w => w.key === k).label; }
function surfaceName(k) { return isCeil(k) ? 'ceiling' : wallLabel(k).toLowerCase() + ' wall'; }
function curWall() { return state.walls[ui.wall]; }
function curZone() { const w = curWall(); return w.wainscot && !w.comp ? ui.zone : 0; }
function curDesign() { return curWall().zones[curZone()]; }
function curInfo() { const L = layouts[ui.wall]; return (L && L.zones[curZone()] && L.zones[curZone()].info) || {}; }
function layoutMode(w) { return w.comp ? 'feature' : w.wainscot ? 'wainscot' : 'full'; }

function layoutOpts(k) {
  let o;
  
  if (!o) o = { reveal: VIEW_SPACING.reveal, edge: VIEW_SPACING.edge, minPiece: state.minPiece };
  if (isCeil(k)) o = Object.assign({}, o, { edge: { ceiling: o.edge.corner, floor: o.edge.corner, corner: o.edge.corner, opening: o.edge.opening } });
  else if (state.room.levels) o = Object.assign({}, o, { tiers: G.tierRunsOnWall(state.room.levels, k, state.room.W, state.room.L) });
  return o;
}
function computeAll() {
  layouts = {};
  SURFACES.forEach(w => { layouts[w.key] = G.computeWallLayout(state.walls[w.key], surfW(w.key), surfH(w.key), layoutOpts(w.key)); });
}

// ------------------------------------------------------------ small helpers

const $ = (sel, root) => (root || document).querySelector(sel);
const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));
function esc(s) { return String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
function getPath(path) { return path.split('.').reduce((o, k) => (o == null ? o : o[k]), state); }
function setPath(path, v) {
  const ks = path.split('.'); let o = state;
  for (let i = 0; i < ks.length - 1; i++) o = o[ks[i]];
  o[ks[ks.length - 1]] = v;
}
function inches(v) { return Math.round(v) + ' in'; }
let uid = 0;

const ICON = {
  spark: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.5l1.9 5.6 5.6 1.9-5.6 1.9L12 18.5l-1.9-5.6L4.5 11l5.6-1.9z"/><path d="M18.5 15.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z"/></svg>',
  minus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 12h12"/></svg>',
  plus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 6v12M6 12h12"/></svg>',
  close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7l10 10M17 7L7 17"/></svg>',
  chev: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 10l5 5 5-5"/></svg>',
  check: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5.5 12.5l4 4 9-9"/></svg>',
  camera: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 8.5h3.2L9 6h6l1.8 2.5H20v10H4z"/><circle cx="12" cy="13.2" r="3.3"/></svg>',
  room: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 8l8-4 8 4v8l-8 4-8-4zM4 8l8 4 8-4M12 12v8"/></svg>',
  screen: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="11.5" rx="1"/><path d="M9 20h6M12 16.5V20"/></svg>',
  door: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 21V3.5h12V21M4 21h16"/><circle cx="15" cy="12.5" r=".9"/></svg>',
  glass: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 21V3.5h12V21M4 21h16"/><path d="M8.5 6v12.5M15.5 6l-4 5"/></svg>',
  window: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4.5" y="3.5" width="15" height="17" rx=".5"/><path d="M12 3.5v17M4.5 12h15"/></svg>',
  outlet: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="3.5" width="12" height="17" rx="2"/><path d="M10 8.5v3M14 8.5v3M10.5 15.5h3"/></svg>',
  copy: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="8.5" y="8.5" width="11" height="11" rx="1.5"/><path d="M15.5 8.5V5.5a1 1 0 0 0-1-1h-9a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h3"/></svg>',
  mail: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3.5" y="5.5" width="17" height="13" rx="1.5"/><path d="M4 6.5l8 6 8-6"/></svg>',
  image: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3.5" y="4.5" width="17" height="15" rx="1.5"/><path d="M3.5 16l5-5 4 4 2.5-2.5 5.5 5.5"/><circle cx="15.5" cy="9" r="1.4"/></svg>',
  stair: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 20h4v-4h4v-4h4V8h4V4.5"/></svg>',
  sections: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3.5" y="4" width="4" height="16" rx=".5"/><rect x="9" y="4" width="6" height="16" rx=".5"/><rect x="16.5" y="4" width="4" height="16" rx=".5"/></svg>',
  bulb: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 17.5h6M10 20.5h4M8.2 14.5a6 6 0 1 1 7.6 0c-.8.7-1.3 1.6-1.3 2.5h-5c0-.9-.5-1.8-1.3-2.5z"/></svg>',
};
const OPENING_ICON = { screen: ICON.screen, door: ICON.door, window: ICON.window, outlet: ICON.outlet, glass: ICON.glass };
const ADD_ORDER = [['screen', 'Add a TV'], ['door', 'Add a door'], ['window', 'Add a window'], ['glass', 'Add a glass door'], ['outlet', 'Add an outlet']];

// ------------------------------------------------------------ pattern thumbnails, drawn from the real geometry

function polyPath(p) { return 'M' + p.map(v => v[0].toFixed(2) + ' ' + v[1].toFixed(2)).join('L') + 'Z'; }
const THUMB_DESIGNS = {
  grid: { rows: 3, cols: 4 }, channels: { count: 7 }, bands: { count: 4 },
  diamonds: { moduleW: 26, angle: 50 }, chevrons: { moduleW: 20, moduleH: 15, angle: 30 },
  bond: { moduleW: 24, moduleH: 18 }, ashlar: { moduleW: 17, moduleH: 15, mirror: true }, triangles: { moduleW: 22, angle: 60 },
  tumbling: { moduleW: 21, moduleH: 24 }, lattice: { moduleW: 17, angle: 55, mirror: true }, framed: { moduleW: 38, moduleH: 37, count: 22 },
  facets: { moduleW: 11, angle: 55, mirror: true }, fishbone: { moduleW: 14, moduleH: 8, angle: 35 }, arrow: { moduleW: 6, angle: 45, count: 4 },
  broken: { moduleW: 24, moduleH: 26, angle: 22 }, alternate: { moduleW: 17, moduleH: 9, angle: 30 }, fan: { moduleH: 11, angle: 35 },
  scurve: { moduleW: 16, moduleH: 34, count: 75 }, arch: { moduleW: 14, count: 175 }, curved: { moduleW: 16, count: 70 },
  hexes: { moduleW: 16, moduleH: 26 }, capsule: { moduleW: 12, moduleH: 34 }, decofan: { moduleW: 16, moduleH: 11, count: 50 },
  diagbands: { moduleW: 12, angle: 45 }, roundel: { moduleW: 46, count: 0, mirror: true }, custom: { moduleW: 40, moduleH: 30 }, flow: { moduleW: 10, count: 3 }, facetcols: { moduleW: 22, angle: 45 },
};
const THUMB_CACHE = {};
function thumbSVG(type, opts) {
  const key = type + (opts && opts.accent ? '+a' : '') + (opts && opts.custom ? JSON.stringify(opts.custom) : '');
  if (THUMB_CACHE[key]) return THUMB_CACHE[key];
  const Wt = 120, Ht = 80, gap = 2.6;
  let paths = '';
  const draw = (d, R) => {
    const { cells } = G.designCells(d, R, gap);
    for (const c of cells) {
      if (c.kind === 'mirror' && !d.mirror) continue;
      const parts = G.isConvex(c.poly) ? [G.clipRect(c.poly, R.x0, R.y0, R.x1, R.y1)] : G.clipRectAny(c.poly, R.x0, R.y0, R.x1, R.y1);
      for (const p of parts) if (G.area(p) > 1) paths += '<path d="' + polyPath(p) + '"' + (c.kind === 'mirror' ? ' class="ins"' : c.accent ? ' class="acc"' : '') + '/>';
    }
  };
  if (type === 'wainscot') {
    draw(Object.assign(G.defaultDesign('grid'), { rows: 1, cols: 4 }), { x0: 3, y0: 3, x1: Wt - 3, y1: 30 });
    draw(Object.assign(G.defaultDesign('channels'), { count: 7 }), { x0: 3, y0: 34, x1: Wt - 3, y1: Ht - 3 });
  } else if (type === 'full') {
    draw(Object.assign(G.defaultDesign('channels'), { count: 7 }), { x0: 3, y0: 3, x1: Wt - 3, y1: Ht - 3 });
  } else if (type === 'feature') {
    draw(Object.assign(G.defaultDesign('diamonds'), { moduleW: 16, angle: 50 }), { x0: 30, y0: 3, x1: Wt - 30, y1: Ht - 3 });
    paths += '<rect class="ins" x="3" y="3" width="24" height="' + (Ht - 6) + '"/><rect class="ins" x="' + (Wt - 27) + '" y="3" width="24" height="' + (Ht - 6) + '"/>';
  } else if (type !== 'none') {
    draw(Object.assign(G.defaultDesign(type), THUMB_DESIGNS[type] || {}, (opts && opts.accent) ? { accentOn: true } : {}, (opts && opts.custom) ? { custom: opts.custom } : {}), { x0: 3, y0: 3, x1: Wt - 3, y1: Ht - 3 });
  }
  if (type === 'none') paths = '<rect class="bare" x="3" y="3" width="' + (Wt - 6) + '" height="' + (Ht - 6) + '"/>';
  return (THUMB_CACHE[key] = '<svg class="thumb" viewBox="0 0 ' + Wt + ' ' + Ht + '" aria-hidden="true"><g transform="translate(0 ' + Ht + ') scale(1 -1)">' + paths + '</g></svg>');
}
function presetFocus(key) { const p = St.PRESET_LIST.find(x => x[0] === key); return p ? p[3] : 'front'; }
function presetSVG(name) {
  const s = St.PRESETS[name](), k = presetFocus(name) === 'room' ? 'left' : presetFocus(name);
  const sz = St.surfaceSize(s, k), L = G.computeWallLayout(s.walls[k], sz.w, sz.h, Object.assign({}, VIEW_SPACING, { minPiece: 3 }));
  const W = L.W, H = L.H, sw = Math.max(W, H) / 120;
  let h = '<svg class="thumb preset-thumb" viewBox="' + (-sw) + ' ' + (-sw) + ' ' + (W + 2 * sw) + ' ' + (H + 2 * sw) + '" aria-hidden="true" preserveAspectRatio="xMidYMid slice"><g transform="translate(0 ' + H + ') scale(1 -1)">';
  h += '<rect x="0" y="0" width="' + W + '" height="' + H + '" fill="' + (LIGHT ? '#E6E3DD' : '#1B1B1C') + '"/>';
  for (const p of L.pieces) h += '<path d="' + polyPath(p.poly) + '" fill="' + esc(p.color) + '" stroke="rgba(0,0,0,.35)" stroke-width="' + (sw * 0.6) + '"/>';
  for (const p of L.inserts) h += '<path d="' + polyPath(p.poly) + '" fill="#8E949B"/>';
  for (const o of L.openings) { const r = o.raw; h += '<rect x="' + r.x0 + '" y="' + r.y0 + '" width="' + (r.x1 - r.x0) + '" height="' + (r.y1 - r.y0) + '" fill="' + (LIGHT ? '#CFCBC3' : '#050505') + '"/>'; }
  return h + '</g></svg>';
}
const PRESET_THUMBS = {}, PRESET_IMG = {};
function presetPic(key) {
  if (PRESET_IMG[key]) return '<img class="thumb" src="' + PRESET_IMG[key] + '" alt="">';
  if (!PRESET_THUMBS[key]) PRESET_THUMBS[key] = presetSVG(key);
  return PRESET_THUMBS[key];
}

// ------------------------------------------------------------ form pieces

function lenField(label, path, step, small) {
  const id = 'f' + (++uid);
  return '<div class="field len' + (small ? ' small' : '') + '"><label for="' + id + '">' + esc(label) + '</label><div class="stepper">' +
    '<button type="button" class="stepbtn" data-nudge="' + path + '" data-by="' + (-step) + '" aria-label="' + esc(label) + ', less">' + ICON.minus + '</button>' +
    '<input id="' + id + '" type="text" inputmode="text" data-bind="' + path + '" data-kind="len" value="' + esc(G.fmtFtIn(getPath(path))) + '" autocomplete="off" spellcheck="false">' +
    '<button type="button" class="stepbtn" data-nudge="' + path + '" data-by="' + step + '" aria-label="' + esc(label) + ', more">' + ICON.plus + '</button></div></div>';
}
function seg(path, options, label) {
  const v = getPath(path);
  return '<div class="seg" role="group"' + (label ? ' aria-label="' + esc(label) + '"' : '') + '>' + options.map(o => '<button type="button" data-set="' + path + '" data-value="' + o[0] +
    '" aria-pressed="' + (String(o[0]) === String(v)) + '">' + esc(o[1]) + '</button>').join('') + '</div>';
}
function fieldSeg(label, path, options) { return '<div class="field"><span class="label">' + esc(label) + '</span>' + seg(path, options, label) + '</div>'; }
function rangeField(label, attr, min, max, step, v, shown) {
  const id = 'f' + (++uid);
  return '<div class="field"><label for="' + id + '" class="label">' + esc(label) + ' <output class="val" data-out="' + attr + '">' + esc(shown) + '</output></label>' +
    '<input id="' + id + '" class="range" type="range" min="' + min + '" max="' + max + '" step="' + step + '" value="' + v + '" data-range="' + attr + '"></div>';
}
function switchBtn(attr, on, label) {
  return '<button type="button" class="switch" role="switch" ' + attr + ' aria-checked="' + !!on + '"><span class="knob"></span>' + esc(label) + '</button>';
}
function wallChips(withCeiling) {
  const list = withCeiling ? SURFACES : WALLS;
  return '<div class="wallchips" role="group" aria-label="Surface">' + list.map(w => '<button type="button" class="chip" data-wall="' + w.key + '" aria-pressed="' + (w.key === ui.wall) + '">' + w.label + '</button>').join('') + '</div>';
}
function zoneSeg() {
  const w = curWall();
  if (!w.wainscot || w.comp) return '';
  return '<div class="seg" role="group" aria-label="Section of the wall">' + ['Lower section', 'Upper section'].map((t, i) =>
    '<button type="button" data-zone="' + i + '" aria-pressed="' + (i === curZone()) + '">' + t + '</button>').join('') + '</div>';
}
function chips(items, current, attr, label) {
  return '<div class="chips" role="group" aria-label="' + esc(label) + '">' + items.map(([t, v]) =>
    '<button type="button" class="chip" ' + attr + '="' + v + '" aria-pressed="' + (Math.abs(+current - v) < Math.max(0.6, Math.abs(v) * 0.02)) + '">' + esc(t) + '</button>').join('') + '</div>';
}
function disclosure(key, icon, title, summary, body) {
  const open = !!ui.more[key];
  return '<div class="group more' + (open ? ' open' : '') + '"><button type="button" class="morehead" data-more="' + key + '" aria-expanded="' + open + '">' +
    '<span class="more-ic">' + icon + '</span><span class="more-t">' + esc(title) + '</span><span class="more-s">' + esc(summary) + '</span><span class="more-chev">' + ICON.chev + '</span></button>' +
    (open ? '<div class="morebody">' + body + '</div>' : '') + '</div>';
}

// ------------------------------------------------------------ room type: a dropdown with pictures, grouped

function roomPicker() {
  const cur = St.PRESET_LIST.find(p => p[0] === state.room.kind);
  const label = cur ? cur[1] : 'Choose a room';
  let h = '<div class="field"><span class="label" id="roomTypeLabel">Room type</span><div class="roomsel' + (ui.roomMenu ? ' open' : '') + '">' +
    '<button type="button" class="roomsel-btn" id="roomSelBtn" aria-haspopup="listbox" aria-expanded="' + ui.roomMenu + '" aria-labelledby="roomTypeLabel roomSelBtn">' +
    '<span class="roomsel-pic">' + (cur ? presetPic(cur[0]) : '') + '</span><span class="roomsel-txt"><b>' + esc(label) + '</b>' + (cur ? '<span>' + esc(cur[2]) + '</span>' : '') + '</span><span class="roomsel-chev">' + ICON.chev + '</span></button>';
  if (ui.roomMenu) {
    h += '<ul class="roomsel-list" id="roomList" role="listbox" aria-labelledby="roomTypeLabel" tabindex="-1">';
    St.PRESET_GROUPS.forEach(([g, gl]) => {
      h += '<li role="presentation" class="roomsel-group">' + esc(gl) + '</li>';
      St.PRESET_LIST.filter(p => p[4] === g).forEach(([key, title, line]) => {
        const s0 = St.PRESETS[key]().room;
        h += '<li role="option" class="roomsel-opt" id="ro-' + key + '" data-preset="' + key + '" aria-selected="' + (key === state.room.kind) + '" tabindex="-1">' +
          '<span class="roomsel-pic">' + presetPic(key) + '</span><span class="roomsel-txt"><b>' + esc(title) + '</b><span>' + esc(line) + '</span></span>' +
          '<span class="roomsel-size">' + G.fmtFtIn(s0.W).replace(/ 0"$/, '') + ' x ' + G.fmtFtIn(s0.L).replace(/ 0"$/, '') + '</span>' + (key === state.room.kind ? '<span class="roomsel-check">' + ICON.check + '</span>' : '') + '</li>';
      });
    });
    h += '</ul>';
  }
  return h + '</div></div>';
}

// ------------------------------------------------------------ panes, as HTML blocks the shells arrange

function roomHTML() {
  return '<div class="group">' + roomPicker() + '<p class="lead">Each room starts with a suggested design. Change anything after.</p></div>' +
    '<div class="group"><h3>Room size</h3><p class="lead">Feet and inches, like 14\' 6", or plain inches.</p>' +
    lenField('Front wall width', 'room.W', 6) + lenField('Side wall length', 'room.L', 6) + lenField('Ceiling height', 'room.H', 3) +
    '<div class="field"><span class="label">Floor</span>' + seg('room.floor', [['carpet', 'Carpet'], ['wood', 'Wood']], 'Floor') + '</div></div>' + levelsHTML();
}
const LEVEL_ROOMS = ['theater', 'theater26', 'media', 'conference', 'restaurant'];
function levelsHTML() {
  const lv = state.room.levels;
  if (!lv && !LEVEL_ROOMS.includes(state.room.kind)) return '';
  let h = '<div class="group"><h3>Steps or levels</h3><div class="field"><span class="label">Does the room have steps or levels?</span>' +
    '<div class="seg" role="group" aria-label="Steps or levels"><button type="button" data-levels="0" aria-pressed="' + !lv + '">No</button><button type="button" data-levels="1" aria-pressed="' + !!lv + '">Yes</button></div></div>';
  if (lv) {
    h += '<div class="field"><span class="label">Tiers</span>' + chips([['One', 1], ['Two', 2], ['Three', 3], ['Four', 4]], lv.n, 'data-tiers', 'Tiers') + '</div>' +
      '<div class="pair">' + lenField('Riser height', 'room.levels.rise', 1, true) + lenField('Tier depth', 'room.levels.depth', 3, true) + '</div>' +
      lenField('First step, from the screen wall', 'room.levels.start', 6) +
      switchBtn('data-lvflag="seats"', lv.seats, 'Show seating rows') + switchBtn('data-lvflag="lights"', lv.lights, 'Step lights') +
      '<p class="lead sm">The side-wall panels step up with each tier, keeping the floor gap above it.</p>';
  }
  return h + '</div>';
}
function openingsHTML() {
  if (isCeil(ui.wall)) return '<div class="group"><h3>Doors, windows and the TV</h3>' + wallChips(false) + '<p class="lead">The ceiling has no openings here. Choose a wall.</p></div>';
  const w = curWall();
  let h = '<div class="group openings-group"><h3>Doors, windows and the TV</h3>' + wallChips(false) + '<ul class="openings">';
  w.openings.forEach((o, i) => {
    const p = 'walls.' + ui.wall + '.openings.' + i, open = ui.editOpening === i;
    h += '<li class="op' + (open ? ' editing' : '') + '"><div class="op-row"><span class="op-ic">' + (OPENING_ICON[o.type] || ICON.door) + '</span>' +
      '<span class="op-main"><b>' + esc(G.openingName(o).replace(/^./, c => c.toUpperCase())) + '</b><span>' + inches(o.w) + ' by ' + inches(o.h) + ', ' + inches(o.x) + ' from the left</span></span>' +
      '<button type="button" class="ghost sm" data-edit-opening="' + i + '" aria-expanded="' + open + '">' + (open ? 'Done' : 'Edit') + '</button>' +
      '<button type="button" class="iconbtn" data-remove-opening="' + i + '" aria-label="Remove ' + esc(G.openingName(o)) + '">' + ICON.close + '</button></div>';
    if (open && o.type === 'outlet') h += '<div class="op-edit gang"><div class="field"><span class="label">Box</span>' + '<div class="chips" role="group" aria-label="Box size">' + [['Single gang', 2.25], ['Double gang', 4.5]].map(([l, v]) => '<button type="button" class="chip" data-gang="' + i + '" data-gang-size="' + v + '" aria-pressed="' + (Math.abs(o.w - v) < 0.1) + '">' + l + '</button>').join('') + '</div>' + '</div></div>';
    if (open) h += '<div class="op-edit">' + lenField('Width', p + '.w', 1, true) + lenField('Height', p + '.h', 1, true) +
      lenField('From the left corner', p + '.x', 2, true) + lenField('From the floor', p + '.y', 2, true) + '</div>';
    h += '</li>';
  });
  if (!w.openings.length) h += '<li class="empty">Nothing on the ' + surfaceName(ui.wall) + ' yet.</li>';
  h += '</ul><div class="addrow" role="group" aria-label="Add to this wall">' + ADD_ORDER.map(([t, l]) =>
    '<button type="button" class="add" data-add-opening="' + t + '">' + OPENING_ICON[t] + '<span>' + esc(l) + '</span></button>').join('') + '</div></div>';
  return h + stairHTML();
}
function stairHTML() {
  if (isCeil(ui.wall)) return '';
  const w = curWall(), sl = w.slope, p = 'walls.' + ui.wall + '.slope';
  let h = '<div class="group"><h3>Stair</h3>' + switchBtn('data-stair="bottom"', sl && sl.bottom, 'The panel field follows a stair');
  if (sl && sl.bottom) {
    h += '<p class="lead">Where the stair line meets each end of the ' + surfaceName(ui.wall) + ', measured up from the floor.</p><div class="pair">' +
      lenField('At the left end', p + '.bottom.0', 3, true) + lenField('At the right end', p + '.bottom.1', 3, true) + '</div>';
    h += switchBtn('data-stair="top"', sl.top, 'Slope the top of the field too');
    if (sl.top) h += '<div class="pair">' + lenField('Top, left end', p + '.top.0', 3, true) + lenField('Top, right end', p + '.top.1', 3, true) + '</div>';
  }
  return h + '</div>';
}
function layoutTiles() {
  const w = curWall(), mode = layoutMode(w);
  if (isCeil(ui.wall)) return '';
  let h = '<div class="group"><h3>Layout</h3><div class="tiles three">' +
    '<button type="button" class="tile" data-layout="full" aria-pressed="' + (mode === 'full') + '">' + thumbSVG('full') + '<span>Full wall</span></button>' +
    '<button type="button" class="tile" data-layout="wainscot" aria-pressed="' + (mode === 'wainscot') + '">' + thumbSVG('wainscot') + '<span>Wainscot</span></button>' +
    '<button type="button" class="tile" data-layout="feature" aria-pressed="' + (mode === 'feature') + '">' + thumbSVG('feature') + '<span>Feature with sides</span></button></div>';
  if (mode === 'wainscot') {
    h += rangeField('Lower section height', 'split', 18, Math.max(24, Math.round(state.room.H - 24)), 1, Math.round(w.split), inches(w.split)) +
      chips(St.WAINSCOT_CHIPS, w.split, 'data-split-chip', 'Lower section height') + zoneSeg();
  }
  return h + '</div>';
}
function patternPicker() {
  const w = curWall(), d = curDesign();
  const sug = St.suggested(state), kind = St.PRESET_LIST.find(p => p[0] === state.room.kind);
  const groups = [['suggested', 'Suggested', sug]].concat(St.PATTERN_GROUPS.map(g => [g[0], g[1], g[2]]));
  const g = groups.find(x => x[0] === ui.patGroup) || groups[0];
  let h = '<div class="group"><h3>Pattern' + (w.wainscot && !w.comp ? ', ' + (curZone() ? 'upper' : 'lower') + ' section' : w.comp ? ', feature field' : '') + '</h3>' +
    '<div class="chips patgroups" role="group" aria-label="Pattern family">' + groups.map(x => '<button type="button" class="chip" data-patgroup="' + x[0] + '" aria-pressed="' + (x[0] === g[0]) + '">' + esc(x[1]) + '</button>').join('') + '</div>';
  if (g[0] === 'suggested' && kind) h += '<p class="lead sm">Suggested for a ' + esc(kind[1].toLowerCase()) + '.</p>';
  h += '<div class="tiles">';
  const list = g[2].slice();
  if (g[0] === 'suggested' && !list.includes(d.type) && d.type !== 'none') list.unshift(d.type);
  list.forEach(t => {
    const custom = t === 'custom';
    h += '<button type="button" class="tile" data-pattern="' + t + '" aria-pressed="' + (d.type === t) + '">' + thumbSVG(t, custom ? { custom: d.custom } : null) + '<span>' + esc(custom && d.custom ? d.custom.name : St.PATTERN_WORDS[t]) + '</span></button>';
  });
  h += '</div><button type="button" class="ghost block assist-only assist-prompt" data-assist-prompt="1"' + (chat.mode === 'off' ? ' hidden' : '') + '>' + ICON.spark + '<span>Describe something we don\'t show</span></button>';
  return h + '</div>';
}
function sizeBlock() {
  const d = curDesign(), m = St.SIZE_MODELS[d.type];
  if (!m) return '';
  const info = curInfo(), v = St.getSize(d, info), id = 'f' + (++uid);
  const L = layouts[ui.wall], n = L ? L.pieces.filter(p => p.zone === curZone()).length : 0;
  let h = '<div class="group"><h3>Pattern scale</h3><div class="field"><label for="' + id + '" class="label">' + m.label + ' <output class="val" id="sizeVal">' + inches(v) + '</output></label>' +
    '<input id="' + id + '" class="range" type="range" min="' + m.min + '" max="' + m.max + '" step="0.25" value="' + v + '" data-size="1" list="snap-' + id + '"><datalist id="snap-' + id + '">' + m.chips.map(c => '<option value="' + c[1] + '"></option>').join('') + '</datalist></div>' +
    chips(m.chips, v, 'data-size-chip', m.label);
  const sh = St.SHAPE_MODELS[d.type];
  if (sh) h += '<div class="field"><span class="label">' + sh.label + '</span>' + chips(sh.chips, St.getShape(d, info), 'data-shape-chip', sh.label) + '</div>';
  const cm = St.COUNT_MODELS[d.type];
  if (cm) h += '<div class="field"><span class="label">' + cm.label + '</span>' + chips(cm.chips, d.count, 'data-count-chip', cm.label) + '</div>';
  h += '<p class="readout" id="sizeReadout">' + esc(St.describeLayout(d, info, n)) + '</p>';
  if (d.type === 'custom') { const v = G.validateCustom(d.custom, { moduleW: d.moduleW, moduleH: d.moduleH, minPiece: state.minPiece }); if (!v.ok) h += '<p class="readout warn">' + esc(v.errors[0]) + '</p>'; }
  return h + '</div>';
}
const SECTION_LIST = G.SECTION_TYPES;
function sectionsHTML() {
  if (isCeil(ui.wall)) return '';
  const w = curWall(), c = w.comp;
  const sum = c ? (St.SECTION_WORDS[c.left] || '') + (c.link ? ' either side' : ', ' + (St.SECTION_WORDS[c.right] || '')) : 'Add mirror, slats, fluting or plain panels beside the pattern';
  let body;
  if (!c) body = '<p class="lead">Make the pattern a feature field and fill the rest of the wall with sections: mirror, wood slats, fluted or plain upholstery, stone, or painted wall.</p><button type="button" class="ghost block" data-layout="feature">' + ICON.sections + '<span>Add sections beside the pattern</span></button>';
  else {
    const L = layouts[ui.wall], F = L && L.feature, Uw = surfW(ui.wall) - 2 * VIEW_SPACING.edge.corner, p = 'walls.' + ui.wall + '.comp';
    const fw = F ? F.x1 - F.x0 : c.width;
    body = rangeField('Feature width', 'cw', 24, Math.round(Uw), 1, Math.round(Math.min(c.width, Uw)), inches(fw)) +
      rangeField('Feature offset', 'co', -Math.round(Uw / 2), Math.round(Uw / 2), 1, Math.round(c.offset), (c.offset ? (c.offset > 0 ? inches(c.offset) + ' right' : inches(-c.offset) + ' left') : 'centred')) +
      rangeField('Feature height', 'ch', 36, Math.round(surfH(ui.wall)), 1, c.height > 0 ? Math.round(c.height) : Math.round(surfH(ui.wall)), c.height > 0 ? inches(c.height) : 'full height') +
      '<div class="field"><span class="label">Sides</span><div class="secpick">' + sectionPicker('left', c.left, c.link ? 'Both sides' : 'Left side') +
      (c.link ? '' : sectionPicker('right', c.right, 'Right side')) + '</div>' + switchBtn('data-link="1"', c.link, 'The same on both sides') + '</div>';
    if (c.height > 0) body += '<div class="field"><span class="label">Band above</span><div class="secpick">' + sectionPicker('top', c.top, 'Above') + '</div></div>';
    body += rangeField('Band below', 'cb', 0, 60, 1, Math.round(c.bottomH), c.bottomH > 0 ? inches(c.bottomH) : 'none');
    if (c.bottomH > 0) body += '<div class="secpick">' + sectionPicker('bottom', c.bottom, 'Below') + '</div>';
    const used = [c.left, c.link ? c.left : c.right, c.height > 0 ? c.top : '', c.bottomH > 0 ? c.bottom : ''];
    if (used.includes('slats')) body += fieldSeg('Wood', p + '.wood', G.WOODS) + '<div class="pair">' + lenField('Slat width', p + '.slatW', 0.25, true) + lenField('Gap', p + '.slatGap', 0.25, true) + '</div>';
    if (used.includes('fluted')) body += lenField('Flute width', p + '.flute', 0.5, true);
    body += '<button type="button" class="linkbtn" data-layout="full">Remove the sections</button>';
  }
  return disclosure('sections', ICON.sections, 'Sections', sum, body);
}
function pillarsHTML() {
  if (isCeil(ui.wall)) return '';
  const w = curWall(), pl = w.pillars, p = 'walls.' + ui.wall + '.pillars';
  const sum = pl ? pl.n + ' pillars, ' + (G.PILLAR_FINISHES.find(f => f[0] === pl.finish) || [0, ''])[1].toLowerCase() : 'Columns that break the wall into bays';
  let body = switchBtn('data-pillars="1"', !!pl, 'Pillars on this wall');
  if (pl) {
    body += '<div class="field"><span class="label">How many</span>' + chips([['Two', 2], ['Three', 3], ['Four', 4], ['Five', 5], ['Six', 6]], pl.n, 'data-pillar-n', 'How many pillars') + '</div>' +
      '<div class="pair">' + lenField('Width', p + '.width', 1, true) + lenField('Depth', p + '.depth', 0.5, true) + '</div>' +
      fieldSeg('Finish', p + '.finish', G.PILLAR_FINISHES.map(f => [f[0], f[1].replace(' or stone look', '')])) +
      switchBtn('data-pillarflag="sconce"', pl.sconce, 'A glass sconce on each pillar') + switchBtn('data-pillarflag="graze"', pl.graze, 'LED grazing light up each pillar') +
      (ui.wall === 'left' || ui.wall === 'right' ? '<button type="button" class="ghost block" id="pillarsBoth">Same pillars on both side walls</button>' : '');
  }
  return disclosure('pillars', '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="3.5" width="4" height="17"/><rect x="15" y="3.5" width="4" height="17"/><path d="M3 20.5h18M3 3.5h18"/></svg>', 'Pillars', sum, body);
}
function sectionPicker(side, cur, label) {
  return '<div class="field"><label class="label" for="sec-' + side + '">' + esc(label) + '</label><div class="selectwrap"><select id="sec-' + side + '" data-section="' + side + '">' +
    SECTION_LIST.map(([k, l]) => '<option value="' + k + '"' + (k === cur ? ' selected' : '') + '>' + esc(l) + '</option>').join('') + '</select>' + ICON.chev + '</div></div>';
}
function lightingHTML() {
  const w = curWall(), d = curDesign(), zp = 'walls.' + ui.wall + '.zones.' + curZone(), wp = 'walls.' + ui.wall;
  const bits = [];
  if (d.led && d.led !== 'none') bits.push('LED ' + (G.LED_TYPES.find(x => x[0] === d.led) || [0, ''])[1].toLowerCase());
  if (w.cove && w.cove !== 'none') bits.push('cove');
  if (w.sconces) bits.push(w.sconces.n + ' sconce' + (w.sconces.n > 1 ? 's' : ''));
  let body = '';
  if (d.type !== 'none') {
    body += fieldSeg('Backlit LED', zp + '.led', G.LED_TYPES);
    if (d.led && d.led !== 'none') body += fieldSeg('Colour', zp + '.ledTemp', G.LED_TEMPS) + rangeField('Brightness', 'lv', 10, 100, 5, Math.round((d.ledLevel || 0.7) * 100), Math.round((d.ledLevel || 0.7) * 100) + '%');
  }
  if (!isCeil(ui.wall)) {
    body += fieldSeg('Cove light', wp + '.cove', G.COVE_TYPES);
    body += '<div class="field">' + switchBtn('data-sconces="1"', !!w.sconces, 'Wall sconces') + '</div>';
    if (w.sconces) {
      const sp = wp + '.sconces';
      body += '<div class="field"><span class="label">How many</span>' + chips([['One', 1], ['Two', 2], ['Three', 3], ['Four', 4], ['Six', 6]], w.sconces.n, 'data-sconce-n', 'How many sconces') + '</div>' +
        fieldSeg('Style', sp + '.style', G.SCONCE_STYLES) + fieldSeg('Finish', sp + '.finish', G.METALS) + fieldSeg('Placement', sp + '.place', G.SCONCE_PLACES) +
        lenField('Height to the centre', sp + '.y', 2, true);
      if (w.sconces.place === 'custom') {
        body += '<div class="pair">';
        for (let i = 0; i < w.sconces.n; i++) { if (!isFinite(+w.sconces.xs[i])) w.sconces.xs[i] = Math.round(surfW(ui.wall) * (i + 1) / (w.sconces.n + 1)); body += lenField('Sconce ' + (i + 1) + ' from the left', sp + '.xs.' + i, 2, true); }
        body += '</div>';
      }
    }
  }
  return disclosure('lighting', ICON.bulb, 'Lighting', bits.length ? bits.join(', ') : 'LED, cove light and sconces', body || '<p class="lead">Choose a pattern first.</p>');
}
function trimHTML() {
  const d = curDesign(), zp = 'walls.' + ui.wall + '.zones.' + curZone();
  if (d.type === 'none') return '';
  let h = '<div class="group"><h3>Metal inlay</h3>' + seg(zp + '.inlay', G.INLAY_TYPES, 'Metal inlay');
  if (d.inlay !== 'none' || d.led === 'lines' || d.led === 'both') h += '<div class="field"><span class="label">Where the inlay and reveal light run</span>' + seg(zp + '.lineScope', G.LINE_SCOPES, 'Where') + '</div>';
  if (G.MIRROR_TYPES.includes(d.type)) h += switchBtn('data-mirror="1"', d.mirror, d.type === 'ashlar' ? 'A mirror band across the wall' : 'Mirror in the open spaces');
  return h + '</div>';
}
function starsHTML() {
  const d = curDesign();
  if (d.type === 'none' || (!isCeil(ui.wall) && !(d.stars > 0))) return '';
  return '<div class="group"><h3>Fibre-optic stars</h3><p class="lead">Small points of light through the panels, for a starlight ceiling.</p>' + chips(St.STAR_CHIPS, d.stars || 0, 'data-stars', 'Star density') + '</div>';
}
function moodHTML() { return '<div class="group"><h3>Lighting mood</h3>' + seg('light', [['day', 'Day'], ['theater', 'Theater']], 'Lighting mood') + '</div>'; }
function surfaceHTML() {
  const d = curDesign();
  if (d.type === 'none') return '';
  return '<div class="group"><h3>Sewn surface</h3>' + seg('walls.' + ui.wall + '.zones.' + curZone() + '.surface', G.SURFACE_TYPES, 'Sewn surface') + '</div>';
}
function designHeadHTML() {
  return '<div class="group"><h3>Designing the ' + surfaceName(ui.wall) + '</h3>' + wallChips(true) +
    '<button type="button" class="linkbtn" id="copyDesign">Use this design on every wall</button></div>';
}

function fabricHTML() {
  const k = ui.wall, d = curDesign(), z = curZone(), p = 'walls.' + k + '.zones.' + z;
  let h = '<div class="group"><h3>Fabric for the ' + surfaceName(k) + '</h3>' + wallChips(true) + zoneSeg();
  if (d.type === 'none') {
    return h + '<p class="lead">This ' + (curWall().wainscot ? 'section' : 'surface') + ' is left bare. Choose a pattern first.</p>' +
      '<button type="button" class="ghost" data-goto="design">Choose a pattern</button></div>';
  }
  const accent = d.accentOn && ui.target === 'accent';
  const fam = accent ? d.accentFamily : d.family, hex = accent ? d.accentColor : d.color;
  if (d.accentOn) {
    h += '<div class="seg targets" role="group" aria-label="Which fabric">' + [['main', 'Main', d.family, d.color], ['accent', 'Accent', d.accentFamily, d.accentColor]].map(([t, l, f, c]) =>
      '<button type="button" data-target="' + t + '" aria-pressed="' + (ui.target === t) + '"><span class="dot" style="background:' + esc(c) + '"></span>' + l + '</button>').join('') + '</div>';
  }
  h += '<p class="current"><span class="dot lg" style="background:' + esc(hex) + '"></span><span>' + esc(St.fabricName(fam, hex)) + '</span></p></div>';
  St.FAMILIES.forEach(F => {
    h += '<div class="group family"><h4>' + F.label + '</h4><div class="swatches">';
    St.FABRICS.filter(f => f.family === F.key).forEach(f => {
      const on = f.family === fam && f.hex === String(hex).toUpperCase();
      h += '<button type="button" class="swatch" data-fabric="' + f.family + '|' + f.hex + '" aria-pressed="' + on + '" aria-label="' + esc(F.label + ', ' + f.name) + '">' +
        '<span class="chipcolor fam-' + f.family + '" style="background-color:' + f.hex + '"></span><span class="nm">' + f.name + '</span></button>';
    });
    h += '</div></div>';
  });
  const cp = p + (accent ? '.accentColor' : '.color');
  h += '<div class="group"><details class="disclose"><summary>Exact colour</summary><div class="colorrow"><input type="color" data-bind="' + cp + '" data-kind="color" value="' + esc(hex) + '" aria-label="Pick an exact colour">' +
    '<input type="text" data-bind="' + cp + '" data-kind="hex" value="' + esc(String(hex).toUpperCase()) + '" aria-label="Colour code" maxlength="7" spellcheck="false"></div></details></div>';
  h += '<div class="group"><h3>Accent</h3>' + switchBtn('data-accent="1"', d.accentOn, 'A second fabric on some panels');
  if (d.accentOn) h += seg(p + '.accentMode', [['alternate', 'Alternating'], ['center', 'Centre']], 'Where the accent goes');
  h += '</div>' + surfaceHTML();
  return h;
}
function drawingHTML() {
  const L = layouts[ui.wall], n = L ? L.pieces.length : 0;
  return '<div class="group"><h3>Flat drawing</h3>' + wallChips(true) +
    '<p class="lead">The ' + surfaceName(ui.wall) + ' seen straight on, with its overall size, every opening and the panel layout. ' + n + ' panel' + (n === 1 ? '' : 's') + '.</p>' +
    '<div class="btnrow"><button type="button" class="ghost" id="saveDrawingBtn">' + ICON.image + '<span>Save the drawing</span></button></div>' +
    '<ul class="warnings" aria-live="polite"></ul></div>';
}
function sendHTML() {
  const lines = St.summaryLines(state);
  let h = '<div class="group summary"><h3>Your soft wall</h3><dl>';
  h += '<div><dt>Room</dt><dd>' + esc(lines[0].replace(/^Room: /, '')) + '</dd></div>';
  lines.slice(1).forEach(l => { const m = /^(\w+)(?: wall)?: (.*)$/.exec(l); if (m) h += '<div><dt>' + esc(m[1]) + '</dt><dd>' + esc(m[2]) + '</dd></div>'; });
  h += '</dl></div>';
  h += '<div class="group sendto"><h3>Send us this design</h3><p class="lead">Your email opens with a link to this design and the summary filled in. Add your name and number, then send it when you are ready. Nothing leaves this page until you do.</p>' +
    '<a class="primary block" id="mailLink" href="' + esc(St.mailtoHref(state, shareLink())) + '">' + ICON.mail + '<span>Email us this design</span></a>' +
    '<div class="btnrow"><button type="button" class="ghost" id="copyLink">' + ICON.copy + '<span>Copy link</span></button>' +
    '<button type="button" class="ghost" id="saveImage">' + ICON.image + '<span>Save image</span></button></div>' +
    '<p class="fineprint">A planning picture. We measure every room on site and confirm each panel before anything is built.</p></div>' +
    '<div class="group"><button type="button" class="linkbtn" id="sendReset">Start over with a new room</button></div>';
  return h;
}

function renderRoom() {
  $('#paneRoom').innerHTML = roomHTML() + (SHELL === 'C' ? '' : openingsHTML());
  if (ui.roomMenu) { const sel = $('#ro-' + (state.room.kind || 'media')) || $('.roomsel-opt'); if (sel) { sel.focus({ preventScroll: true }); sel.scrollIntoView({ block: 'nearest' }); } }
}
function renderOpenings() { const p = $('#paneOpenings'); if (p) p.innerHTML = SHELL === 'C' ? openingsHTML() : ''; }
function renderDesign() {
  let h = designHeadHTML() + layoutTiles() + patternPicker() + sizeBlock() + sectionsHTML() + pillarsHTML() + lightingHTML();
  if (SHELL !== 'C' && !isCeil(ui.wall)) h += disclosure('headboard', '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20V9a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v11M4 15h16M8 7v8M12 7v8M16 7v8"/></svg>', 'Headboard', curWall().headboard ? 'On, behind the bed' : 'A limited-height piece behind the bed', headboardHTML());
  if (SHELL !== 'C') h += trimHTML();
  h += '<div class="group flat"><details class="disclose"><summary>Flat drawing of this ' + (isCeil(ui.wall) ? 'ceiling' : 'wall') + '</summary><div class="elev-head"><span class="mono dim" id="elevSize"></span></div><div class="elev-svg"></div></details><ul class="warnings" aria-live="polite"></ul></div>';
  $('#paneDesign').innerHTML = h;
}
function renderFabric() { $('#paneFabric').innerHTML = fabricHTML() + (SHELL === 'C' ? '' : starsHTML()); }
function renderFinish() {
  const p = $('#paneFinish'); if (!p) return;
  if (SHELL !== 'C') { p.innerHTML = ''; return; }
  const d = curDesign();
  p.innerHTML = '<div class="group"><h3>Finishes for the ' + surfaceName(ui.wall) + '</h3>' + wallChips(true) + zoneSeg() + '</div>' +
    (d.type === 'none' ? '<div class="group"><p class="lead">Choose a pattern first.</p><button type="button" class="ghost" data-goto="design">Choose a pattern</button></div>' : trimHTML() + starsHTML()) + moodHTML();
}
const HB_STYLES = [['vchannel', 'Vertical channels'], ['hchannel', 'Horizontal channels'], ['plain', 'Plain panel'], ['tufted', 'Diamond tufted'], ['framed', 'Framed bevel']];
function headboardStyle(d) {
  if (d.type === 'channels') return 'vchannel';
  if (d.type === 'bands') return 'hchannel';
  if (d.type === 'grid') return d.surface === 'quilted' ? 'tufted' : 'plain';
  if (d.type === 'framed') return 'framed';
  return '';
}
function headboardHTML() {
  if (isCeil(ui.wall)) return '<div class="group"><h3>Headboard</h3>' + wallChips(false) + '<p class="lead">A headboard goes on a wall. Choose the wall behind the bed.</p></div>';
  const w = curWall(), hb = w.headboard, p = 'walls.' + ui.wall + '.headboard';
  let h = '<div class="group"><h3>Headboard on the ' + surfaceName(ui.wall) + '</h3>' + wallChips(false) +
    '<p class="lead">An upholstered piece behind the bed, not the whole wall. The wall above stays painted unless you choose otherwise.</p>' + switchBtn('data-hb="1"', !!hb, 'A headboard on this wall') + '</div>';
  if (!hb) return h;
  const st = headboardStyle(w.zones[0]);
  h += '<div class="group"><h3>Bed size</h3>' + chips(G.BED_SIZES.map((b, i) => [b[1], i]), G.BED_SIZES.findIndex(b => b[0] === hb.bed), 'data-bed', 'Bed size') + '</div>' +
    '<div class="group"><h3>Wings</h3>' + seg(p + '.wings', G.WING_TYPES, 'Wings') + (hb.wings === 'width' ? lenField('Each wing', p + '.wingW', 2, true) : '') +
    rangeField('Height', 'hbh', 36, Math.min(96, Math.round(state.room.H - 6)), 1, Math.round(hb.height), inches(hb.height)) + '</div>' +
    '<div class="group"><h3>Style</h3><div class="chips" role="group" aria-label="Headboard style">' + HB_STYLES.map(([k, l]) => '<button type="button" class="chip" data-hbstyle="' + k + '" aria-pressed="' + (st === k) + '">' + esc(l) + '</button>').join('') +
    '<button type="button" class="chip" data-goto="design" aria-pressed="' + (!st) + '">Any pattern</button></div></div>' +
    '<div class="group"><h3>Edge trim</h3>' + seg(p + '.trim', G.INLAY_TYPES, 'Edge trim') + switchBtn('data-hbbase="1"', hb.base, 'A matching upholstered bed base') +
    '<div class="field"><label class="label" for="hb-above">The wall above</label><div class="selectwrap"><select id="hb-above" data-hbabove="1">' +
    [['paint', 'Painted wall']].concat(G.SECTION_TYPES.filter(t => t[0] !== 'pattern' && t[0] !== 'paint')).map(([k, l]) => '<option value="' + k + '"' + (hb.above === k ? ' selected' : '') + '>' + esc(l) + '</option>').join('') +
    '</select>' + ICON.chev + '</div></div></div>';
  return h;
}
function renderHeadboard() { const p = $('#paneHeadboard'); if (p) p.innerHTML = SHELL === 'C' ? headboardHTML() : ''; }
function renderDrawing() { const p = $('#paneDrawing'); if (p) p.innerHTML = SHELL === 'C' ? drawingHTML() : ''; }
function renderSend() { $('#paneSend').innerHTML = sendHTML(); }

// ------------------------------------------------------------ steps and chrome

function renderSteps() {
  $$('.step').forEach(t => { const on = t.dataset.step === ui.step; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; });
  $$('.pane').forEach(p => p.classList.toggle('on', p.dataset.pane === ui.step));
  $$('[data-wall]').forEach(b => {
    const on = ui.view === 'wall' && b.dataset.wall === ui.wall;
    if (b.getAttribute('role') === 'tab') b.setAttribute('aria-selected', String(on)); else b.setAttribute('aria-pressed', String(b.dataset.wall === ui.wall));
  });
  const vr = $('#viewRoom'); if (vr) vr.setAttribute('aria-pressed', String(ui.view === 'room' && ui.mode === '3d'));
  const vc = $('#viewCeiling'); if (vc) vc.setAttribute('aria-pressed', String(ui.view === 'wall' && isCeil(ui.wall) && ui.mode === '3d'));
  $$('[data-mode]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.mode === ui.mode && !(ui.mode === '3d' && (ui.view === 'room' || isCeil(ui.wall))))));
  const lab = $('#wnLabel'); if (lab) lab.textContent = ui.view === 'room' ? 'Whole room' : (isCeil(ui.wall) ? 'Ceiling' : wallLabel(ui.wall) + ' wall');
  const ev = $('#elevView'); if (ev) ev.hidden = ui.mode !== 'wall';
  document.body.classList.toggle('mode-wall', ui.mode === 'wall');
  const sn = $('#snap');
  if (sn) {
    const dr = ui.mode === 'wall', lbl = dr ? 'Save the wall drawing' : 'Render a photo of this view';
    $('span', sn).textContent = dr ? 'Save drawing' : 'Photo';
    sn.setAttribute('aria-label', lbl); sn.title = lbl;
    if (dr && PHOTO && PHOTO.on) photoClose();
  }
  $$('[data-light]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.light === state.light)));
  const ft = $('#flyTitle'); if (ft) ft.textContent = STEP_TITLES[ui.step] || '';
  const i = STEPS.indexOf(ui.step);
  const back = $('#stepBack'), next = $('#stepNext');
  back.hidden = i <= 0;
  if (i < 0 || i === STEPS.length - 1) next.hidden = true;
  else {
    next.hidden = false;
    next.textContent = SHELL === 'C' ? NEXT_WORDS[ui.step] : NEXT_AB[i];
    const last = i === STEPS.length - 2;
    next.classList.toggle('primary', last); next.classList.toggle('ghost', !last);
  }
  $('#studio').classList.toggle('closed', !ui.open);
  document.body.classList.toggle('fly-open', !!ui.open);
  const grip = $('#grip'); if (grip) grip.setAttribute('aria-expanded', String(ui.open));
  renderUtility();
}
function renderUtility() {
  const u = $('#utilUndo'), r = $('#utilRedo');
  if (u) u.disabled = !hist.undo.length;
  if (r) r.disabled = !hist.redo.length;
  const d = $('#utilDims'); if (d) d.setAttribute('aria-pressed', String(ui.dims));
  const l = $('#utilLight'); if (l) { l.setAttribute('aria-pressed', String(state.light === 'theater')); const t = $('.ut-t', l); if (t) t.textContent = state.light === 'theater' ? 'Theater light' : 'Day light'; }
}
function renderForms() {
  renderRoom(); renderOpenings(); renderHeadboard(); renderDesign(); renderFabric(); renderFinish(); renderDrawing(); renderSend();
  
  renderSteps();
}

// ------------------------------------------------------------ elevation drawing

const INK = LIGHT
  ? { ground: '#F4F2EE', wall: '#ECE9E3', wallLine: '#A39E95', hole: '#D8D4CC', holeLine: '#6F6A63', text: '#1A1917', text2: '#4A463F', text3: '#6F6A63', seam: 'rgba(0,0,0,.28)' }
  : { ground: '#0B0B0B', wall: '#141414', wallLine: '#6F6A63', hole: '#050505', holeLine: '#A9A39A', text: '#F2EFEA', text2: '#ADA69C', text3: '#8C867D', seam: 'rgba(0,0,0,.5)' };
const METAL_HEX = { gold: '#C9A86A', brass: '#C9A86A', black: '#1C1C1C', chrome: '#C9CED4' };
const WOOD_HEX = { oak: '#B08A5E', walnut: '#5C4030' };
const LED_HEX = { warm: '#FFC98F', neutral: '#FFF1DC', cool: '#D6E6FF' };

function elevationSVG(k, opt) {
  opt = opt || {};
  const L = layouts[k], W = L.W, H = L.H, u = Math.max(W, H);
  const fs = u / 36, pad = opt.dims ? fs * 4 : fs;
  const P = (poly) => 'M' + poly.map(v => v[0].toFixed(2) + ' ' + (H - v[1]).toFixed(2)).join('L') + 'Z';
  const Ln = (a, b) => 'M' + a[0].toFixed(2) + ' ' + (H - a[1]).toFixed(2) + 'L' + b[0].toFixed(2) + ' ' + (H - b[1]).toFixed(2);
  const sw = u / 400;
  let s = '<svg viewBox="' + (-pad).toFixed(2) + ' ' + (-pad * (opt.dims ? 0.5 : 1)).toFixed(2) + ' ' + (W + pad * (opt.dims ? 1.5 : 2)).toFixed(2) + ' ' + (H + pad * (opt.dims ? 1.5 : 2)).toFixed(2) +
    '" role="img" aria-label="' + esc(isCeil(k) ? 'Ceiling' : wallLabel(k) + ' wall') + ' drawing, ' + esc(G.fmtFtIn(W)) + (isCeil(k) ? ' by ' : ' wide and ') + esc(G.fmtFtIn(H)) + (isCeil(k) ? '' : ' high') + '" font-family="IBM Plex Mono, monospace">';
  s += '<defs><linearGradient id="mir' + k + '" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#C9CED4"/><stop offset=".55" stop-color="#7D848C"/><stop offset="1" stop-color="#AEB4BA"/></linearGradient></defs>';
  s += '<rect x="0" y="0" width="' + W + '" height="' + H + '" fill="' + INK.wall + '" stroke="' + INK.wallLine + '" stroke-width="' + sw * 1.5 + '"/>';
  for (const a of L.areas || []) s += '<path d="' + P(a.poly) + '" fill="' + (a.type === 'marble' ? (LIGHT ? '#E9E6E1' : '#3A3936') : 'none') + '" stroke="' + INK.wallLine + '" stroke-width="' + sw + '" stroke-dasharray="' + sw * 4 + ' ' + sw * 3 + '"/>';
  for (const pp of L.pillars || []) s += '<rect x="' + pp.x0 + '" y="' + (H - pp.y1) + '" width="' + (pp.x1 - pp.x0) + '" height="' + (pp.y1 - pp.y0) + '" fill="' + (pp.finish === 'marble' ? (LIGHT ? '#E4E1DC' : '#4A4845') : pp.finish === 'wood' ? '#B08A5E' : INK.wall) + '" stroke="' + INK.holeLine + '" stroke-width="' + sw + '"/>';
  for (const p of L.pieces) s += '<path d="' + P(p.poly) + p.holes.map(P).join('') + '" fill="' + esc(p.color) + '" fill-rule="evenodd" stroke="' + INK.seam + '" stroke-width="' + sw + '"/>';
  for (const p of L.inserts || []) s += '<path d="' + P(p.poly) + p.holes.map(P).join('') + '" fill="url(#mir' + k + ')" fill-rule="evenodd" stroke="' + INK.seam + '" stroke-width="' + sw + '"/>';
  const wood = WOOD_HEX[(state.walls[k].comp && state.walls[k].comp.wood) || 'oak'];
  for (const p of L.slats || []) s += '<path d="' + P(p.poly) + '" fill="' + wood + '"/>';
  L.zones.forEach(z => {
    const d = z.design;
    if (!d || d.type === 'none') return;
    if (d.inlay && d.inlay !== 'none') for (const sg of G.trimLines(z)) s += '<path d="' + Ln(sg[0], sg[1]) + '" stroke="' + METAL_HEX[d.inlay] + '" stroke-width="' + sw * 2.2 + '" stroke-linecap="round"/>';
    const led = LED_HEX[d.ledTemp || 'warm'];
    if (d.led === 'lines' || d.led === 'both') for (const sg of G.trimLines(z)) s += '<path d="' + Ln(sg[0], sg[1]) + '" stroke="' + led + '" stroke-opacity=".9" stroke-width="' + sw * 1.4 + '"/>';
    if (d.led === 'edge' || d.led === 'both') for (const sg of z.edgeLines || []) s += '<path d="' + Ln(sg[0], sg[1]) + '" stroke="' + led + '" stroke-opacity=".75" stroke-width="' + sw * 3 + '"/>';
  });
  for (const c of L.cove || []) s += '<path d="' + Ln(c.seg[0], c.seg[1]) + '" stroke="#FFC98F" stroke-width="' + sw * 3 + '"/>';
  for (const st of G.starPoints(L, G.starSeed(k))) s += '<circle cx="' + st.x.toFixed(1) + '" cy="' + (H - st.y).toFixed(1) + '" r="' + (sw * 1.3).toFixed(2) + '" fill="#FFF6E0"/>';
  for (const o of L.openings) {
    const r = o.raw, x = r.x0, y = H - r.y1, w = r.x1 - r.x0, h = r.y1 - r.y0;
    if (o.type === 'riser') { s += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="' + (LIGHT ? '#CFC6BA' : '#2E2925') + '" stroke="' + INK.holeLine + '" stroke-width="' + sw + '"/>'; continue; }
    if (o.type === 'sconce') { s += '<circle cx="' + (x + w / 2) + '" cy="' + (y + h / 2) + '" r="' + w * 0.75 + '" fill="' + METAL_HEX[(state.walls[k].sconces || {}).finish || 'brass'] + '" stroke="' + INK.holeLine + '" stroke-width="' + sw + '"/>'; continue; }
    s += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="' + INK.hole + '" stroke="' + INK.holeLine + '" stroke-width="' + sw * 1.4 + '" stroke-dasharray="' + sw * 6 + ' ' + sw * 4 + '"/>';
    if (opt.dims && o.type !== 'outlet' && w > fs * 4 && h > fs * 3) {
      s += '<text x="' + (x + w / 2) + '" y="' + (y + h / 2 - fs * 0.3) + '" font-size="' + fs * 0.9 + '" fill="' + INK.text + '" text-anchor="middle">' + esc(G.openingName(o).replace(/^./, c => c.toUpperCase())) + '</text>';
      s += '<text x="' + (x + w / 2) + '" y="' + (y + h / 2 + fs * 1.0) + '" font-size="' + fs * 0.75 + '" fill="' + INK.text2 + '" text-anchor="middle">' + esc(G.fmtFtIn(w) + ' x ' + G.fmtFtIn(h)) + '</text>';
      s += '<text x="' + (x + w / 2) + '" y="' + (y + h / 2 + fs * 2.1) + '" font-size="' + fs * 0.7 + '" fill="' + INK.text3 + '" text-anchor="middle">' + esc(G.fmtIn(r.x0) + ' from left, ' + G.fmtIn(r.y0) + ' up') + '</text>';
    }
  }
  const sl = state.walls[k].slope;
  if (sl) for (const side of ['bottom', 'top']) if (sl[side]) s += '<path d="' + Ln([0, sl[side][0]], [W, sl[side][1]]) + '" stroke="' + INK.holeLine + '" stroke-width="' + sw * 1.2 + '" stroke-dasharray="' + sw * 8 + ' ' + sw * 5 + '"/>';
  
  if (opt.dims) {
    const g = '#B49C78', t = fs * 0.5, dy = H + pad * 0.45, dx = -pad * 0.45;
    const line = (x1, y1, x2, y2) => '<path d="M' + x1 + ' ' + y1 + 'L' + x2 + ' ' + y2 + '" stroke="' + g + '" stroke-width="' + sw * 1.2 + '"/>';
    s += line(0, dy, W, dy) + line(0, dy - t, 0, dy + t) + line(W, dy - t, W, dy + t);
    s += '<text x="' + W / 2 + '" y="' + (dy + fs * 1.5) + '" font-size="' + fs + '" fill="' + INK.text + '" text-anchor="middle">' + esc(G.fmtFtIn(W)) + '</text>';
    s += line(dx, 0, dx, H) + line(dx - t, 0, dx + t, 0) + line(dx - t, H, dx + t, H);
    s += '<text transform="translate(' + (dx - fs * 0.7) + ' ' + H / 2 + ') rotate(-90)" font-size="' + fs + '" fill="' + INK.text + '" text-anchor="middle">' + esc(G.fmtFtIn(H)) + '</text>';
    for (const o of L.openings) {
      if (G.isBoxOpening(o.type) || o.type === 'riser') continue;
      const r = o.raw, yy = H - r.y1 - fs * 0.9;
      if (yy < fs) continue;
      s += line(r.x0, yy, r.x1, yy) + line(r.x0, yy - t * 0.7, r.x0, yy + t * 0.7) + line(r.x1, yy - t * 0.7, r.x1, yy + t * 0.7);
    }
  }
  return s + '</svg>';
}
function renderElevation() {
  const k = ui.wall, L = layouts[k];
  const sz = $('#elevSize'); if (sz) sz.textContent = (isCeil(k) ? 'Ceiling, ' : wallLabel(k) + ' wall, ') + G.fmtFtIn(L.W) + ' x ' + G.fmtFtIn(L.H);
  const small = elevationSVG(k, { parts: PARTS });
  $$('.elev-svg').forEach(el => { el.innerHTML = small; });
  if (ui.mode === 'wall') {
    $('#evSvg').innerHTML = elevationSVG(k, { dims: true, parts: PARTS });
    const n = L.pieces.length;
    $('#evNote').textContent = (isCeil(k) ? 'Ceiling, seen from below. ' : wallLabel(k) + ' wall, seen straight on. ') + n + ' panel' + (n === 1 ? '' : 's') + '.';
  }
  const ws = L.warnings.slice();
  
  $$('.warnings').forEach(el => { el.innerHTML = ws.map(w => '<li class="' + w.level + '">' + esc(w.text) + '</li>').join(''); });
}

// ------------------------------------------------------------ update cycle

function commit(rebuildForms, fromHistory) {
  saveState();
  computeAll();
  
  if (!fromHistory) recordHistory(); else renderUtility();
  if (rebuildForms) {
    const sc = $('#panes'), top = sc ? sc.scrollTop : 0;
    renderForms();
    if (sc) sc.scrollTop = top;
  } else {
    renderSend();
  }
  renderElevation();
  
  scheduleScene();
}
function refreshSizeReadout() {
  const d = curDesign(), info = curInfo(), L = layouts[ui.wall];
  const n = L ? L.pieces.filter(p => p.zone === curZone()).length : 0;
  const ro = $('#sizeReadout'); if (ro) ro.textContent = St.describeLayout(d, info, n);
  const sv = $('#sizeVal'); if (sv) sv.textContent = inches(St.getSize(d, info));
  $$('[data-size-chip]').forEach(b => b.setAttribute('aria-pressed', String(Math.abs(+b.dataset.sizeChip - St.getSize(d, info)) < 0.6)));
}

function readInput(el) {
  const kind = el.dataset.kind, raw = el.value;
  if (kind === 'len') { const v = G.parseLength(raw); return { ok: isFinite(v) && v >= 0, v }; }
  if (kind === 'color') return { ok: /^#[0-9a-f]{6}$/i.test(raw), v: raw.toUpperCase() };
  if (kind === 'hex') { let v = raw.trim(); if (v[0] !== '#') v = '#' + v; return { ok: /^#[0-9a-f]{6}$/i.test(v), v: v.toUpperCase() }; }
  return { ok: false };
}
function setLength(path, v, el) {
  if (/^room\.(W|L|H)$/.test(path) && v < 24) { if (el) el.classList.add('bad'); return false; }
  if (/\.(w|h)$/.test(path) && v <= 0) { if (el) el.classList.add('bad'); return false; }
  if (/\.(slatW|slatGap|flute)$/.test(path) && v <= 0) { if (el) el.classList.add('bad'); return false; }
  if (/^room\.levels\.(rise|depth)$/.test(path) && v < 4) { if (el) el.classList.add('bad'); return false; }
  if (/\.pillars\.(width|depth)$/.test(path) && v < 1) { if (el) el.classList.add('bad'); return false; }
  setPath(path, v);
  return true;
}
function onBindChange(el) {
  const r = readInput(el);
  el.classList.toggle('bad', !r.ok);
  if (!r.ok) return;
  const path = el.dataset.bind;
  if (el.dataset.kind === 'len') {
    if (!setLength(path, r.v, el)) return;
    el.value = G.fmtFtIn(r.v);
  } else setPath(path, r.v);
  commit(el.dataset.kind !== 'color');
  if (/^room\./.test(path)) refocus(false);
}

function setStep(s, keepOpen) {
  const was = ui.step;
  ui.step = s; ui.open = true; ui.roomMenu = false;
  if (s === 'drawing') { ui.mode = 'wall'; renderElevation(); }
  else if (was === 'drawing' && ui.mode === 'wall') { ui.mode = '3d'; refocus(true); }
  renderSteps();
  const sc = $('#panes'); if (sc) sc.scrollTop = 0;
  if (s === 'send') renderSend();
  if (s === 'assistant') renderAssistant();
  const tab = $('.step[data-step="' + s + '"]'); if (tab && document.activeElement && document.activeElement.closest && document.activeElement.closest('.steps')) tab.focus();
  void keepOpen;
  onChromeChange();
}
function setWall(k) {
  ui.wall = k; ui.zone = 0; ui.editOpening = -1; ui.target = 'main'; ui.view = 'wall';
  if (isCeil(k) && ui.step === 'openings') ui.step = 'design';
  renderForms(); renderElevation();
  
  focusWall(k, true);
}
function loadPreset(key) {
  state = St.PRESETS[key]();
  if (LIGHT && state.room.kind !== 'theater' && state.room.kind !== 'ceiling' && state.room.kind !== 'studio') state.room.floor = 'wood';
  const f = presetFocus(key);
  ui.wall = f === 'room' ? 'left' : f; ui.zone = 0; ui.editOpening = -1; ui.view = f === 'room' ? 'room' : 'wall'; ui.roomMenu = false; ui.patGroup = 'suggested';
  commit(true);
  if (f === 'room') viewRoom(true); else focusWall(ui.wall, true);
  toast(St.PRESET_LIST.find(p => p[0] === key)[1] + ' loaded');
}

let toastTimer = 0;
function toast(msg) {
  const t = $('#toast'); t.textContent = msg; t.classList.add('on');
  clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove('on'), 1500);
}

function onRange(el, final) {
  const a = el.dataset.range, v = +el.value, w = curWall(), d = curDesign();
  const out = $('[data-out="' + a + '"]');
  if (a === 'split') { w.split = v; if (out) out.textContent = inches(v); }
  else if (a === 'cw' && w.comp) { w.comp.width = v; if (out) out.textContent = inches(v); }
  else if (a === 'co' && w.comp) { w.comp.offset = v; if (out) out.textContent = v ? (v > 0 ? inches(v) + ' right' : inches(-v) + ' left') : 'centred'; }
  else if (a === 'ch' && w.comp) { const full = v >= surfH(ui.wall) - 1; w.comp.height = full ? 0 : v; if (out) out.textContent = full ? 'full height' : inches(v); }
  else if (a === 'cb' && w.comp) { w.comp.bottomH = v < 6 ? 0 : v; if (out) out.textContent = v < 6 ? 'none' : inches(v); }
  else if (a === 'lv') { d.ledLevel = v / 100; if (out) out.textContent = v + '%'; }
  else if (a === 'hbh' && w.headboard) { w.headboard.height = v; if (out) out.textContent = inches(v); }
  commit(!!final);
}

function bindEvents() {
  document.addEventListener('change', (e) => {
    const el = e.target;
    if (el.dataset && el.dataset.bind && el.dataset.kind !== 'color') onBindChange(el);
    if (el.dataset && el.dataset.size) commit(true);
    if (el.dataset && el.dataset.range) onRange(el, true);
    if (el.dataset && el.dataset.hbabove && curWall().headboard) { curWall().headboard.above = el.value; commit(true); return; }
    if (el.dataset && el.dataset.section) {
      const c = curWall().comp; if (!c) return;
      c[el.dataset.section] = el.value; commit(true);
    }
  });
  document.addEventListener('input', (e) => {
    const el = e.target;
    if (!el.dataset) return;
    if (el.dataset.kind === 'color') onBindChange(el);
    else if (el.dataset.size) {
      // a continuous scale that snaps to the named sizes when it passes close to one
      const m = St.SIZE_MODELS[curDesign().type]; let v = +el.value;
      if (m) for (const c of m.chips) if (Math.abs(v - c[1]) <= (m.max - m.min) * 0.025) v = c[1];
      St.setSize(curDesign(), v, curInfo()); commit(false); refreshSizeReadout();
    } else if (el.dataset.range) onRange(el, false);
  });
  document.addEventListener('keydown', (e) => {
    const el = e.target;
    if ((e.metaKey || e.ctrlKey) && (e.key === 'z' || e.key === 'Z') && !(el.tagName === 'INPUT' && el.type === 'text')) { e.preventDefault(); stepHistory(e.shiftKey ? 1 : -1); return; }
    if (e.key === 'Enter' && el.dataset && el.dataset.bind && el.tagName === 'INPUT') el.blur();
    if (ui.roomMenu && el.closest && el.closest('.roomsel')) {
      const opts = $$('.roomsel-opt'), i = opts.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); const n = opts[Math.max(0, Math.min(opts.length - 1, (i < 0 ? 0 : i + (e.key === 'ArrowDown' ? 1 : -1))))]; if (n) n.focus(); return; }
      if (e.key === 'Home' || e.key === 'End') { e.preventDefault(); (e.key === 'Home' ? opts[0] : opts[opts.length - 1]).focus(); return; }
      if ((e.key === 'Enter' || e.key === ' ') && i >= 0) { e.preventDefault(); loadPreset(opts[i].dataset.preset); const b = $('#roomSelBtn'); if (b) b.focus(); return; }
      if (e.key === 'Escape' || e.key === 'Tab') { ui.roomMenu = false; renderRoom(); const b = $('#roomSelBtn'); if (b) b.focus(); if (e.key === 'Escape') e.preventDefault(); return; }
    }
    if (e.key === 'Escape' && !$('#resetDialog').hidden) { closeResetDialog(); e.preventDefault(); return; }
    if (e.key === 'Escape' && SHELL === 'C' && ui.open && !(el.closest && el.closest('.roomsel'))) { ui.open = false; renderSteps(); onChromeChange(); const t = $('.step[aria-selected="true"]'); if (t) t.focus(); }
    if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft' || e.key === 'ArrowDown' || e.key === 'ArrowUp') && el.classList && el.classList.contains('step')) {
      const all = $$('.step').filter(b => b.offsetParent !== null), i = all.indexOf(el), fwd = e.key === 'ArrowRight' || e.key === 'ArrowDown';
      const n = all[(i + (fwd ? 1 : all.length - 1)) % all.length];
      n.focus(); setStep(n.dataset.step); e.preventDefault();
    }
  });
  document.addEventListener('click', (e) => {
    if (ui.roomMenu && !(e.target.closest && e.target.closest('.roomsel'))) { ui.roomMenu = false; renderRoom(); }
    const t = e.target.closest('button, a, li[data-preset]');
    if (!t) return;
    const ds = t.dataset;
    if (ds.step) {
      if (ui.step === ds.step && (SHELL === 'C' || (SHELL === 'A' && PHONE()))) { ui.open = !ui.open; if (!ui.open && ui.step === 'drawing') { /* keep the drawing up */ } renderSteps(); onChromeChange(); }
      else setStep(ds.step);
      return;
    }
    if (ds.goto) { setStep(ds.goto); return; }
    if (t.id === 'stepNext') { setStep(STEPS[STEPS.indexOf(ui.step) + 1]); return; }
    if (t.id === 'stepBack') { setStep(STEPS[Math.max(0, STEPS.indexOf(ui.step) - 1)]); return; }
    if (t.id === 'flyClose') { ui.open = false; renderSteps(); onChromeChange(); return; }
    if (t.id === 'grip') {
      if (PHONE() && SHELL === 'C') { if (!ui.open) ui.open = true; else document.body.classList.toggle('sheet-tall'); }
      else ui.open = !ui.open;
      renderSteps(); onChromeChange(); return;
    }
    if (t.id === 'railToggle') { document.body.classList.toggle('rail-mini'); try { localStorage.setItem('rr-rail-mini', document.body.classList.contains('rail-mini') ? '1' : '0'); } catch (er) { /* ignore */ } onChromeChange(); return; }
    if (t.id === 'roomSelBtn') { ui.roomMenu = !ui.roomMenu; renderRoom(); return; }
    if (ds.preset) { loadPreset(ds.preset); return; }
    if (ds.wall) { setWall(ds.wall); return; }
    if (t.id === 'viewCeiling') { ui.mode = '3d'; if (ui.step === 'drawing') ui.step = 'design'; setWall('ceiling'); return; }
    if (t.id === 'viewRoom') { ui.mode = '3d'; ui.view = 'room'; if (ui.step === 'drawing') ui.step = 'design'; renderSteps(); viewRoom(true); return; }
    if (ds.mode) { ui.mode = ds.mode; if (ds.mode === '3d' && ui.step === 'drawing') ui.step = 'design'; renderSteps(); renderElevation(); if (ds.mode === '3d') refocus(true); return; }
    if (ds.cycle) { const i = SURFACES.findIndex(w => w.key === ui.wall); setWall(SURFACES[(i + (+ds.cycle) + SURFACES.length) % SURFACES.length].key); return; }
    if (ds.zoom) { zoomBy(+ds.zoom > 0 ? 1.2 : 1 / 1.2); return; }
    if (ds.light) { state.light = ds.light; saveState(); recordHistory(); renderSteps(); applyLighting(); requestRender(); renderSend(); renderFinish(); return; }
    if (t.id === 'utilUndo') { stepHistory(-1); return; }
    if (t.id === 'utilRedo') { stepHistory(1); return; }
    if (t.id === 'utilLight') { state.light = state.light === 'theater' ? 'day' : 'theater'; saveState(); recordHistory(); renderSteps(); applyLighting(); requestRender(); renderSend(); renderFinish(); return; }
    if (t.id === 'utilDims') { ui.dims = !ui.dims; renderUtility(); requestRender(); return; }
    if (t.id === 'sendTop') { setStep('send'); return; }
    if (ds.zone) { ui.zone = +ds.zone; ui.target = 'main'; renderDesign(); renderFabric(); renderFinish(); renderElevation(); return; }
    if (ds.target) { ui.target = ds.target; renderFabric(); return; }
    if (ds.patgroup) { ui.patGroup = ds.patgroup; renderDesign(); renderElevation(); return; }
    if (ds.more) { ui.more[ds.more] = !ui.more[ds.more]; renderDesign(); renderElevation(); return; }
    if (ds.nudge) {
      const cur = +getPath(ds.nudge), v = Math.round((cur + +ds.by) * 16) / 16;
      if (setLength(ds.nudge, v)) { commit(true); if (/^room\./.test(ds.nudge)) refocus(false); }
      return;
    }
    if (ds.set) {
      const cur = getPath(ds.set);
      setPath(ds.set, typeof cur === 'number' ? +ds.value : ds.value); commit(true);
      if (ds.set === 'light') { applyLighting(); requestRender(); renderSteps(); }
      return;
    }
    if (ds.pattern) {
      if (ds.pattern === 'custom') return; // the assistant's pattern is already on; the picker shows it, it does not make one
      if (A.setPattern(curWall(), curZone(), ds.pattern)) commit(true);
      return;
    }
    if (ds.layout) {
      const w = curWall(), mode = ds.layout;
      if (!A.setLayout(w, mode, surfW(ui.wall), state.room.H)) return;
      if (mode === 'feature') { ui.more.sections = true; ui.zone = 0; } else ui.zone = mode === 'wainscot' ? 1 : 0;
      commit(true); return;
    }
    if (ds.link) { const c = curWall().comp; if (c) { c.link = !c.link; if (!c.link) c.right = c.left; commit(true); } return; }
    if (ds.stair) {
      const w = curWall(), H = state.room.H;
      if (ds.stair === 'bottom') w.slope = w.slope && w.slope.bottom ? null : { bottom: [Math.round(H * 0.06), Math.round(H * 0.5)], top: null };
      else if (w.slope) w.slope.top = w.slope.top ? null : [Math.min(H, w.slope.bottom[0] + 60), Math.min(H, w.slope.bottom[1] + 60)];
      commit(true); return;
    }
    if (ds.levels != null && t.closest('.seg')) { state.room.levels = ds.levels === '1' ? (state.room.levels || G.defaultLevels()) : null; commit(true); return; }
    if (ds.tiers && state.room.levels) { state.room.levels.n = +ds.tiers; commit(true); return; }
    if (ds.lvflag && state.room.levels) { state.room.levels[ds.lvflag] = !state.room.levels[ds.lvflag]; commit(true); return; }
    if (ds.hb) { const w = curWall(); if (w.headboard) w.headboard = null; else { w.headboard = G.defaultHeadboard(); w.comp = null; w.wainscot = false; if (!headboardStyle(w.zones[0])) w.zones[0] = St.design('channels', { mode: 'size', size: 5, color: w.zones[0].color, family: w.zones[0].family }); } commit(true); return; }
    if (ds.bed != null && curWall().headboard) { curWall().headboard.bed = G.BED_SIZES[+ds.bed][0]; commit(true); return; }
    if (ds.hbbase && curWall().headboard) { curWall().headboard.base = !curWall().headboard.base; commit(true); return; }
    if (ds.hbstyle) {
      const w = curWall(), old = w.zones[0], keep = { color: old.color, family: old.family, accentOn: old.accentOn, accentColor: old.accentColor, accentFamily: old.accentFamily };
      const map = { vchannel: ['channels', { mode: 'size', size: 5 }], hchannel: ['bands', { mode: 'size', size: 8 }], plain: ['grid', { mode: 'size', targetW: 46, targetH: 72 }],
        tufted: ['grid', { mode: 'size', targetW: 46, targetH: 72, surface: 'quilted' }], framed: ['framed', { moduleW: 30, moduleH: 30, count: 20 }] }[ds.hbstyle];
      w.zones[0] = St.design(map[0], Object.assign(keep, map[1])); commit(true); return;
    }
    if (ds.pillars) { const w = curWall(); w.pillars = w.pillars ? null : G.defaultPillars(); ui.more.pillars = true; commit(true); return; }
    if (ds.pillarN) { const pl = curWall().pillars; if (pl) { pl.n = +ds.pillarN; commit(true); } return; }
    if (ds.pillarflag) { const pl = curWall().pillars; if (pl) { pl[ds.pillarflag] = !pl[ds.pillarflag]; commit(true); } return; }
    if (t.id === 'pillarsBoth') { const pl = curWall().pillars; if (pl) { for (const k of ['left', 'right']) state.walls[k].pillars = JSON.parse(JSON.stringify(pl)); commit(true); toast('Both side walls have these pillars'); } return; }
    if (ds.sconces) { const w = curWall(); w.sconces = w.sconces ? null : G.defaultSconces(); commit(true); return; }
    if (ds.sconceN) { const s = curWall().sconces; if (s) { s.n = +ds.sconceN; commit(true); } return; }
    if (ds.mirror) { const d = curDesign(); d.mirror = !d.mirror; commit(true); return; }
    if (ds.stars != null && t.classList.contains('chip')) { curDesign().stars = +ds.stars; commit(true); return; }
    if (ds.sizeChip) { St.setSize(curDesign(), +ds.sizeChip, curInfo()); commit(true); return; }
    if (ds.shapeChip) { St.setShape(curDesign(), +ds.shapeChip, curInfo()); commit(true); return; }
    if (ds.countChip) { St.setCount(curDesign(), +ds.countChip); commit(true); return; }
    if (ds.splitChip) { curWall().split = +ds.splitChip; commit(true); return; }
    if (ds.fabric) {
      const [f, hex] = ds.fabric.split('|'), d = curDesign();
      if (d.accentOn && ui.target === 'accent') { d.accentFamily = f; d.accentColor = hex; } else { d.family = f; d.color = hex; }
      commit(true); return;
    }
    if (ds.accent) {
      const d = curDesign(); d.accentOn = !d.accentOn;
      if (d.accentOn && d.accentColor.toUpperCase() === d.color.toUpperCase()) { d.accentColor = '#B49C78'; d.accentFamily = 'velvet'; }
      ui.target = d.accentOn ? 'accent' : 'main'; commit(true); return;
    }
    if (ds.addOpening) {
      const k = ui.wall, W = surfW(k), H = state.room.H, type = ds.addOpening;
      const defs = { door: [Math.min(18, Math.max(0, W - 36)), 0, 36, 80], glass: [Math.min(18, Math.max(0, W - 40)), 0, 40, 84], window: [Math.max(0, (W - 48) / 2), 36, 48, 48],
        screen: [Math.max(0, (W - Math.min(110, W - 24)) / 2), Math.min(30, H / 4), Math.min(110, W - 24), Math.min(62, H / 2)], outlet: [18, 16, 2.25, 4] };
      const v = defs[type].map(x => Math.round(x * 4) / 4);
      state.walls[k].openings.push(St.opening(type, v[0], v[1], v[2], v[3]));
      ui.editOpening = state.walls[k].openings.length - 1; commit(true); return;
    }
    if (ds.gang != null && ds.gangSize) { const o = curWall().openings[+ds.gang]; if (o) { const cx = o.x + o.w / 2; o.w = +ds.gangSize; o.h = 4; o.x = Math.round((cx - o.w / 2) * 16) / 16; commit(true); } return; }
    if (ds.editOpening != null) { const i = +ds.editOpening; ui.editOpening = ui.editOpening === i ? -1 : i; renderRoom(); renderOpenings(); return; }
    if (ds.removeOpening != null) { curWall().openings.splice(+ds.removeOpening, 1); ui.editOpening = -1; commit(true); return; }
    if (t.id === 'copyDesign') {
      const src = curWall();
      WALLS.forEach(w => { if (w.key !== ui.wall) { const dst = state.walls[w.key]; dst.wainscot = src.wainscot; dst.split = src.split; dst.zoneGap = src.zoneGap; dst.zones = JSON.parse(JSON.stringify(src.zones)); dst.comp = src.comp ? JSON.parse(JSON.stringify(src.comp)) : null; } });
      commit(true); toast('Every wall now uses this design'); return;
    }
    if (t.id === 'copyLink' || t.id === 'railShare') {
      const link = shareLink();
      const ok = () => toast('Link copied');
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link).then(ok, () => fallbackCopy(link));
      else fallbackCopy(link);
      return;
    }
    if (t.id === 'saveDrawingBtn') { saveDrawing(); return; }
    if (t.id === 'railReset' || t.id === 'sendReset') { openResetDialog(t); return; }
    if (t.id === 'resetCancel') { closeResetDialog(); return; }
    if (t.id === 'resetGo') { closeResetDialog(); startOver(); return; }
    if (t.id === 'snap') { photoOpen(); return; }
    if (t.id === 'railOnWall') { onWallOpen(); return; }
    if (t.id === 'saveImage' || t.id === 'railSave') { if (ui.mode === 'wall') saveDrawing(); else saveImage(); return; }
    
  });
}
// Start over: a small in-app confirmation, then the default room; one Undo brings everything back.
let resetReturn = null;
function openResetDialog(from) {
  const d = $('#resetDialog'); if (!d) return;
  resetReturn = from; d.hidden = false; const go = $('#resetCancel'); if (go) go.focus();
}
function closeResetDialog() { const d = $('#resetDialog'); if (d) d.hidden = true; if (resetReturn && resetReturn.focus) resetReturn.focus(); resetReturn = null; }
function startOver() {
  state = St.PRESETS[LIGHT ? 'bedroom' : 'theater']();
  if (LIGHT) state.room.floor = 'wood';
  try { localStorage.removeItem(STORE_KEY); OLD_STORE_KEYS.forEach(k => localStorage.removeItem(k)); } catch (e) { /* storage unavailable */ }
  ui.wall = 'front'; ui.zone = 0; ui.editOpening = -1; ui.view = 'wall'; ui.mode = '3d'; ui.step = 'room'; ui.patGroup = 'suggested';
  hist.t = 0; freshStart = true;
  commit(true);
  try { history.replaceState(null, '', location.pathname + location.search); } catch (e) { /* sandboxed frame */ }
  focusWall('front', true);
  toast('Started over. Undo brings your design back.');
}
function fallbackCopy(text) {
  const ta = document.createElement('textarea'); ta.value = text; ta.setAttribute('readonly', '');
  ta.style.cssText = 'position:fixed;left:-9999px;top:0'; document.body.appendChild(ta); ta.select();
  let ok = false; try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
  ta.remove();
  toast(ok ? 'Link copied' : 'Copy the link from the address bar');
}

// The phone sheet: a short peek by default so the wall stays in view; drag the grip to open it further.
function bindSheet() {
  const grip = $('#grip'), studio = $('#studio');
  if (!grip || !studio) return;
  let y0 = 0, h0 = 0, dragging = false, moved = false;
  grip.addEventListener('pointerdown', (e) => {
    if (!PHONE()) return;
    dragging = true; moved = false; y0 = e.clientY; h0 = studio.getBoundingClientRect().height;
    grip.setPointerCapture(e.pointerId);
  });
  grip.addEventListener('pointermove', (e) => {
    if (!dragging) return;
    const dy = e.clientY - y0;
    if (Math.abs(dy) > 6) moved = true;
    if (moved) { studio.style.height = Math.max(90, Math.min(window.innerHeight * 0.86, h0 - dy)) + 'px'; studio.classList.add('dragging'); }
  });
  const end = () => {
    if (!dragging) return;
    dragging = false; studio.classList.remove('dragging');
    if (!moved) return;
    const h = studio.getBoundingClientRect().height, vh = window.innerHeight;
    studio.style.height = '';
    ui.open = h > vh * 0.14;
    document.body.classList.toggle('sheet-tall', h > vh * 0.5);
    renderSteps(); onChromeChange();
    grip.dataset.dragged = '1'; setTimeout(() => { delete grip.dataset.dragged; }, 50);
  };
  grip.addEventListener('pointerup', end); grip.addEventListener('pointercancel', end);
  grip.addEventListener('click', (e) => { if (grip.dataset.dragged) { e.stopImmediatePropagation(); e.preventDefault(); } }, true);
}

// ------------------------------------------------------------ 3D room

let T = null, BGU = null, ENV = null, REFL = null, RBOX = null;  // three.js namespaces once loaded
const R3 = { ready: false, renderer: null, scene: null, camera: null, controls: null, room: null, walls: {}, mats: {}, tex: {}, tween: null, pending: false, frames: 0, safe: { top: 0, bottom: 0, left: 0 } };
window.__roomDesigner = R3;
R3.encode = () => St.encodeState(state); // read by the render check to prove the share link round-trips
R3.ui = ui;
const LOW = (window.matchMedia && matchMedia('(pointer: coarse)').matches) || Math.min(screen.width, screen.height) < 700;

/** Where a surface sits in the room: origin, its x direction (u), up (v) and the way it faces (n). */
function wallFrame(k) {
  const W = state.room.W, L = state.room.L, H = state.room.H;
  if (k === 'front') return { o: [0, 0, 0], u: [1, 0, 0], v: [0, 1, 0], n: [0, 0, 1], width: W, depth: L };
  if (k === 'back') return { o: [W, 0, L], u: [-1, 0, 0], v: [0, 1, 0], n: [0, 0, -1], width: W, depth: L };
  if (k === 'left') return { o: [0, 0, L], u: [0, 0, -1], v: [0, 1, 0], n: [1, 0, 0], width: L, depth: W };
  if (k === 'right') return { o: [W, 0, 0], u: [0, 0, 1], v: [0, 1, 0], n: [-1, 0, 0], width: L, depth: W };
  return { o: [0, H, 0], u: [1, 0, 0], v: [0, 0, 1], n: [0, -1, 0], width: W, depth: H }; // the ceiling, seen from below
}

// --- procedural textures (canvas, generated once, tiny)
function rng(seed) { return () => (seed = (seed * 16807) % 2147483647) / 2147483647; }
function canvasTex(w, h, paint, repeatIn, srgb) {
  const c = document.createElement('canvas'); c.width = w; c.height = h;
  const g = c.getContext('2d'); paint(g, w, h);
  const t = new T.CanvasTexture(c);
  t.wrapS = t.wrapT = T.RepeatWrapping;
  if (repeatIn) t.repeat.set(1 / repeatIn[0], 1 / repeatIn[1]);
  t.colorSpace = srgb ? T.SRGBColorSpace : T.NoColorSpace;
  t.anisotropy = LOW ? 4 : 8;
  return t;
}
function noiseField(g, w, h, amp, cell, rnd) {
  const nx = Math.ceil(w / cell), ny = Math.ceil(h / cell), grid = [];
  for (let j = 0; j < ny; j++) { grid.push([]); for (let i = 0; i < nx; i++) grid[j].push(rnd() * 2 - 1); }
  const img = g.getImageData(0, 0, w, h), d = img.data;
  const sm = (t) => t * t * (3 - 2 * t);
  for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
    const fx = x / cell, fy = y / cell, i0 = Math.floor(fx) % nx, j0 = Math.floor(fy) % ny, i1 = (i0 + 1) % nx, j1 = (j0 + 1) % ny;
    const tx = sm(fx - Math.floor(fx)), ty = sm(fy - Math.floor(fy));
    const v = (grid[j0][i0] * (1 - tx) + grid[j0][i1] * tx) * (1 - ty) + (grid[j1][i0] * (1 - tx) + grid[j1][i1] * tx) * ty;
    const o = (y * w + x) * 4, val = Math.max(0, Math.min(255, d[o] + v * amp));
    d[o] = d[o + 1] = d[o + 2] = val;
  }
  g.putImageData(img, 0, 0);
}
function makeTextures() {
  const tx = R3.tex;
  tx.velvet = canvasTex(128, 128, (g, w, h) => { g.fillStyle = '#ececec'; g.fillRect(0, 0, w, h); noiseField(g, w, h, 22, 32, rng(11)); noiseField(g, w, h, 8, 8, rng(5)); }, [36, 36]);
  tx.linen = canvasTex(128, 128, (g, w, h) => {
    const r = rng(23); g.fillStyle = '#dedede'; g.fillRect(0, 0, w, h);
    for (let y = 0; y < h; y++) { let x = 0; while (x < w) { const run = 4 + r() * 40, v = Math.round(222 + (r() - 0.5) * 40); g.fillStyle = 'rgb(' + v + ',' + v + ',' + v + ')'; g.fillRect(x, y, run, 1); x += run; } }
    for (let x = 0; x < w; x += 2) { g.fillStyle = 'rgba(0,0,0,' + (0.04 + r() * 0.05) + ')'; g.fillRect(x, 0, 1, h); }
  }, [5, 5]);
  tx.leather = canvasTex(128, 128, (g, w, h) => {
    const r = rng(41); g.fillStyle = '#e4e4e4'; g.fillRect(0, 0, w, h);
    for (let i = 0; i < 1400; i++) { const v = Math.round(228 + (r() - 0.5) * 36); g.fillStyle = 'rgb(' + v + ',' + v + ',' + v + ')'; g.beginPath(); g.arc(r() * w, r() * h, 0.8 + r() * 2.2, 0, 6.3); g.fill(); }
  }, [3, 3]);
  // sewn surfaces: a stitched groove every few inches, as a soft height map
  tx.channel = canvasTex(64, 8, (g, w, h) => {
    const gr = g.createLinearGradient(0, 0, w, 0);
    gr.addColorStop(0, '#5a5a5a'); gr.addColorStop(0.08, '#c8c8c8'); gr.addColorStop(0.5, '#ffffff'); gr.addColorStop(0.92, '#c8c8c8'); gr.addColorStop(1, '#5a5a5a');
    g.fillStyle = gr; g.fillRect(0, 0, w, h);
  }, [4, 4]);
  tx.quilt = canvasTex(128, 128, (g, w, h) => {
    // diamond stitching: 0 on a stitch line, rising to a soft pillow between them
    const img = g.createImageData(w, h), d = img.data;
    for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
      const u = (x + y) / w, v = (x - y + h) / h;
      const a = 1 - Math.abs((u % 1) - 0.5) * 2, b = 1 - Math.abs((v % 1) - 0.5) * 2;
      const t = Math.min(1, Math.min(a, b) * 6), val = Math.round(110 + 145 * Math.sqrt(t));
      const o = (y * w + x) * 4; d[o] = d[o + 1] = d[o + 2] = val; d[o + 3] = 255;
    }
    g.putImageData(img, 0, 0);
  }, [14, 14]);
  // fine structure as normal maps, drawn as height and converted: woven linen, pebbled leather, velvet pile
  tx.linenN = normalTex(256, (x, y) => {
    const p = 10, u = x / p, v = y / p, over = (Math.floor(u) + Math.floor(v)) % 2;
    const along = over ? Math.sin(Math.PI * (v % 1)) : Math.sin(Math.PI * (u % 1));
    return 0.55 * along + 0.12 * Math.sin(x * 0.9 + Math.sin(y * 0.13) * 3) ;
  }, 2.2, [2, 2]);
  tx.leatherN = (() => {
    const r = rng(7), cells = []; for (let i = 0; i < 260; i++) cells.push([r() * 256, r() * 256]);
    return normalTex(256, (x, y) => { let d = 1e9; for (const c of cells) { let dx = Math.abs(x - c[0]), dy = Math.abs(y - c[1]); dx = Math.min(dx, 256 - dx); dy = Math.min(dy, 256 - dy); d = Math.min(d, dx * dx + dy * dy); } return Math.min(1, Math.sqrt(d) / 9); }, 1.6, [4, 4]);
  })();
  tx.velvetN = (() => { const r = rng(31), g0 = []; for (let i = 0; i < 64 * 64; i++) g0.push(r()); return normalTex(128, (x, y) => g0[((y >> 1) & 63) * 64 + ((x >> 1) & 63)], 0.5, [1.5, 1.5]); })();
  tx.channelN = normalTex(128, (x) => { const u = (x % 64) / 64; return Math.pow(Math.sin(Math.PI * u), 0.35); }, 3.2, [4, 4]);
  tx.quiltN = normalTex(128, (x, y) => { const u = (x + y) / 128, v = (x - y + 128) / 128; const a = 1 - Math.abs((u % 1) - 0.5) * 2, b = 1 - Math.abs((v % 1) - 0.5) * 2; return Math.sqrt(Math.min(1, Math.min(a, b) * 6)); }, 1.2, [14, 14]);
  tx.carpet = canvasTex(128, 128, (g, w, h) => { g.fillStyle = '#d6d6d6'; g.fillRect(0, 0, w, h); noiseField(g, w, h, 26, 2, rng(3)); noiseField(g, w, h, 12, 16, rng(9)); }, [14, 14], true);
  tx.wood = canvasTex(256, 512, (g, w, h) => {
    const r = rng(77), planks = 4, pw = w / planks;
    for (let i = 0; i < planks; i++) {
      let y = -r() * h;
      while (y < h) {
        const len = h * (0.35 + r() * 0.5), tone = (LIGHT ? 214 : 168) + Math.round((r() - 0.5) * 34);
        g.fillStyle = 'rgb(' + tone + ',' + Math.round(tone * (LIGHT ? 0.88 : 0.86)) + ',' + Math.round(tone * (LIGHT ? 0.76 : 0.7)) + ')';
        g.fillRect(i * pw, y, pw, len);
        for (let k = 0; k < 18; k++) { g.fillStyle = 'rgba(70,40,20,' + (0.03 + r() * 0.07) + ')'; g.fillRect(i * pw + r() * pw, y, 0.8 + r() * 1.4, len); }
        g.fillStyle = 'rgba(40,24,12,.35)'; g.fillRect(i * pw, y, pw, 1.2);
        y += len;
      }
      g.fillStyle = 'rgba(40,24,12,.4)'; g.fillRect(i * pw, 0, 1.2, h);
    }
  }, [28, 56], true);
  tx.grain = canvasTex(64, 256, (g, w, h) => {
    const r = rng(17); g.fillStyle = '#d9d9d9'; g.fillRect(0, 0, w, h);
    for (let k = 0; k < 90; k++) { g.fillStyle = 'rgba(0,0,0,' + (0.03 + r() * 0.08) + ')'; g.fillRect(r() * w, 0, 0.6 + r() * 1.6, h); }
  }, [3, 24], true);
  tx.marble = canvasTex(256, 256, (g, w, h) => {
    g.fillStyle = '#efedea'; g.fillRect(0, 0, w, h); noiseField(g, w, h, 14, 64, rng(5));
    const r = rng(19); g.lineCap = 'round';
    for (let k = 0; k < 9; k++) {
      g.strokeStyle = 'rgba(80,80,90,' + (0.12 + r() * 0.25) + ')'; g.lineWidth = 0.6 + r() * 2.2; g.beginPath();
      let x = r() * w, y = 0; g.moveTo(x, y);
      while (y < h) { x += (r() - 0.5) * 34; y += 8 + r() * 18; g.lineTo(x, y); }
      g.stroke();
    }
  }, [40, 40], true);
  tx.sky = canvasTex(32, 64, (g, w, h) => {
    const gr = g.createLinearGradient(0, 0, 0, h); gr.addColorStop(0, '#a9c4dc'); gr.addColorStop(0.62, '#e6edf1'); gr.addColorStop(1, '#d6d0c4');
    g.fillStyle = gr; g.fillRect(0, 0, w, h);
  }, null, true);
  tx.screen = canvasTex(64, 64, (g, w, h) => {
    const gr = g.createLinearGradient(0, 0, w, h); gr.addColorStop(0, '#2a3a4c'); gr.addColorStop(0.55, '#141c26'); gr.addColorStop(1, '#3a2c22');
    g.fillStyle = gr; g.fillRect(0, 0, w, h);
  }, null, true);
  // soft light: a band that fades out to both sides (u), and a round pool
  tx.band = canvasTex(64, 4, (g, w, h) => {
    const gr = g.createLinearGradient(0, 0, w, 0);
    gr.addColorStop(0, 'rgba(255,255,255,0)'); gr.addColorStop(0.5, 'rgba(255,255,255,1)'); gr.addColorStop(1, 'rgba(255,255,255,0)');
    g.fillStyle = gr; g.fillRect(0, 0, w, h);
  }, null, true);
  tx.fade = canvasTex(4, 64, (g, w, h) => {
    const gr = g.createLinearGradient(0, 0, 0, h);
    gr.addColorStop(0, 'rgba(255,255,255,1)'); gr.addColorStop(0.35, 'rgba(255,255,255,.45)'); gr.addColorStop(1, 'rgba(255,255,255,0)');
    g.fillStyle = gr; g.fillRect(0, 0, w, h);
  }, null, true);
  tx.pool = canvasTex(64, 64, (g, w, h) => {
    const gr = g.createRadialGradient(w / 2, h / 2, 0, w / 2, h / 2, w / 2);
    gr.addColorStop(0, 'rgba(255,255,255,1)'); gr.addColorStop(0.45, 'rgba(255,255,255,.35)'); gr.addColorStop(1, 'rgba(255,255,255,0)');
    g.fillStyle = gr; g.fillRect(0, 0, w, h);
  }, null, true);
  [tx.band, tx.fade, tx.pool].forEach(t => { t.wrapS = t.wrapT = T.ClampToEdgeWrapping; t.repeat.set(1, 1); });
}
/** A tangent-space normal map from a height function h(x, y) in 0..1 over an N x N tile. */
function normalTex(N, h, strength, repeatIn) {
  const H = new Float32Array(N * N);
  for (let y = 0; y < N; y++) for (let x = 0; x < N; x++) H[y * N + x] = h(x, y);
  const t = canvasTex(N, N, (g, w) => {
    const img = g.createImageData(w, w), d = img.data;
    for (let y = 0; y < w; y++) for (let x = 0; x < w; x++) {
      const dx = (H[y * w + (x + 1) % w] - H[y * w + (x - 1 + w) % w]) * strength, dy = (H[((y + 1) % w) * w + x] - H[((y - 1 + w) % w) * w + x]) * strength;
      const l = Math.hypot(dx, dy, 1), o = (y * w + x) * 4;
      d[o] = Math.round((-dx / l * 0.5 + 0.5) * 255); d[o + 1] = Math.round((dy / l * 0.5 + 0.5) * 255); d[o + 2] = Math.round((1 / l * 0.5 + 0.5) * 255); d[o + 3] = 255;
    }
    g.putImageData(img, 0, 0);
  }, repeatIn);
  return t;
}
// ambient-occlusion feel: darker toward the edges of a surface (corners, floor line, ceiling line)
function aoTex(wIn, hIn, edges) {
  const S0 = 64;
  return canvasTex(S0, S0, (g, w, h) => {
    const img = g.createImageData(w, h), d = img.data;
    for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
      const u = (x + 0.5) / w * wIn, v = (1 - (y + 0.5) / h) * hIn;
      let a = 1;
      for (const [side, reach, depth] of edges) {
        const dist = side === 'l' ? u : side === 'r' ? wIn - u : side === 'b' ? v : hIn - v;
        a *= 1 - depth * Math.exp(-dist / reach);
      }
      const o = (y * w + x) * 4; d[o] = d[o + 1] = d[o + 2] = Math.round(255 * a); d[o + 3] = 255;
    }
    g.putImageData(img, 0, 0);
  });
}

function hexColor(hex) { return new T.Color(hex); }
function fabricMat(family, hex, surface) {
  const key = family + hex + (surface || 'plain');
  if (R3.mats[key]) return R3.mats[key];
  const c = hexColor(hex), tx = R3.tex, sewN = surface === 'channel' ? tx.channelN : surface === 'quilted' ? tx.quiltN : null;
  const sewAO = surface === 'channel' ? tx.channel : surface === 'quilted' ? tx.quilt : null;
  let m;
  if (family === 'linen') {
    m = new T.MeshStandardMaterial({ color: c, map: tx.linen, normalMap: sewN || tx.linenN, roughness: 0.94, metalness: 0, vertexColors: true });
    m.normalScale.set(sewN ? 1 : 0.55, sewN ? 1 : 0.55);
  } else if (family === 'leather') {
    m = new T.MeshPhysicalMaterial({ color: c, map: tx.leather, normalMap: sewN || tx.leatherN, roughness: 0.48, metalness: 0, clearcoat: 0.32, clearcoatRoughness: 0.38, vertexColors: true });
    m.normalScale.set(sewN ? 1 : 0.35, sewN ? 1 : 0.35);
  } else {
    // velvet: a soft pile, and the sheen that makes velvet look like velvet as the light rakes across it
    const sheen = c.clone().lerp(new T.Color(0xffffff), 0.5);
    m = new T.MeshPhysicalMaterial({ color: c.clone().multiplyScalar(0.8), map: tx.velvet, normalMap: sewN || tx.velvetN, roughness: 0.86, metalness: 0,
      sheen: 1, sheenRoughness: 0.3, sheenColor: sheen, vertexColors: true });
    m.normalScale.set(sewN ? 1 : 0.4, sewN ? 1 : 0.4);
  }
  if (sewAO) { m.aoMap = sewAO; m.aoMapIntensity = surface === 'quilted' ? 0.35 : 0.6; }
  m.envMapIntensity = 0.2;
  R3.mats[key] = m;
  return m;
}
function metalMat(finish) {
  const key = 'metal-' + finish;
  if (R3.mats[key]) return R3.mats[key];
  const spec = { gold: [0xd6b273, 0.3], brass: [0xd6b273, 0.3], black: [0x1e1e1e, 0.42], chrome: [0xe3e6ea, 0.1] }[finish] || [0xd6b273, 0.3];
  // brushed metal: a stretched highlight along the strip
  const m = new T.MeshPhysicalMaterial({ color: spec[0], metalness: finish === 'black' ? 0.75 : 1, roughness: spec[1], anisotropy: finish === 'chrome' ? 0.2 : 0.4 });
  m.envMapIntensity = 1.15;
  return (R3.mats[key] = m);
}
function mirrorMat() {
  if (R3.mats.mirror) return R3.mats.mirror;
  // a mirror reflects the room: a cube map captured from the middle of the room after each rebuild
  const m = new T.MeshStandardMaterial({ color: 0xdfe3e6, metalness: 1, roughness: 0.06, envMap: ENV });
  m.envMapIntensity = 1;
  return (R3.mats.mirror = m);
}
function glowMat(hex, tex) {
  const m = new T.MeshBasicMaterial({ color: hex, map: tex || null, transparent: true, depthWrite: false, blending: T.AdditiveBlending, toneMapped: false, opacity: 0.5 });
  m.userData.glow = true; m.userData.ownMat = true;
  return m;
}

function disposeGroup(g) { g.traverse(o => { if (o.userData.staging) return; if (o.geometry) o.geometry.dispose(); if (o.userData.ownMat && o.material) o.material.dispose(); }); }   // staging props share their geometry across rebuilds

/** Round the convex corners of a polygon in plan (a wrapped panel never has a knife-sharp corner). */
function filletPoly(poly, rf) {
  const n = poly.length, out = [];
  for (let i = 0; i < n; i++) {
    const a = poly[(i - 1 + n) % n], b = poly[i], c = poly[(i + 1) % n];
    const ux = a[0] - b[0], uy = a[1] - b[1], vx = c[0] - b[0], vy = c[1] - b[1];
    const lu = Math.hypot(ux, uy), lv = Math.hypot(vx, vy);
    const cross = (b[0] - a[0]) * (c[1] - b[1]) - (b[1] - a[1]) * (c[0] - b[0]);
    const cosT = (ux * vx + uy * vy) / (lu * lv || 1), th = Math.acos(Math.max(-1, Math.min(1, cosT)));
    if (cross <= 0 || th > 2.97 || lu < 1e-6 || lv < 1e-6) { out.push(b); continue; }
    let tl = rf / Math.tan(th / 2);
    tl = Math.min(tl, 0.42 * lu, 0.42 * lv);
    const r = tl * Math.tan(th / 2);
    if (r < 0.04) { out.push(b); continue; }
    const p0 = [b[0] + ux / lu * tl, b[1] + uy / lu * tl], p1 = [b[0] + vx / lv * tl, b[1] + vy / lv * tl];
    let bx = ux / lu + vx / lv, by = uy / lu + vy / lv; const bl = Math.hypot(bx, by) || 1; bx /= bl; by /= bl;
    const dc = r / Math.sin(th / 2), cx = b[0] + bx * dc, cy = b[1] + by * dc;
    const a0 = Math.atan2(p0[1] - cy, p0[0] - cx); let a1 = Math.atan2(p1[1] - cy, p1[0] - cx);
    while (a1 < a0) a1 += Math.PI * 2;
    if (a1 - a0 > Math.PI) a1 -= Math.PI * 2;
    const k = 4;
    for (let q = 0; q <= k; q++) { const t = a0 + (a1 - a0) * q / k; out.push([cx + r * Math.cos(t), cy + r * Math.sin(t)]); }
  }
  return out;
}
/**
 * An upholstered panel, built directly so it shades like the real thing: a short side (the board and the
 * padding under the fabric), a tight rounded edge where the fabric is pulled over the padding, and a nearly flat
 * face with a very gentle crown. Corners are softly rounded in plan. The sides carry baked shading, so
 * panels look seated against their neighbours. UVs are in inches, turned to run along the piece.
 */
function panelGeometry(p) {
  const poly0 = G.ensureCCW(G.clean(p.poly));
  if (poly0.length < 3) return null;
  const width = G.pieceWidth(poly0);
  const poly = filletPoly(poly0, Math.min(0.5, Math.max(0.2, width * 0.03)));
  const n = poly.length;
  const R = Math.max(0.22, Math.min(LOW ? 0.5 : 0.55, width * 0.07)), C = 0.5;
  const base = 0.04, side = 0.82, K = LOW ? 3 : 5;
  // fabric runs along the piece: the longest edge sets the weave direction
  let best = 0, ang = 0;
  for (let i = 0; i < poly0.length; i++) { const a = poly0[i], b = poly0[(i + 1) % poly0.length], l = Math.hypot(b[0] - a[0], b[1] - a[1]); if (l > best) { best = l; ang = Math.atan2(b[1] - a[1], b[0] - a[0]); } }
  if (Math.abs(Math.cos(ang)) > 0.92) ang = 0; else if (Math.abs(Math.sin(ang)) > 0.92) ang = Math.PI / 2;
  const ca = Math.cos(-ang), sa = Math.sin(-ang);
  const UV = (x, y) => [x * ca - y * sa, x * sa + y * ca];
  const ns = [];
  for (let i = 0; i < n; i++) { const a = poly[i], b = poly[(i + 1) % n], dx = b[0] - a[0], dy = b[1] - a[1], l = Math.hypot(dx, dy) || 1; ns.push([dy / l, -dx / l]); }
  const mit = [], hor = [];
  for (let i = 0; i < n; i++) {
    const n0 = ns[(i - 1 + n) % n], n1 = ns[i];
    let bx = n0[0] + n1[0], by = n0[1] + n1[1]; const bl = Math.hypot(bx, by);
    if (bl < 1e-6) { bx = n1[0]; by = n1[1]; } else { bx /= bl; by /= bl; }
    const a = poly[(i - 1 + n) % n], b = poly[i], c = poly[(i + 1) % n];
    const reflex = (b[0] - a[0]) * (c[1] - b[1]) - (b[1] - a[1]) * (c[0] - b[0]) < 0;
    // a reflex corner is not amplified, and no corner moves further than 0.45 of its shorter edge (per inch of offset)
    let f = reflex ? 1 : 1 / Math.max(0.34, bx * n1[0] + by * n1[1]);
    const short = Math.min(Math.hypot(b[0] - a[0], b[1] - a[1]), Math.hypot(c[0] - b[0], c[1] - b[1]));
    f = Math.min(f, Math.max(0.2, 0.45 * short / R));
    mit.push([-bx * f, -by * f]); hor.push([bx, by]);
  }
  const pos = [], nrm = [], uv = [], col = [], idx = [];
  const ring = (t, z, nh, nz, shade) => {
    const start = pos.length / 3, l = Math.hypot(nh, nz) || 1;
    for (let i = 0; i < n; i++) {
      const x = poly[i][0] + mit[i][0] * t, y = poly[i][1] + mit[i][1] * t, q = UV(x, y);
      pos.push(x, y, z); nrm.push(hor[i][0] * nh / l, hor[i][1] * nh / l, nz / l); uv.push(q[0], q[1]); col.push(shade, shade, shade);
    }
    return start;
  };
  const rings = [ring(0, base, 1, 0.05, 0.3), ring(0, base + side * 0.55, 1, 0.08, 0.62), ring(0, base + side, 1, 0.15, 0.82)];
  for (let k = 1; k <= K; k++) {
    // a superellipse quarter: rises fast, then lays flat into the face
    const th = (k / K) * Math.PI / 2, c = Math.cos(th), sn = Math.sin(th);
    const t = R * (1 - Math.pow(c, 0.7)), z = base + side + C * Math.pow(sn, 0.7);
    rings.push(ring(t, z, C * Math.pow(c, 0.6), R * Math.pow(sn, 0.6) + 0.02, 0.82 + 0.18 * (k / K)));
  }
  for (let r = 0; r + 1 < rings.length; r++) {
    const a0 = rings[r], b0 = rings[r + 1];
    for (let i = 0; i < n; i++) { const j = (i + 1) % n; idx.push(a0 + i, a0 + j, b0 + j, a0 + i, b0 + j, b0 + i); }
  }
  // the face: the innermost ring, triangulated, finely subdivided, and given a gentle crown
  const top = rings[rings.length - 1], zTop = base + side + C;
  const contour = []; for (let i = 0; i < n; i++) contour.push([pos[(top + i) * 3], pos[(top + i) * 3 + 1]]);
  const holes = (p.holes || []).map(h => { const b = G.bbox(h); return [[b.x0, b.y0], [b.x0, b.y1], [b.x1, b.y1], [b.x1, b.y0]]; });
  let tris = [];
  try { tris = T.ShapeUtils.triangulateShape(contour.map(v => new T.Vector2(v[0], v[1])), holes.map(h => h.map(v => new T.Vector2(v[0], v[1])))); } catch (e) { tris = []; }
  let fv = contour.concat(...holes);
  // a face that does not triangulate cleanly (it crossed itself) is rebuilt from a clean inset outline
  const triArea = tris.reduce((sum, t) => sum + Math.abs(G.signedArea([fv[t[0]], fv[t[1]], fv[t[2]]])), 0);
  const want = Math.abs(G.signedArea(contour)) - holes.reduce((sum, h) => sum + Math.abs(G.signedArea(h)), 0);
  if (!G.isSimple(contour) || !tris.length || Math.abs(triArea - want) > want * 0.01) {
    const clean = G.offsetSimple(poly, -R);
    if (clean.length >= 3) {
      contour.length = 0; clean.forEach(v => contour.push(v));
      try { tris = T.ShapeUtils.triangulateShape(contour.map(v => new T.Vector2(v[0], v[1])), holes.map(h => h.map(v => new T.Vector2(v[0], v[1])))); } catch (e) { tris = []; }
      fv = contour.concat(...holes);
    }
  }
  let ft = tris.map(t => t.slice());
  const longest = () => { let m = 0; for (const t of ft) for (let e = 0; e < 3; e++) { const a = fv[t[e]], b = fv[t[(e + 1) % 3]]; m = Math.max(m, Math.hypot(a[0] - b[0], a[1] - b[1])); } return m; };
  for (let lev = 0; lev < (LOW ? 3 : 4) && ft.length && ft.length < 1400 && longest() > 3.5; lev++) {
    const cache = new Map(), mid = (i, j) => { const k = i < j ? i + ',' + j : j + ',' + i; if (!cache.has(k)) { cache.set(k, fv.length); fv.push([(fv[i][0] + fv[j][0]) / 2, (fv[i][1] + fv[j][1]) / 2]); } return cache.get(k); };
    const nt = [];
    for (const [a, b, c] of ft) { const ab = mid(a, b), bc = mid(b, c), cx = mid(c, a); nt.push([a, ab, cx], [ab, b, bc], [cx, bc, c], [ab, bc, cx]); }
    ft = nt;
  }
  const crown = Math.min(0.32, width * 0.018), D = Math.max(2, Math.min(9, width * 0.3));
  const segs = [];
  for (let i = 0; i < contour.length; i++) segs.push([contour[i], contour[(i + 1) % contour.length]]);
  for (const h of holes) for (let i = 0; i < 4; i++) segs.push([h[i], h[(i + 1) % 4]]);
  const fz = fv.map(v => { let d = Infinity; for (const [a, b] of segs) d = Math.min(d, G.pointSegDist(v, a, b)); const s = Math.min(1, d / D); return zTop + crown * (1 - (1 - s) * (1 - s)); });
  const faceGeo = new T.BufferGeometry();
  const fpos = [], fuv = [], fcol = [];
  fv.forEach((v, i) => { const q = UV(v[0], v[1]); fpos.push(v[0], v[1], fz[i]); fuv.push(q[0], q[1]); fcol.push(1, 1, 1); });
  faceGeo.setAttribute('position', new T.Float32BufferAttribute(fpos, 3));
  faceGeo.setAttribute('uv', new T.Float32BufferAttribute(fuv, 2));
  faceGeo.setAttribute('color', new T.Float32BufferAttribute(fcol, 3));
  faceGeo.setIndex([].concat(...ft));
  faceGeo.computeVertexNormals();
  const geo = new T.BufferGeometry();
  geo.setAttribute('position', new T.Float32BufferAttribute(pos, 3));
  geo.setAttribute('normal', new T.Float32BufferAttribute(nrm, 3));
  geo.setAttribute('uv', new T.Float32BufferAttribute(uv, 2));
  geo.setAttribute('color', new T.Float32BufferAttribute(col, 3));
  geo.setIndex(idx);
  const out = BGU.mergeGeometries([geo, faceGeo], false);
  geo.dispose(); faceGeo.dispose();
  return out;
}
/** A flat slab (mirror, slat, stone) from a polygon, depth d, at height z0. */
function slabGeometry(poly, d, z0, bevel) {
  const shape = new T.Shape(G.ensureCCW(poly).map(v => new T.Vector2(v[0], v[1])));
  const geo = new T.ExtrudeGeometry(shape, { depth: d, bevelEnabled: !!bevel, bevelThickness: bevel || 0, bevelSize: bevel || 0, bevelSegments: 2, curveSegments: 1 });
  geo.translate(0, 0, z0);
  return geo;
}
/** A thin strip along a segment, w wide, d deep, top at z1. */
function stripGeometry(a, b, w, d, z1) {
  const L = Math.hypot(b[0] - a[0], b[1] - a[1]);
  if (L < 0.05) return null;
  const g = new T.BoxGeometry(L, w, d);
  g.rotateZ(Math.atan2(b[1] - a[1], b[0] - a[0]));
  g.translate((a[0] + b[0]) / 2, (a[1] + b[1]) / 2, z1 - d / 2);
  return g;
}
/** A flat glow quad along a segment: width across it, fading out to both sides. */
function glowStrip(a, b, w, z, endPad) {
  const L = Math.hypot(b[0] - a[0], b[1] - a[1]) + (endPad || 0);
  if (L < 0.05) return null;
  const g = new T.PlaneGeometry(L, w);
  const uvs = g.attributes.uv; for (let i = 0; i < uvs.count; i++) uvs.setXY(i, uvs.getY(i), uvs.getX(i));
  g.rotateZ(Math.atan2(b[1] - a[1], b[0] - a[0]));
  g.translate((a[0] + b[0]) / 2, (a[1] + b[1]) / 2, z);
  return g;
}
function merged(list) { const l = list.filter(Boolean); if (!l.length) return null; if (l.length === 1) return l[0]; const m = BGU.mergeGeometries(l, false); l.forEach(x => x.dispose()); return m; }

const LOOK = LIGHT
  ? { trim: 0xf3f1ed, door: 0x9a7656, doorInset: 0x8d6a4c, glass: 0x9fb3c2, frame: 0xf3f1ed, outlet: 0xf4f2ee, paintDay: 0xd9d7d2, paintNight: 0x2f2c29, base: 0xf3f1ed, ceilDay: 0xf8f6f2, ceilNight: 0x3a3632, floorWood: 0xd6bfa0, floorCarpet: 0xb5ada3, bg: 0xeceae6, furn: 0xe9e6e0, furn2: 0xcfc9c0 }
  : { trim: 0x2c2825, door: 0x3a2f27, doorInset: 0x33291f, glass: 0x9fb3c2, frame: 0x1c1a18, outlet: 0xe9e5dd, paintDay: 0x9c9389, paintNight: 0x2f2b28, base: 0x24211e, ceilDay: 0xe2ddd4, ceilNight: 0x3a342e, floorWood: 0x86705e, floorCarpet: 0x5a524b, bg: 0x0b0b0b, furn: 0x3a3632, furn2: 0x2a2725 };
function stdMat(o) { return new T.MeshStandardMaterial(o); }

function buildOpenings(g, lay, k) {
  const own = (mesh) => { mesh.userData.ownMat = true; mesh.receiveShadow = true; return mesh; };
  for (const o of lay.openings) {
    const r = o.raw, w = r.x1 - r.x0, h = r.y1 - r.y0, cx = (r.x0 + r.x1) / 2, cy = (r.y0 + r.y1) / 2;
    if (o.type === 'screen') {
      const bezel = own(new T.Mesh(new T.BoxGeometry(w, h, 2.2), stdMat({ color: 0x0b0b0c, roughness: 0.5, metalness: 0.3 })));
      bezel.position.set(cx, cy, 1.1); bezel.castShadow = true; g.add(bezel);
      const glassM = stdMat({ color: 0x07080a, roughness: 0.32, metalness: 0, emissive: 0xffffff, emissiveMap: R3.tex.screen, emissiveIntensity: 0.1 });
      const glass = own(new T.Mesh(new T.PlaneGeometry(Math.max(1, w - 1.2), Math.max(1, h - 1.2)), glassM));
      glass.position.set(cx, cy, 2.22); g.add(glass); R3.screens.push(glassM);
    } else if (o.type === 'door' || o.type === 'glass') {
      if (o.type === 'glass') {
        const gm = stdMat({ color: 0xbfd0da, roughness: 0.08, metalness: 0.1, transparent: true, opacity: 0.35 });
        const pane = own(new T.Mesh(new T.PlaneGeometry(w - 3, h - 3), gm)); pane.position.set(cx, cy, 0.9); g.add(pane);
        const fm = stdMat({ color: 0x2b2b2b, roughness: 0.4, metalness: 0.6 });
        for (const [x, y, ww, hh] of [[r.x0 + 1, cy, 2, h], [r.x1 - 1, cy, 2, h], [cx, r.y1 - 1, w, 2], [cx, r.y0 + 1, w, 2]]) { const b = own(new T.Mesh(new T.BoxGeometry(ww, hh, 1.6), fm)); b.position.set(x, y, 0.8); g.add(b); }
      } else {
        const slab = own(new T.Mesh(new T.BoxGeometry(w, h, 1.6), stdMat({ color: LOOK.door, roughness: 0.6 })));
        slab.position.set(cx, cy, 0.8); g.add(slab);
        for (const [py, ph] of [[r.y0 + h * 0.08, h * 0.38], [r.y0 + h * 0.54, h * 0.38]]) {
          const inset = own(new T.Mesh(new T.BoxGeometry(w * 0.7, ph, 0.4), stdMat({ color: LOOK.doorInset, roughness: 0.64 })));
          inset.position.set(cx, py + ph / 2, 1.75); g.add(inset);
        }
        const knob = own(new T.Mesh(new T.SphereGeometry(1.1, 16, 10), metalMat(LIGHT ? 'chrome' : 'brass')));
        knob.position.set(r.x1 - 4, r.y0 + 36, 2.6); g.add(knob);
      }
    } else if (o.type === 'window') {
      const glassM = stdMat({ color: 0x101418, roughness: 0.1, metalness: 0, emissive: 0xffffff, emissiveMap: R3.tex.sky, emissiveIntensity: 0.6 });
      const glass = own(new T.Mesh(new T.PlaneGeometry(w, h), glassM)); glass.position.set(cx, cy, 0.25); g.add(glass); R3.windows.push(glassM);
      const fm = stdMat({ color: LOOK.frame, roughness: 0.5 });
      for (const [x, y, ww, hh] of [[cx, cy, 1.4, h], [cx, cy, w, 1.4]]) { const b = own(new T.Mesh(new T.BoxGeometry(ww, hh, 0.9), fm)); b.position.set(x, y, 0.6); g.add(b); }
    } else if (o.type === 'outlet') {
      // the cover plate sits flush on the panel face when the box is cut through a panel, on the wall when not
      const host = lay.pieces.find(p => p.holes.some(h => { const b = G.bbox(h); return b.x0 <= cx && b.x1 >= cx && b.y0 <= cy && b.y1 >= cy; }));
      const hb = host ? G.bbox(host.holes.find(h => { const b = G.bbox(h); return b.x0 <= cx && b.x1 >= cx && b.y0 <= cy && b.y1 >= cy; })) : null;
      const z = host ? 1.42 : 0.12, pw = Math.max(w + 0.75, hb ? hb.w + 0.6 : 0), ph = Math.max(h + 0.75, hb ? hb.h + 0.6 : 0);
      const plateM = stdMat({ color: LOOK.outlet, roughness: 0.38 });
      const plate = own(new T.Mesh(RBOX ? new RBOX(pw, ph, 0.25, 2, 0.08) : new T.BoxGeometry(pw, ph, 0.25), plateM));
      plate.position.set(cx, cy, z + 0.125); plate.castShadow = true; g.add(plate);
      const gangs = Math.max(1, Math.round(w / 2.25)), slotM = stdMat({ color: 0x2a2826, roughness: 0.8 });
      for (let k = 0; k < gangs; k++) {
        const gx = cx - (gangs - 1) * 1.15 + k * 2.3;
        for (const dy of [-0.85, 0.85]) {
          const face = own(new T.Mesh(RBOX ? new RBOX(1.35, 1.15, 0.14, 2, 0.12) : new T.BoxGeometry(1.35, 1.15, 0.14), plateM));
          face.position.set(gx, cy + dy, z + 0.3); g.add(face);
          for (const sx of [-0.25, 0.25]) { const sl = own(new T.Mesh(new T.BoxGeometry(0.08, 0.32, 0.04), slotM)); sl.position.set(gx + sx, cy + dy + 0.1, z + 0.38); g.add(sl); }
        }
      }
    }
    if (o.type === 'door' || o.type === 'window' || o.type === 'glass') {
      const t = 3.25, tm = stdMat({ color: LOOK.trim, roughness: 0.5 });
      const parts = [[r.x0 - t / 2, cy, t, h + t], [r.x1 + t / 2, cy, t, h + t], [cx, r.y1 + t / 2, w + 2 * t, t]];
      if (o.type === 'window') parts.push([cx, r.y0 - t / 2, w + 2 * t, t]);
      for (const [x, y, ww, hh] of parts) { const b = own(new T.Mesh(new T.BoxGeometry(ww, hh, 0.9), tm)); b.position.set(x, y, 0.45); b.castShadow = true; g.add(b); }
    }
  }
  void k;
}

/** Panels, mirrors, slats, stone and trim for one surface, in that surface's own coordinates. */
function buildSurface(g, lay, k) {
  const byMat = {};
  const pDepth = lay.pillars && lay.pillars.length ? lay.pillars[0].depth : 0;
  const onPillar = (p) => { const zs = lay.zones[p.zone] && lay.zones[p.zone].section; return zs && zs.side === 'pillar'; };
  for (const p of lay.pieces) {
    const z = lay.zones[p.zone].design, fam = p.accent ? (z.accentFamily || 'velvet') : (z.family || 'velvet');
    const geo = panelGeometry(p); if (!geo) continue;
    if (onPillar(p)) geo.translate(0, 0, pDepth);
    const key = fam + '|' + p.color + '|' + (z.surface || 'plain');
    (byMat[key] = byMat[key] || { fam, hex: p.color, surface: z.surface, geos: [] }).geos.push(geo);
  }
  for (const key in byMat) {
    const b = byMat[key], geo = merged(b.geos);
    if (!geo) continue;
    const m = new T.Mesh(geo, fabricMat(b.fam, b.hex, b.surface)); m.castShadow = true; m.receiveShadow = true; g.add(m);
  }
  // mirror: inserts in the pattern and mirror sections
  // mirrors: a bevelled slab for the edge, and over it a true planar reflection of the room (one per surface)
  const mir = merged((lay.inserts || []).map(p => { const gg = slabGeometry(p.poly, 0.12, 0.2, 0.14); if (onPillar(p)) gg.translate(0, 0, pDepth); return gg; }));
  if (mir) { const m = new T.Mesh(mir, mirrorMat()); m.receiveShadow = false; m.castShadow = true; m.userData.mirror = true; g.add(m); R3.mirrors.push(m); }
  if (REFL && (lay.inserts || []).length) {
    const faces = merged(lay.inserts.map(p => { const sh = new T.ShapeGeometry(new T.Shape(G.ensureCCW(G.offsetSimple(p.poly, -0.1).length >= 3 ? G.offsetSimple(p.poly, -0.1) : p.poly).map(v => new T.Vector2(v[0], v[1])))); sh.translate(0, 0, 0.47 + (onPillar(p) ? pDepth : 0)); return sh; }));
    if (faces) {
      const vs = viewSize(), pr = Math.min(2, window.devicePixelRatio || 1);
      const res = Math.min(LOW ? 1024 : 2048, Math.max(512, Math.max(vs.w, vs.h) * pr));
      const rf = new REFL(faces, { textureWidth: res, textureHeight: res, color: 0xc4cbca, clipBias: 0.002, multisample: LOW ? 0 : 4 });
      rf.userData.ownMat = true; rf.userData.mirror = true; g.add(rf); R3.mirrors.push(rf);
      // the bevelled slab sits behind the reflection plane: hide it while the reflection is drawn, or it blocks the room
      const slabs = R3.mirrors.filter(x => x !== rf && x.parent === g), draw = rf.onBeforeRender;
      // the walls and furniture behind the viewer are culled for the main view; a mirror has to see them, or it shows an empty white void
      rf.onBeforeRender = function () {
        const hidden = [];
        for (const key in R3.walls) { const wg = R3.walls[key].group; if (!wg.visible && wg !== g) { wg.visible = true; hidden.push(wg); } }
        for (const m of R3.ctx || []) if (!m.visible) { m.visible = true; hidden.push(m); }
        if (R3.ceiling && !R3.ceiling.visible) { R3.ceiling.visible = true; hidden.push(R3.ceiling); }
        slabs.forEach(x => { x.visible = false; });
        draw.apply(rf, arguments);
        slabs.forEach(x => { x.visible = true; });
        hidden.forEach(x => { x.visible = false; });
      };
    }
  }
  // the seams: behind every panel a dark backing a reveal wider than the piece, so each gap reads as a tight shadow line
  const seams = {};
  const half = layoutOpts(k).reveal / 2 + 0.02;
  for (const p of lay.pieces) {
    const big = (G.isConvex(p.poly) ? G.offsetConvex : G.offsetSimple)(p.poly, half);
    if (big.length < 3) continue;
    const sh = new T.Shape(G.ensureCCW(big).map(v => new T.Vector2(v[0], v[1])));
    const sg = new T.ShapeGeometry(sh); sg.translate(0, 0, 0.03);
    (seams[p.color] = seams[p.color] || []).push(sg);
  }
  for (const hex in seams) {
    const geo = merged(seams[hex]);
    if (!geo) continue;
    const m = new T.Mesh(geo, new T.MeshStandardMaterial({ color: new T.Color(hex).multiplyScalar(0.08), roughness: 1 }));
    m.userData.ownMat = true; m.receiveShadow = true; g.add(m);
  }
  // wood slats
  const comp = state.walls[k] && state.walls[k].comp;
  const slats = merged((lay.slats || []).map(p => slabGeometry(p.poly, 1.0, 0.05, 0.12)));
  if (slats) {
    const wood = (comp && comp.wood) || 'oak';
    const m = new T.Mesh(slats, stdMat({ color: wood === 'walnut' ? 0x6a4a36 : 0xc49a6c, map: R3.tex.grain, roughness: 0.55 }));
    m.material.userData.ownMat = true; m.userData.ownMat = true; m.castShadow = true; m.receiveShadow = true; g.add(m);
  }
  // stone areas (painted areas are just the wall)
  for (const a of lay.areas || []) {
    if (a.type !== 'marble') continue;
    const geo = slabGeometry(a.poly, 0.6, 0.02, 0); fixPlanarUV(geo);
    const m = new T.Mesh(geo, stdMat({ color: 0xffffff, map: R3.tex.marble, roughness: 0.22, metalness: 0 }));
    m.userData.ownMat = true; m.receiveShadow = true; g.add(m);
  }
  // metal inlay in the reveals
  lay.zones.forEach(z => {
    const d = z.design;
    if (!d || d.type === 'none' || !d.inlay || d.inlay === 'none') return;
    const geo = merged(G.trimLines(z).map(s => stripGeometry(s[0], s[1], 0.6, 1.2, 1.35)));
    if (geo) { const m = new T.Mesh(geo, metalMat(d.inlay)); m.castShadow = false; g.add(m); }
  });
  // backlit LED: in the reveals, and a halo round the field
  lay.zones.forEach(z => {
    const d = z.design;
    if (!d || !d.led || d.led === 'none') return;
    const hex = LED_HEX[d.ledTemp || 'warm'], lv = d.ledLevel || 0.7;
    if (d.led === 'lines' || d.led === 'both') {
      const lines = G.trimLines(z);
      const core = merged(lines.map(s => stripGeometry(s[0], s[1], 0.32, 0.1, 0.22)));
      if (core) { const m = new T.Mesh(core, new T.MeshBasicMaterial({ color: hex, toneMapped: false })); m.userData.ownMat = true; m.material.userData.led = lv; g.add(m); }
      const wash = merged(lines.map(s => glowStrip(s[0], s[1], 4.5, 1.72, 1.5)));
      if (wash) { const m = new T.Mesh(wash, glowMat(hex, R3.tex.band)); m.material.userData.level = lv * 0.55; m.renderOrder = 2; g.add(m); R3.glows.push(m.material); }
    }
    if (d.led === 'edge' || d.led === 'both') {
      const halo = merged((z.edgeLines || []).map(s => glowStrip(s[0], s[1], 18, 0.06, 18)));
      if (halo) { const m = new T.Mesh(halo, glowMat(hex, R3.tex.band)); m.material.userData.level = lv * 0.9; m.renderOrder = 1; g.add(m); R3.glows.push(m.material); }
    }
  });
  // headboard edge trim: a metal strip standing just proud of the panels at each joint and outer edge
  if ((lay.trims || []).length) {
    const fin = lay.trims[0].finish, geo = merged(lay.trims.map(t => stripGeometry(t.seg[0], t.seg[1], 0.55, 2.2, 2.25)));
    if (geo) { const m = new T.Mesh(geo, metalMat(fin)); m.castShadow = true; g.add(m); }
  }
  // light cove along the ceiling or floor line
  for (const c of lay.cove || []) {
    const [a, b] = c.seg, up = c.at === 'bottom', len = Math.hypot(b[0] - a[0], b[1] - a[1]);
    const core = new T.Mesh(new T.BoxGeometry(len, 0.6, 0.5), new T.MeshBasicMaterial({ color: 0xffd9a8, toneMapped: false }));
    core.position.set((a[0] + b[0]) / 2, a[1], 0.4); core.userData.ownMat = true; core.material.userData.led = 0.8; g.add(core);
    const wash = new T.Mesh(new T.PlaneGeometry(len, 30), glowMat(0xffc98f, R3.tex.fade));
    if (up) { wash.rotation.z = Math.PI; }
    wash.position.set((a[0] + b[0]) / 2, a[1] + (up ? 15 : -15), 0.1); wash.material.userData.level = 0.7; wash.renderOrder = 1; g.add(wash); R3.glows.push(wash.material);
  }
  // pillars: a stone, wood or plain core; upholstered and mirror faces are panels on top of it
  for (const P of lay.pillars || []) {
    const w = P.x1 - P.x0, h = P.y1 - P.y0;
    let m;
    if (P.finish === 'marble') { m = stdMat({ color: 0xffffff, map: R3.tex.marble, roughness: 0.18 }); }
    else if (P.finish === 'wood') { m = stdMat({ color: 0xb08a5e, map: R3.tex.grain, roughness: 0.5 }); }
    else m = stdMat({ color: LOOK.trim, roughness: 0.6 });
    const geo = new T.BoxGeometry(w, h, P.depth - (P.finish === 'marble' || P.finish === 'wood' ? 0 : 0.05));
    if (P.finish === 'marble') { const uvA = geo.attributes.uv; for (let i = 0; i < uvA.count; i++) uvA.setXY(i, uvA.getX(i) * w / 40, uvA.getY(i) * h / 40); }
    const mesh = new T.Mesh(geo, m); mesh.userData.ownMat = true; mesh.position.set((P.x0 + P.x1) / 2, (P.y0 + P.y1) / 2, P.depth / 2); mesh.castShadow = true; mesh.receiveShadow = true; g.add(mesh);
    if (P.graze) {
      const gw = new T.Mesh(new T.PlaneGeometry(w * 0.9, h * 0.7), glowMat(0xffc98f, R3.tex.fade)); gw.rotation.z = Math.PI;
      gw.position.set((P.x0 + P.x1) / 2, h * 0.35, P.depth + 0.12); gw.material.userData.level = 0.75; gw.renderOrder = 2; g.add(gw); R3.glows.push(gw.material);
    }
  }
  // sconces: a small fixture, and warm pools of light on the wall above and below it
  const sc = state.walls[k] && state.walls[k].sconces;
  for (const p of lay.sconces || []) {
    if (p.onPillar) {
      // a slim glass cylinder on the pillar face, glowing warm
      const fx = new T.Group(), metal = metalMat('brass');
      const tube = new T.Mesh(new T.CylinderGeometry(1.4, 1.4, 16, 24), new T.MeshStandardMaterial({ color: 0xfff1d6, emissive: 0xffd6a0, emissiveIntensity: 1.1, roughness: 0.2, transparent: true, opacity: 0.92 }));
      tube.userData.ownMat = true; tube.position.z = 3.2; fx.add(tube);
      for (const dy of [-8.3, 8.3]) { const cap = new T.Mesh(new T.CylinderGeometry(1.6, 1.6, 0.6, 24), metal); cap.position.set(0, dy, 3.2); fx.add(cap); }
      const arm = new T.Mesh(new T.BoxGeometry(0.8, 0.8, 2), metal); arm.position.z = 1.2; fx.add(arm);
      fx.position.set(p.x, p.y, pDepth); g.add(fx);
      const pool = new T.Mesh(new T.PlaneGeometry(14, 40), glowMat(0xffc98f, R3.tex.pool)); pool.position.set(p.x, p.y, pDepth + 0.15);
      pool.material.userData.level = 0.85; pool.renderOrder = 3; g.add(pool); R3.glows.push(pool.material);
      continue;
    }
    const fin = metalMat((sc && sc.finish) || 'brass'), style = (sc && sc.style) || 'cylinder', fx = new T.Group();
    const plate = new T.Mesh(new T.CylinderGeometry(2.4, 2.4, 0.5, 24), fin); plate.rotation.x = Math.PI / 2; plate.position.z = 2.2; fx.add(plate);
    if (style === 'globe') {
      const arm = new T.Mesh(new T.CylinderGeometry(0.35, 0.35, 3.6, 10), fin); arm.rotation.x = Math.PI / 2; arm.position.z = 4; fx.add(arm);
      const glb = new T.Mesh(new T.SphereGeometry(3, 24, 16), new T.MeshStandardMaterial({ color: 0xfff6e6, emissive: 0xffe2b8, emissiveIntensity: 0.9, roughness: 0.3 }));
      glb.userData.ownMat = true; glb.position.z = 7.2; fx.add(glb);
    } else if (style === 'vbar') {
      const bar = new T.Mesh(new T.BoxGeometry(1.6, 26, 1.8), fin); bar.position.z = 2.6; fx.add(bar);
      const lens = new T.Mesh(new T.BoxGeometry(0.5, 24, 0.3), new T.MeshBasicMaterial({ color: 0xfff1d8, toneMapped: false })); lens.userData.ownMat = true; lens.position.set(0, 0, 3.55); fx.add(lens);
    } else if (style === 'bar') {
      const bar = new T.Mesh(new T.BoxGeometry(18, 1.8, 2.4), fin); bar.position.z = 3.2; fx.add(bar);
      const lens = new T.Mesh(new T.BoxGeometry(17, 0.3, 1.8), new T.MeshBasicMaterial({ color: 0xfff1d8, toneMapped: false })); lens.userData.ownMat = true; lens.position.set(0, -1.0, 3.2); fx.add(lens);
    } else {
      const tube = new T.Mesh(new T.CylinderGeometry(1.8, 1.8, 10, 24), fin); tube.position.z = 4.4; fx.add(tube);
      const arm = new T.Mesh(new T.BoxGeometry(1, 1, 2.2), fin); arm.position.z = 3.1; fx.add(arm);
    }
    fx.position.set(p.x, p.y, 0); fx.traverse(o => { if (o.isMesh) o.castShadow = true; }); g.add(fx);
    const tall = style === 'bar' ? 14 : 30;
    for (const dir of style === 'globe' ? [0] : [1, -1]) {
      const pool = new T.Mesh(new T.PlaneGeometry(style === 'globe' ? 34 : 16, style === 'globe' ? 34 : tall), glowMat(0xffc98f, R3.tex.pool));
      pool.position.set(p.x, p.y + dir * (style === 'globe' ? 0 : tall * 0.45), 1.8); pool.material.userData.level = 0.75; pool.renderOrder = 3; g.add(pool); R3.glows.push(pool.material);
    }
  }
}
function fixPlanarUV(geo) {
  const pos = geo.attributes.position, uv = new Float32Array(pos.count * 2);
  for (let i = 0; i < pos.count; i++) { uv[i * 2] = pos.getX(i); uv[i * 2 + 1] = pos.getY(i); }
  geo.setAttribute('uv', new T.BufferAttribute(uv, 2));
}

/** Fibre-optic stars: points on the ceiling panels that twinkle. */
function buildStars(g, lay, k) {
  const pts = G.starPoints(lay, G.starSeed(k));
  if (!pts.length) return;
  const pos = new Float32Array(pts.length * 3), col = new Float32Array(pts.length * 3);
  pts.forEach((s, i) => { pos[i * 3] = s.x; pos[i * 3 + 1] = s.y; pos[i * 3 + 2] = 1.62; col[i * 3] = col[i * 3 + 1] = col[i * 3 + 2] = 1; });
  const geo = new T.BufferGeometry();
  geo.setAttribute('position', new T.BufferAttribute(pos, 3)); geo.setAttribute('color', new T.BufferAttribute(col, 3));
  const m = new T.PointsMaterial({ size: 1.3, map: R3.tex.pool, vertexColors: true, transparent: true, depthWrite: false, blending: T.AdditiveBlending, toneMapped: false, color: 0xfff4dc });
  const P = new T.Points(geo, m); P.userData.ownMat = true; P.userData.tw = pts.map(s => s.tw); g.add(P); R3.stars.push(P);
}
let twinkleTimer = 0;
function twinkle() {
  clearTimeout(twinkleTimer);
  if (!R3.stars || !R3.stars.length || document.hidden) { twinkleTimer = setTimeout(twinkle, 600); return; }
  const t = performance.now() / 1000, th = state.light === 'theater';
  for (const P of R3.stars) {
    const c = P.geometry.attributes.color, tw = P.userData.tw;
    for (let i = 0; i < c.count; i++) { const v = (th ? 0.55 : 0.25) + (th ? 0.45 : 0.2) * (0.5 + 0.5 * Math.sin(t * (1.3 + tw[i] * 2.4) + tw[i] * 40)); c.setXYZ(i, v, v, v * 0.92); }
    c.needsUpdate = true;
  }
  requestRender();
  twinkleTimer = setTimeout(twinkle, REDUCED ? 2000 : 90);
}

// ------------------------------------------------------------ staging
// Real props and a real floor, so a picture of the room reads as a room: a herringbone oak floor, a plant and a vase on
// the nightstands, pillows on the bed. All Poly Haven, CC0 (assets/staging/LICENSE.md). Staging only: none of it is part
// of the design, the share link or the build. Loaded after the room has drawn; a phone gets the floor only.
const STAGE = { want: false, floor: null, plant: null, vase: null, pillows: null };
const rdAsset = n => (window.RD_ASSETS && window.RD_ASSETS[n]) || ('assets/' + n);
async function loadStaging() {
  if (STAGE.want) return; STAGE.want = true;
  try {
    const tl = new T.TextureLoader(), tex = (n, srgb) => new Promise(res => tl.load(rdAsset(n), t => { t.wrapS = t.wrapT = T.RepeatWrapping; if (srgb) t.colorSpace = T.SRGBColorSpace; t.anisotropy = 8; res(t); }, undefined, () => res(null)));
    const [d, nm, r] = await Promise.all([tex('rd-floor-diff.jpg', true), tex('rd-floor-nor.jpg'), tex('rd-floor-rough.jpg')]);
    if (d) { STAGE.floor = { map: d, normalMap: nm, roughnessMap: r }; scheduleScene(); }
    if (LOW) return;
    const { GLTFLoader } = await import('three/addons/loaders/GLTFLoader.js');
    const gl = new GLTFLoader(), model = n => new Promise(res => gl.load(rdAsset(n), g => res(g.scene), undefined, () => res(null)));
    const [plant, vase, pillows, alpha] = await Promise.all([model('rd-plant.gltf'), model('rd-vase.gltf'), model('rd-pillows.gltf'), tex('rd-plant-leaves_alpha_1k.png')]);
    if (plant) plant.traverse(o => { if (o.isMesh && /leaves/.test(o.material.name)) { o.material.alphaMap = alpha; o.material.alphaTest = 0.5; o.material.transparent = false; o.material.side = T.DoubleSide; } });
    for (const g of [plant, vase, pillows]) if (g) g.traverse(o => { if (o.isMesh) { o.castShadow = true; o.receiveShadow = true; } });
    Object.assign(STAGE, { plant, vase, pillows });
    scheduleScene();
  } catch (e) { /* staging is a nicety; the room works without it */ }
}
/** A staging prop, scaled from metres to our inches, standing on a point. */
function placeProp(room, src, x, y, z, s, rotY) {
  if (!src) return null;
  const g = src.clone(true); g.scale.setScalar(39.37 * (s || 1)); g.position.set(x, y, z); g.rotation.y = rotY || 0;
  g.traverse(o => { o.userData.staging = true; }); room.add(g); R3.ctx.push(g); return g;
}

/** Context, not product: a stair under a sloped field, a bed, a desk, a table, a booth seat. */
function buildContext(room, W, L, H) {
  const furn = fabricMat('linen', LIGHT ? '#E2DCD2' : '#4A4642', 'plain'), furn2 = stdMat({ color: LOOK.furn2, roughness: 0.55 });
  const wood = stdMat({ color: LIGHT ? 0x8a6a4e : 0x3a2c22, map: R3.tex.grain, roughness: 0.5 }); wood.userData.ownMat = true;
  const duvet = fabricMat('linen', LIGHT ? '#F4F1EB' : '#6A645E', 'plain'), throwM = fabricMat('velvet', LIGHT ? '#B9AE9F' : '#3A3B3D', 'plain');
  // soft, rounded low-poly pieces: a rounded box when the module is there, a plain box when it is not
  const box = (w, h, d, r) => RBOX ? new RBOX(w, h, d, LOW ? 2 : 3, Math.min(r || 0.8, w / 2.2, h / 2.2, d / 2.2)) : new T.BoxGeometry(w, h, d);
  const col = (g) => { const n = g.attributes.position.count, c = new Float32Array(n * 3).fill(1); g.setAttribute('color', new T.BufferAttribute(c, 3)); return g; };
  R3.ctx = [];
  const add = (w, h, d, x, y, z, m, r) => { const b = new T.Mesh(col(box(w, h, d, r)), m || furn); b.position.set(x, y, z); b.castShadow = true; b.receiveShadow = true; room.add(b); R3.ctx.push(b); return b; };
  const kind = state.room.kind;
  const hbw = state.walls.front.headboard;
  if (kind === 'bedroom' || kind === 'mirrorbed' || kind === 'headboard' || hbw) {
    const bs = hbw ? G.bedSize(hbw.bed) : null;
    const bw = bs ? bs.w : Math.min(76, W * 0.46), bl = bs ? bs.l : 84, cx = W / 2, z0 = hbw ? 3.5 : 4;
    // the bed base: in the headboard's own fabric and style when a matching base is chosen
    const zd = state.walls.front.zones[0], baseM = hbw && hbw.base ? fabricMat(zd.family || 'velvet', zd.color, zd.type === 'channels' ? 'channel' : zd.surface) : furn;
    add(bw + 6, 12, bl + 4, cx, 7, z0 + bl / 2, baseM, 2.2);                    // upholstered frame
    add(bw - 2, 9, bl - 4, cx, 16.5, z0 + bl / 2 + 1, duvet, 3);                // mattress and duvet
    // a throw across the foot of the bed: real cloth, lying on the duvet and falling over both sides in soft folds
    {
      const drop = 9, span = bw - 2 + 0.8 + 2 * drop, len = bl * 0.3, geo = new T.PlaneGeometry(span, len, 72, 14), P = geo.attributes.position;
      for (let i = 0; i < P.count; i++) {
        // the duvet is (bw - 2) wide and its top sits at 21: the throw lies just above it and only ever folds upward
        const x = P.getX(i), zz = P.getY(i), edge = (bw - 2) / 2 + 0.4, over = Math.abs(x) - edge;
        const fold = 0.5 + 0.3 * Math.sin(x * 0.09 + zz * 0.21) + 0.2 * Math.sin(x * 0.23 - zz * 0.13);
        if (over <= 0) P.setXYZ(i, x, 21.6 + fold * 0.7, zz);
        else { const a = Math.min(1, over / 2.4), out = 0.9 + 0.5 * Math.sin(zz * 0.18 + over * 0.4); P.setXYZ(i, Math.sign(x) * (edge + out * a + 0.3), 21.6 + fold * 0.7 * (1 - a) - over * (0.3 + 0.7 * a), zz); }
      }
      geo.computeVertexNormals(); col(geo);
      const tm = throwM.clone(); tm.side = T.DoubleSide; tm.userData.ownMat = true;
      const throwMesh = new T.Mesh(geo, tm); throwMesh.position.set(cx, 0, z0 + bl * 0.74); throwMesh.castShadow = true; throwMesh.receiveShadow = true; throwMesh.userData.ownMat = true;
      room.add(throwMesh); R3.ctx.push(throwMesh);
    }
    for (const s of [-1, 1]) { add(bw * 0.42, 9, 6, cx + s * bw * 0.24, 25, z0 + 9, duvet, 2.8); add(bw * 0.34, 7.5, 5, cx + s * bw * 0.2, 23.5, z0 + 14, furn, 2.4); }
    for (const s of [-1, 1]) {                                                    // nightstands: plinth, body, a drawer line
      const x = cx + s * (bw / 2 + 17);
      add(18, 2, 14, x, 1, 10, furn2, 0.4); add(22, 18, 16, x, 12, 10, wood, 0.6); add(20.5, 0.4, 0.2, x, 13, 18.05, furn2, 0.1);
    }
    add(Math.min(56, bw * 0.75), 16, 16, cx, 8, z0 + bl + 14, furn, 1.6);       // a bench at the foot
    // staging: a plant on one nightstand, a vase on the other, a pair of pillows against the bolsters
    placeProp(room, STAGE.plant, cx - (bw / 2 + 17), 21, 10, 0.9, 0.6);
    placeProp(room, STAGE.vase, cx + (bw / 2 + 17) + 3, 21, 8, 1.1, 0);
    const pil = placeProp(room, STAGE.pillows, cx, 22.5, z0 + 22, 1.0, Math.PI);
    // Poly Haven's pillows are a loud chevron; ours take a plain velvet that sits with the wall: the wall colour, lifted
    if (pil) { const pc = hexColor(zd.color || '#B9AE9F').lerp(new T.Color(0xf2ece2), 0.45);
      const key = pc.getHexString(); STAGE.pilMats = STAGE.pilMats || {};
      pil.traverse(o => { if (o.isMesh) { const m = STAGE.pilMats[key] || (STAGE.pilMats[key] = Object.assign(o.material.clone(), { map: null, roughness: 0.9 })); m.color.copy(pc); o.material = m; } }); }
    // a framed print on the wall opposite, so a mirror has something of the room to show
    const art = canvasTex(256, 176, (g2, w2, h2) => {
      const gr = g2.createLinearGradient(0, 0, w2, h2); gr.addColorStop(0, '#d9cbb3'); gr.addColorStop(1, '#8c7a63'); g2.fillStyle = gr; g2.fillRect(0, 0, w2, h2);
      const r2 = rng(5); for (let i = 0; i < 7; i++) { g2.fillStyle = ['#3b4a45', '#b49c78', '#efe8dc', '#5c3b26'][i % 4]; g2.globalAlpha = 0.75; g2.beginPath(); g2.ellipse(r2() * w2, r2() * h2, 20 + r2() * 60, 12 + r2() * 40, r2() * 3, 0, 7); g2.fill(); }
      g2.globalAlpha = 1;
    }, null, true);
    art.wrapS = art.wrapT = T.ClampToEdgeWrapping; art.repeat.set(1, 1);
    add(62, 30, 18, W / 2, 15, L - 9.5, wood, 0.8);                               // a low dresser under it
    add(58, 0.4, 0.2, W / 2, 16, L - 18.6, furn2, 0.1);
    const frame = add(44, 32, 1.6, W / 2, 50, L - 0.9, stdMat({ color: 0x1e1c1a, roughness: 0.5 }), 0.3); frame.castShadow = false;
    const pic = new T.Mesh(new T.PlaneGeometry(40, 28), new T.MeshStandardMaterial({ map: art, roughness: 0.85 })); pic.userData.ownMat = true;
    pic.position.set(W / 2, 50, L - 1.75); pic.rotation.y = Math.PI; room.add(pic); R3.ctx.push(pic);
  } else if (kind === 'office' || kind === 'corporate') {
    const cx = W / 2; add(66, 1.6, 30, cx, 29.2, 44, furn2); for (const s of [-1, 1]) add(2, 28.4, 26, cx + s * 31, 14.2, 44, furn2);
    add(22, 18, 22, cx, 9, 70, furn);
  } else if (kind === 'conference') {
    const tl = Math.min(L * 0.55, 192); add(48, 2, tl, W / 2, 29, L / 2 + 10, furn2); add(20, 28, tl * 0.7, W / 2, 14, L / 2 + 10, furn);
  } else if (kind === 'restaurant') {
    add(W - 40, 18, 22, W / 2, 9, 12, furn2);
    for (let i = 0; i < 4; i++) { const x = W * (i + 0.5) / 4; add(30, 1.6, 30, x, 29, 46, furn2); add(4, 28, 4, x, 14, 46, furn2); }
  }
  // a tiered floor: carpeted platforms with a fascia, step lights, and rows of seats
  const tiers = G.tierSpans(state.room.levels, L);
  if (tiers.length) {
    const carpet = stdMat({ color: LIGHT ? 0x8c7f72 : 0x3a332d, map: R3.tex.carpet, roughness: 1 }); carpet.userData.ownMat = true;
    const fascia = stdMat({ color: LIGHT ? 0x5a4c40 : 0x221d19, roughness: 0.8 }); fascia.userData.ownMat = true;
    const stepLight = new T.MeshBasicMaterial({ color: 0xffd9a8, toneMapped: false });
    for (const t of tiers) {
      const d = L - t.z0, b = new T.Mesh(new T.BoxGeometry(W - 0.5, t.h, d), carpet); b.position.set(W / 2, t.h / 2, t.z0 + d / 2); b.receiveShadow = true; b.castShadow = true; room.add(b);
      const f = new T.Mesh(new T.BoxGeometry(W - 0.5, t.h, 0.6), fascia); f.position.set(W / 2, t.h / 2, t.z0 - 0.3); room.add(f);
      if (state.room.levels.lights) for (let x = 18; x < W - 12; x += 30) { const l = new T.Mesh(new T.BoxGeometry(3, 0.8, 0.2), stepLight); l.position.set(x, t.h - 3, t.z0 - 0.7); room.add(l); }
    }
    if (state.room.levels.seats) {
      const leather = fabricMat('leather', LIGHT ? '#7A4A2A' : '#5C3B26', 'plain');
      const rowAt = [[Math.max(30, tiers[0].z0 - 60), 0]].concat(tiers.map(t => [t.z0 + Math.min(40, (t.z1 - t.z0) * 0.45), t.h]));
      const per = Math.max(1, Math.floor((W - 36) / 34));
      for (const [z, y0] of rowAt) {
        if (z + 30 > L) continue;
        for (let i = 0; i < per; i++) {
          const x = W / 2 + (i - (per - 1) / 2) * 34;
          add(30, 16, 34, x, y0 + 8, z, leather, 3); add(30, 22, 9, x, y0 + 26, z + 14, leather, 3.5);
          for (const sx of [-1, 1]) add(5, 8, 32, x + sx * 14.5, y0 + 19, z + 1, leather, 2);
        }
      }
    }
  }
  // a stair mass under any wall whose field follows a stair
  for (const w of WALLS) {
    const sl = state.walls[w.key].slope;
    if (!sl || !sl.bottom) continue;
    const f = wallFrame(w.key), n0 = new T.Vector3(...f.n), u0 = new T.Vector3(...f.u), o = new T.Vector3(...f.o);
    const [yl, yr] = sl.bottom, run = f.width, rise = Math.abs(yr - yl), steps = Math.max(2, Math.round(rise / 7.5)), tread = run / steps, depth = Math.min(40, f.depth * 0.9);
    const m = stdMat({ color: LIGHT ? 0xc9a77c : 0x5a4636, map: R3.tex.wood, roughness: 0.55 }); m.userData.ownMat = true;
    for (let i = 0; i < steps; i++) {
      const xa = i * tread, h = (yl < yr ? (i + 1) : (steps - i)) * rise / steps - 4;
      if (h <= 0) continue;
      const b = new T.Mesh(new T.BoxGeometry(tread, h, depth), m);
      const c = o.clone().addScaledVector(u0, xa + tread / 2).addScaledVector(n0, depth / 2); c.y = h / 2;
      b.position.copy(c); b.quaternion.setFromRotationMatrix(new T.Matrix4().makeBasis(u0, new T.Vector3(0, 1, 0), n0)); b.castShadow = true; b.receiveShadow = true; room.add(b);
    }
  }
}

function buildScene() {
  if (!R3.ready) return;
  const scene = R3.scene;
  if (R3.room) { scene.remove(R3.room); disposeGroup(R3.room); }
  const room = new T.Group(); R3.room = room; R3.walls = {}; R3.screens = []; R3.windows = []; R3.paints = []; R3.downlights = []; R3.glows = []; R3.stars = []; R3.mirrors = [];
  const W = state.room.W, L = state.room.L, H = state.room.H;
  // floor
  const wood = state.room.floor === 'wood';
  const floorM = stdMat({ color: wood ? LOOK.floorWood : LOOK.floorCarpet, map: wood ? R3.tex.wood : R3.tex.carpet, roughness: wood ? 0.42 : 1, metalness: 0, aoMap: aoTex(W, L, [['l', 16, 0.45], ['r', 16, 0.45], ['b', 16, 0.45], ['t', 16, 0.45]]), aoMapIntensity: 1 });
  if (wood && STAGE.floor) {   // the real oak herringbone, one tile to about five feet
    const rep = t => { if (!t) return null; const c = t.clone(); c.repeat.set(W / 60, L / 60); c.needsUpdate = true; return c; };
    floorM.map = rep(STAGE.floor.map); floorM.normalMap = rep(STAGE.floor.normalMap); floorM.roughnessMap = rep(STAGE.floor.roughnessMap);
    floorM.color.set(0xffffff); floorM.roughness = 1; floorM.normalScale.set(0.6, 0.6);
  }
  const floor = new T.Mesh(new T.PlaneGeometry(W, L), floorM); floor.userData.ownMat = true;
  floor.rotation.x = -Math.PI / 2; floor.position.set(W / 2, 0, L / 2); floor.receiveShadow = true; room.add(floor);
  // ceiling, with a cove and downlights unless the ceiling itself is panelled
  const ceilM = stdMat({ color: LOOK.ceilDay, roughness: 0.95, aoMap: aoTex(W, L, [['l', 14, 0.4], ['r', 14, 0.4], ['b', 14, 0.4], ['t', 14, 0.4]]), aoMapIntensity: 1 });
  const ceil = new T.Mesh(new T.PlaneGeometry(W, L), ceilM); ceil.userData.ownMat = true;
  ceil.rotation.x = Math.PI / 2; ceil.position.set(W / 2, H, L / 2); room.add(ceil); R3.ceiling = ceil;
  const ceilPanelled = layouts.ceiling && layouts.ceiling.pieces.length > 0;
  const cove = new T.Group(), inset = Math.min(14, W * 0.08), stripM = new T.MeshBasicMaterial({ color: 0xffc58a, toneMapped: false });
  if (!ceilPanelled) {
    for (const [x, z, sx, sz] of [[W / 2, inset, W - 2 * inset, 1.4], [W / 2, L - inset, W - 2 * inset, 1.4], [inset, L / 2, 1.4, L - 2 * inset], [W - inset, L / 2, 1.4, L - 2 * inset]]) {
      const m = new T.Mesh(new T.PlaneGeometry(sx, sz), stripM); m.rotation.x = Math.PI / 2; m.position.set(x, H - 0.05, z); cove.add(m);
    }
    const dlM = new T.MeshBasicMaterial({ color: 0xfff6e6, toneMapped: false }); R3.downlights.push(dlM);
    const dlGeo = new T.CircleGeometry(2.4, 24), nx = W > 150 ? 3 : 2, nz = L > 200 ? 3 : 2;
    for (let i = 0; i < nx; i++) for (let j = 0; j < nz; j++) {
      const d = new T.Mesh(dlGeo, dlM); d.rotation.x = Math.PI / 2;
      d.position.set(W * (i + 1) / (nx + 1), H - 0.06, L * (j + 1) / (nz + 1)); cove.add(d);
    }
  }
  cove.userData.strip = stripM;
  room.add(cove); R3.cove = cove;
  // walls and the ceiling surface
  const paintM = stdMat({ color: LOOK.paintDay, roughness: 0.93 });
  const baseM = stdMat({ color: LOOK.base, roughness: LIGHT ? 0.45 : 0.6 });
  for (const w of SURFACES) {
    const f = wallFrame(w.key), lay = layouts[w.key];
    const g = new T.Group();
    const u = new T.Vector3(...f.u), up = new T.Vector3(...f.v), n = new T.Vector3(...f.n);
    g.matrixAutoUpdate = false;
    g.matrix.makeBasis(u, up, n).setPosition(new T.Vector3(...f.o));
    if (!isCeil(w.key)) {
      const wm = paintM.clone(); wm.userData.ao = true; R3.paints.push(wm);
      wm.aoMap = aoTex(f.width, H, [['l', 10, 0.42], ['r', 10, 0.42], ['b', 8, 0.35], ['t', 8, 0.32]]); wm.aoMapIntensity = 1;
      const plane = new T.Mesh(new T.PlaneGeometry(f.width, H), wm); plane.userData.ownMat = true;
      plane.position.set(f.width / 2, H / 2, 0); plane.receiveShadow = true; g.add(plane);
      const bh = LIGHT ? 5.5 : 4, bd = LIGHT ? 0.75 : 0.6;
      const base = new T.Mesh(new T.BoxGeometry(f.width, bh, bd), baseM); base.position.set(f.width / 2, bh / 2, bd / 2); base.receiveShadow = true; g.add(base);
      if (LIGHT) {
        // crown molding: a stepped profile under the ceiling line
        for (const [hh, dd, yy] of [[4.2, 1.1, H - 2.1], [2.2, 2.4, H - 1.1], [0.8, 3.4, H - 0.4]]) {
          const c = new T.Mesh(new T.BoxGeometry(f.width, hh, dd), baseM); c.position.set(f.width / 2, yy, dd / 2); c.receiveShadow = true; g.add(c);
        }
      }
      buildOpenings(g, lay, w.key);
    }
    buildSurface(g, lay, w.key);
    if (isCeil(w.key)) buildStars(g, lay, w.key);
    g.matrixWorldNeedsUpdate = true;
    room.add(g);
    R3.walls[w.key] = { group: g, o: new T.Vector3(...f.o), n };
  }
  buildContext(room, W, L, H);
  scene.add(room);
  scene.background = new T.Color(LOOK.bg);
  // light rig sized to the room
  const C = new T.Vector3(W / 2, H / 2, L / 2), M = Math.max(W, L, H);
  for (const [i, [x, z]] of [[W / 2, inset + 10], [W / 2, L - inset - 10], [inset + 10, L / 2], [W - inset - 10, L / 2]].entries()) R3.coves[i].position.set(x, H - 6, z);
  R3.screenLight.position.set(W / 2, H * 0.4, Math.min(L * 0.25, 60));
  const sc = R3.key.shadow.camera;
  sc.left = -M * 0.8; sc.right = M * 0.8; sc.top = M * 0.8; sc.bottom = -M * 0.8; sc.near = 1; sc.far = M * 4; sc.updateProjectionMatrix();
  R3.center = C;
  placeKey(ui.view === 'room' ? null : ui.wall);
  applyLighting();
  requestRender();
  if (R3.stars.length) twinkle();
  loadStaging();
}
/** Capture the room for the mirrors to reflect, from eye height in the middle of the room. */
let cubeQueued = 0;
function updateMirrors() {
  if (REFL) return; // planar reflectors render live; the captured cube is only the fallback
  clearTimeout(cubeQueued);
  cubeQueued = setTimeout(() => {
    if (!R3.ready || !R3.cubeCam || !R3.mirrors || !R3.mirrors.length) return;
    R3.mirrors.forEach(m => { m.visible = false; });
    for (const k in R3.walls) R3.walls[k].group.visible = true;
    if (R3.ceiling) R3.ceiling.visible = true;
    // capture from where the viewer stands (kept inside the room), so the mirror shows what is behind them
    const c = R3.camera.position, W = state.room.W, L = state.room.L, H = state.room.H;
    R3.cubeCam.position.set(Math.min(W - 6, Math.max(6, c.x)), Math.min(H - 6, Math.max(20, c.y)), Math.min(L - 6, Math.max(6, c.z)));
    R3.cubeCam.updateMatrixWorld(true);
    R3.cubeCam.update(R3.renderer, R3.scene);
    R3.cubeRT.texture.needsPMREMUpdate = true;
    R3.mirrors.forEach(m => { m.visible = true; });
    requestRender();
  }, 60);
}

function placeKey(k) {
  if (!R3.ready) return;
  const W = state.room.W, L = state.room.L, H = state.room.H, C = new T.Vector3(W / 2, H * 0.4, L / 2), M = Math.max(W, L, H);
  let dir;
  if (k && !isCeil(k)) {
    const f = wallFrame(k), n = new T.Vector3(...f.n), u = new T.Vector3(...f.u);
    // light rakes across the wall from one side, the cue that makes padding read
    dir = n.clone().multiplyScalar(0.48).add(new T.Vector3(0, 0.62, 0)).addScaledVector(u, -0.9).normalize();
  } else dir = new T.Vector3(-0.4, 1, 0.55).normalize();
  R3.key.position.copy(C).addScaledVector(dir, M * 1.6);
  R3.key.target.position.copy(C); R3.key.target.updateMatrixWorld();
  R3.fill.position.copy(C).addScaledVector(new T.Vector3(-dir.x, 0.35, -dir.z), M * 1.6);
  R3.fill.target.position.copy(C); R3.fill.target.updateMatrixWorld();
}

function applyLighting() {
  if (!R3.ready) return;
  const th = state.light === 'theater';
  R3.hemi.intensity = th ? 0.25 : (LIGHT ? 0.95 : 1.2);
  R3.hemi.color.set(th ? 0xdfe2ea : 0xfff6ee);
  R3.hemi.groundColor.set(th ? 0x1c1916 : (LIGHT ? 0xbdb3a6 : 0x9a8f84));
  R3.key.intensity = th ? 0.45 : (LIGHT ? 2.7 : 2.5);
  R3.key.shadow.radius = LIGHT ? 7 : 4;
  R3.fill.intensity = th ? 0.08 : (LIGHT ? 0.9 : 0.7);
  R3.coves.forEach(l => { l.visible = th; });
  R3.screenLight.visible = th;
  if (R3.cove) R3.cove.userData.strip.color.set(th ? 0xffc58a : (LIGHT ? 0xd9d4cc : 0x6b625a));
  (R3.screens || []).forEach(m => { m.emissiveIntensity = th ? 0.75 : 0.12; });
  (R3.windows || []).forEach(m => { m.emissiveIntensity = th ? 0.08 : (LIGHT ? 0.85 : 0.6); });
  (R3.paints || []).forEach(m => m.color.set(th ? LOOK.paintNight : LOOK.paintDay));
  (R3.downlights || []).forEach(m => m.color.set(th ? 0x3a3027 : 0xfff6e6));
  (R3.glows || []).forEach(m => { m.opacity = Math.min(1, (m.userData.level || 0.6) * (th ? 1.0 : (LIGHT ? 0.42 : 0.55))); });
  R3.renderer.toneMappingExposure = th ? 1.2 : (LIGHT ? 0.98 : 1.05);
  if (R3.ceiling) { R3.ceiling.material.color.set(th ? LOOK.ceilNight : LOOK.ceilDay); R3.ceiling.material.emissive.set(th || !LIGHT ? 0x000000 : 0x6e6c68); }
  R3.scene.background.set(th && !LIGHT ? 0x0b0b0b : LOOK.bg);
  R3.scene.environmentIntensity = th ? 0.1 : (LIGHT ? 0.38 : 0.3);
  updateMirrors();
  if (PHOTO && PHOTO.on) photoCameraMoved();   // a light or design change re-renders the photo
}

let sceneQueued = false;
function scheduleScene() {
  if (sceneQueued) return; sceneQueued = true;
  requestAnimationFrame(() => { sceneQueued = false; buildScene(); });
}

function requestRender() {
  if (!R3.ready || R3.pending) return;
  R3.pending = true;
  requestAnimationFrame(renderNow);
}
function cull(cam) {
  for (const k in R3.walls) {
    const w = R3.walls[k];
    w.group.visible = isCeil(k) ? cam.y < state.room.H : w.n.dot(cam.clone().sub(w.o)) > 0;
  }
  // furniture standing against a wall goes with that wall, so a camera behind it is never blocked by the back of a dresser
  for (const m of R3.ctx || []) {
    if (m.userData.wallK === undefined) {
      m.userData.wallK = null; let best = 30;
      for (const k in R3.walls) { if (isCeil(k)) continue; const w = R3.walls[k], d = w.n.dot(m.position.clone().sub(w.o)); if (d >= -1 && d < best) { best = d; m.userData.wallK = k; } }
    }
    const wk = m.userData.wallK; m.visible = !wk || !R3.walls[wk] || R3.walls[wk].group.visible;
  }
  const inside = cam.y < state.room.H;
  if (R3.ceiling) R3.ceiling.visible = inside;
  if (R3.cove) R3.cove.visible = inside;
}
function zoomBy(f) {
  if (!R3.ready) return;
  const c = R3.camera, t = R3.controls.target, d = c.position.clone().sub(t);
  const len = Math.min(R3.controls.maxDistance, Math.max(R3.controls.minDistance, d.length() * f));
  animateCamera(t.clone().add(d.setLength(len)), t.clone(), true);
}
function renderNow() {
  R3.pending = false;
  if (!R3.ready) return;
  if (PHOTO && PHOTO.on) {
    // while a photo is tracing, the canvas is the photo: only a real camera move hands it back to the live room
    const k = camKey();
    if (k !== PHOTO.camKey) { PHOTO.camKey = k; photoCameraMoved(); }
    if (!PHOTO.live) return;
  }
  cull(R3.camera.position);
  R3.renderer.render(R3.scene, R3.camera);
  R3.frames++;
  drawDims();
}

// Dimensions on request: the wall's width and height, and each opening's width, drawn over the 3D view.
function drawDims() {
  const svg = $('#dims');
  if (!svg) return;
  if (!ui.dims || ui.mode !== '3d' || !R3.ready) { if (svg.innerHTML) svg.innerHTML = ''; svg.hidden = true; return; }
  svg.hidden = false;
  const { w, h } = viewSize(), k = ui.view === 'room' ? 'front' : ui.wall, f = wallFrame(k), H = isCeil(k) ? state.room.L : state.room.H;
  const o = new T.Vector3(...f.o), u = new T.Vector3(...f.u), v = new T.Vector3(...f.v), n = new T.Vector3(...f.n);
  const at = (x, y, off) => { const p = o.clone().addScaledVector(u, x).addScaledVector(v, y).addScaledVector(n, off || 3).project(R3.camera); return [(p.x + 1) / 2 * w, (1 - p.y) / 2 * h, p.z]; };
  let s = '';
  const dim = (a, b, label) => {
    if (a[2] > 1 || b[2] > 1) return;
    const mx = (a[0] + b[0]) / 2, my = (a[1] + b[1]) / 2;
    s += '<line x1="' + a[0] + '" y1="' + a[1] + '" x2="' + b[0] + '" y2="' + b[1] + '"/>';
    const dx = b[0] - a[0], dy = b[1] - a[1], l = Math.hypot(dx, dy) || 1, nx = -dy / l * 5, ny = dx / l * 5;
    s += '<line x1="' + (a[0] - nx) + '" y1="' + (a[1] - ny) + '" x2="' + (a[0] + nx) + '" y2="' + (a[1] + ny) + '"/><line x1="' + (b[0] - nx) + '" y1="' + (b[1] - ny) + '" x2="' + (b[0] + nx) + '" y2="' + (b[1] + ny) + '"/>';
    const tw = label.length * 7.4 + 14;
    s += '<g transform="translate(' + mx + ' ' + my + ')"><rect x="' + (-tw / 2) + '" y="-11" width="' + tw + '" height="22" rx="11"/><text text-anchor="middle" dominant-baseline="central">' + esc(label) + '</text></g>';
  };
  dim(at(0, H * 0.02), at(f.width, H * 0.02), G.fmtFtIn(f.width));
  dim(at(f.width * 0.015, 0), at(f.width * 0.015, H), G.fmtFtIn(H));
  if (!isCeil(k)) for (const op of layouts[k].openings) { if (G.isBoxOpening(op.type) || op.type === 'riser') continue; const r = op.raw; dim(at(r.x0, r.y1 + 4), at(r.x1, r.y1 + 4), G.fmtFtIn(r.x1 - r.x0)); }
  svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
  svg.innerHTML = s;
}

// --- camera: the room is framed in the part of the stage the controls do not cover
function viewSize() { const host = $('#viewport'); return host ? { w: host.clientWidth, h: host.clientHeight } : { w: 0, h: 0 }; }
function fovV() { return PHONE() ? 52 : 44; }
function applyProjection() {
  const { w, h } = viewSize();
  if (!w || !h) return;
  const st = Math.min(R3.safe.top, h * 0.3), sb = Math.min(R3.safe.bottom, h * 0.7), sl = Math.min(R3.safe.left || 0, w * 0.5);
  const hv = Math.max(80, h - st - sb), yc = st + hv / 2;
  const F = 2 * Math.max(yc, h - yc), y0 = F / 2 - yc;
  const wv = Math.max(120, w - sl), xc = sl + wv / 2, Fw = 2 * Math.max(xc, w - xc), x0 = Fw / 2 - xc;
  const cam = R3.camera;
  cam.fov = 2 * Math.atan(Math.tan(fovV() * Math.PI / 360) * F / hv) * 180 / Math.PI;
  cam.aspect = Fw / F;
  cam.setViewOffset(Fw, F, x0, y0, w, h);
  cam.updateProjectionMatrix();
  R3.visible = { w: wv, hv };
}
function fitDistance(width, height) {
  const v = Math.tan(fovV() * Math.PI / 360), vis = R3.visible || viewSize();
  const aspect = vis.w / (vis.hv || vis.h);
  const dv = (height / 2) / v * 1.34;
  const dh = (width / 2) / (v * aspect) * 1.16;
  return Math.max(dv, dh);
}
function ease(k) { return k >= 1 ? 1 : 1 - Math.pow(2, -10 * k); }
function animateCamera(pos, target, animate) {
  if (!R3.ready) return;
  const c = R3.camera, ctl = R3.controls;
  R3.tween = null; R3.userMove = false;
  if (!animate || REDUCED) { c.position.copy(pos); ctl.target.copy(target); ctl.update(); requestRender(); updateMirrors(); return; }
  // swing around the room's centre rather than cutting through it
  const Cc = new T.Vector3(state.room.W / 2, 0, state.room.L / 2);
  const cyl = (p) => ({ a: Math.atan2(p.z - Cc.z, p.x - Cc.x), r: Math.hypot(p.x - Cc.x, p.z - Cc.z), y: p.y });
  const A = cyl(c.position), B = cyl(pos);
  let da = B.a - A.a; while (da > Math.PI) da -= 2 * Math.PI; while (da < -Math.PI) da += 2 * Math.PI;
  const t0 = ctl.target.clone(), start = performance.now(), dur = 1100, id = {};
  R3.tween = id;
  const step = (now) => {
    if (R3.tween !== id) return;
    const k = Math.min(1, (now - start) / dur), e = ease(k);
    const a = A.a + da * e, r = A.r + (B.r - A.r) * e, y = A.y + (B.y - A.y) * e;
    c.position.set(Cc.x + Math.cos(a) * r, y, Cc.z + Math.sin(a) * r);
    ctl.target.lerpVectors(t0, target, e); ctl.update(); renderNow();
    if (k < 1) requestAnimationFrame(step); else { R3.tween = null; updateMirrors(); }
  };
  requestAnimationFrame(step);
}
function wallPose(k) {
  const H = state.room.H, W = state.room.W, L = state.room.L;
  if (isCeil(k)) return { pos: new T.Vector3(W / 2, Math.max(30, H * 0.3), L * 0.96), target: new T.Vector3(W / 2, H, L * 0.42), up: true };
  const f = wallFrame(k);
  const o = new T.Vector3(...f.o), u = new T.Vector3(...f.u), n = new T.Vector3(...f.n);
  const center = o.clone().addScaledVector(u, f.width / 2).setY(H * 0.5);
  const dist = fitDistance(f.width, H);
  // straight on, so zooming in dollies toward the middle of the wall and never drifts to one side
  return { pos: center.clone().addScaledVector(n, dist).setY(H * 0.54), target: center.clone().setY(H * 0.47) };
}
function roomPose() {
  const W = state.room.W, L = state.room.L, H = state.room.H, m = Math.max(W, L);
  if (state.room.kind === 'hallway' || L / W >= 3.2) return { pos: new T.Vector3(W / 2, 62, L - 6), target: new T.Vector3(W / 2, 54, 0) };
  return { pos: new T.Vector3(W / 2 + m * 0.75, H + m * 0.6, L / 2 + m * 0.85), target: new T.Vector3(W / 2, H * 0.35, L / 2) };
}
// Inside the room the camera may tilt right up to the ceiling; it never rolls or flips (OrbitControls keeps up = +y).
function setPolar(up) {
  const inside = ui.view !== 'room';
  R3.controls.maxPolarAngle = up ? Math.PI * 0.97 : inside ? Math.PI * 0.9 : Math.PI * 0.495;
  R3.controls.minPolarAngle = up ? Math.PI * 0.45 : inside ? Math.PI * 0.08 : 0;
}
/** Keep the camera inside the room when looking at a wall or the ceiling: never below the floor, never above the ceiling. */
function clampCamera() {
  if (!R3.ready || ui.view === 'room' || !R3.userMove) return; // only the visitor's own drag or zoom, never a scripted camera move
  // keep the eye between floor and ceiling; when a tilt would push it through, hold the eye and move the pivot
  // along the same line of sight instead, so dragging up keeps turning the view toward the ceiling
  const c = R3.camera.position, t = R3.controls.target, H = state.room.H, lo = isCeil(ui.wall) ? 4 : Math.min(42, H * 0.4), hi = H - 4; // the floor limit is a seated eye height, so the eye never sinks into the bed or the seats
  if (c.y >= lo && c.y <= hi) return;
  const dir = t.clone().sub(c), r = dir.length() || 1; dir.divideScalar(r);
  c.y = Math.max(lo, Math.min(hi, c.y));
  let reach = r;
  if (dir.y > 1e-3) reach = Math.min(reach, (H - 1 - c.y) / dir.y);
  if (dir.y < -1e-3) reach = Math.min(reach, (1 - c.y) / dir.y);
  t.copy(c).addScaledVector(dir, Math.max(12, reach));
}
function focusWall(k, animate) {
  if (!R3.ready) return;
  ui.view = 'wall';
  const p = wallPose(k);
  setPolar(!!p.up);
  placeKey(k); applyLighting();
  animateCamera(p.pos, p.target, animate);
}
function viewRoom(animate) {
  if (!R3.ready) return;
  ui.view = 'room';
  const p = roomPose();
  setPolar(false);
  placeKey(null); applyLighting();
  animateCamera(p.pos, p.target, animate);
}
function refocus(animate) { if (ui.view === 'room') viewRoom(animate); else focusWall(ui.wall, animate); }

// The controls overlap the stage; measure how much so the room sits clear of them.
function measureSafe() {
  const host = $('#viewport'); if (!host) return { top: 0, bottom: 0, left: 0 };
  const hr = host.getBoundingClientRect();
  let top = 0, bottom = 0, left = 0;
  for (const el of $$('[data-overlay]')) {
    const r = el.getBoundingClientRect(), cs = getComputedStyle(el);
    if (!r.height || cs.display === 'none' || cs.visibility === 'hidden') continue;
    if (r.bottom <= hr.top || r.top >= hr.bottom || r.right <= hr.left || r.left >= hr.right) continue;
    if (el.dataset.overlay === 'left') { left = Math.max(left, r.right - hr.left + 12); continue; }
    if (r.height > r.width * 1.5 && r.width < hr.width * 0.3) continue; // a side stack, not a band
    if (el.dataset.overlay === 'bottom') bottom = Math.max(bottom, hr.bottom - r.top + 8);
    else top = Math.max(top, r.bottom - hr.top + 6);
  }
  return { top, bottom, left };
}
let chromeTimer = 0;
function setSafeVars(s) {
  const st = document.querySelector('.stage');
  if (st) { st.style.setProperty('--safe-top', Math.round(s.top) + 'px'); st.style.setProperty('--safe-bottom', Math.round(s.bottom) + 'px'); st.style.setProperty('--safe-left', Math.round(s.left) + 'px'); }
}
function setOverlayKind() { const stu = $('#studio'); if (stu && SHELL === 'C') stu.dataset.overlay = PHONE() ? 'bottom' : 'left'; }
function onChromeChange() {
  setOverlayKind();
  clearTimeout(chromeTimer);
  chromeTimer = setTimeout(() => {
    const s = measureSafe();
    setSafeVars(s);
    if (!R3.ready) return;
    if (Math.abs(s.top - R3.safe.top) < 4 && Math.abs(s.bottom - R3.safe.bottom) < 4 && Math.abs(s.left - (R3.safe.left || 0)) < 4) return;
    R3.safe = s; applyProjection(); refocus(true);
  }, 300);
}

function stampAndSave(src, name, caption) {
  const c = document.createElement('canvas');
  c.width = src.width; c.height = src.height;
  const g = c.getContext('2d'); g.fillStyle = LIGHT ? '#F4F2EE' : '#0B0B0B'; g.fillRect(0, 0, c.width, c.height); g.drawImage(src, 0, 0, c.width, c.height);
  const s = Math.max(1, c.width / 1200), pad = 28 * s;
  const grd = g.createLinearGradient(0, c.height - 120 * s, 0, c.height); grd.addColorStop(0, 'rgba(0,0,0,0)'); grd.addColorStop(1, 'rgba(0,0,0,.66)');
  g.fillStyle = grd; g.fillRect(0, c.height - 120 * s, c.width, 120 * s);
  g.fillStyle = '#B49C78'; g.font = '600 ' + Math.round(26 * s) + 'px "Cormorant Garamond", Georgia, serif';
  g.fillText('Rivers Refined', pad, c.height - pad - 20 * s);
  g.fillStyle = '#F7F5F1'; g.font = '500 ' + Math.round(14 * s) + 'px Figtree, system-ui, sans-serif';
  g.fillText(caption, pad, c.height - pad);
  const a = document.createElement('a');
  a.href = c.toDataURL('image/png'); a.download = name;
  document.body.appendChild(a); a.click(); setTimeout(() => a.remove(), 500);
  R3.lastImage = { w: c.width, h: c.height };
}
function setShadowSize(n) {
  R3.key.shadow.mapSize.set(n, n);
  if (R3.key.shadow.map) { R3.key.shadow.map.dispose(); R3.key.shadow.map = null; }
}
/** HD image: the current view rendered at 2x to 3x with a sharper shadow map. The live view stays light. */
function saveImage() {
  if (!R3.ready) { toast('The room is still loading'); return; }
  const r = R3.renderer, pr = r.getPixelRatio(), { w, h } = viewSize(), sm = R3.key.shadow.mapSize.x;
  const maxTex = r.capabilities.maxTextureSize || 4096;
  const ratio = Math.max(pr, Math.min(3, Math.floor(Math.min(maxTex, 6144) / Math.max(w, h) * 10) / 10));
  try {
    setShadowSize(Math.min(4096, maxTex));
    r.setPixelRatio(ratio); r.setSize(w, h, false); renderNow();
    stampAndSave(r.domElement, 'rivers-refined-soft-wall.png', 'Soft wall design, planning picture');
  } finally {
    r.setPixelRatio(pr); r.setSize(w, h, false); setShadowSize(sm); renderNow();
  }
  toast('HD image saved');
}

// ------------------------------------------------------------ Photo render
// The same room, path traced: light bounces, soft shadows, real reflections in the mirrors, light from every lamp,
// LED and cove. It traces a copy of what is on screen, built only from what the camera can see (a culled wall left in
// the copy blocks the light: that was the black half-wall in the first test), so the geometry is the geometry the cut
// list comes from. A picture of the design, never a new design. three-gpu-pathtracer 0.0.23, MIT, loaded on first use.
var PHOTO = { on: false, busy: false, pt: null, ts: null, quad: null, dn: null, raf: 0, restart: 0, goal: LOW ? 160 : 320, saveAt: LOW ? 16 : 24, err: '' };
const PT_MODS = {};
async function ptModules() {
  if (!PT_MODS.pt) {
    const [pt, pass] = await Promise.all([import('three-gpu-pathtracer'), import('three/addons/postprocessing/Pass.js')]);
    PT_MODS.pt = pt; PT_MODS.Quad = pass.FullScreenQuad;
  }
  return PT_MODS;
}
const isShown = o => { let v = o.visible; o.traverseAncestors(a => { if (!a.visible) v = false; }); return v; };
/** One clean attribute set per mesh: the tracer merges every mesh into one buffer, so all must carry the same three. */
function ptGeometry(g0) {
  const g = g0.index ? g0.toNonIndexed() : g0, out = new T.BufferGeometry();
  const flat = a => { const arr = new Float32Array(a.count * a.itemSize); for (let i = 0; i < a.count; i++) for (let k = 0; k < a.itemSize; k++) arr[i * a.itemSize + k] = a.getComponent(i, k); return new T.BufferAttribute(arr, a.itemSize); };
  out.setAttribute('position', flat(g.attributes.position));
  if (g.attributes.normal) out.setAttribute('normal', flat(g.attributes.normal)); else out.computeVertexNormals();
  out.setAttribute('uv', g.attributes.uv ? flat(g.attributes.uv) : new T.BufferAttribute(new Float32Array(g.attributes.position.count * 2), 2));
  // vertex colour carries the padding's shading on every panel; meshes without one get plain white so all match
  const n = g.attributes.position.count, col = new Float32Array(n * 3).fill(1), ca = g.attributes.color;
  if (ca) for (let i = 0; i < n; i++) { col[i * 3] = ca.getX(i); col[i * 3 + 1] = ca.getY(i); col[i * 3 + 2] = ca.getZ(i); }
  out.setAttribute('color', new T.BufferAttribute(col, 3));
  for (const gr of g.groups) out.addGroup(gr.start, gr.count, gr.materialIndex);
  if (g !== g0) g.dispose();
  return out;
}
const MIRROR_PT = () => { const m = new T.MeshStandardMaterial({ color: 0xdfe5e4, metalness: 1, roughness: 0.025 }); m.userData.pt = true; return m; };
/** The tracer reads a texture at full detail, so a fine weave becomes grain. A softened, still tileable copy of each
 *  fabric map reads as cloth instead. Same wrap and filter settings as the original, which the tracer requires. */
const PT_SOFT = new Map();
function ptSoft(tex, px) {
  if (!tex || !tex.image || !tex.image.width) return tex;
  if (PT_SOFT.has(tex)) return PT_SOFT.get(tex);
  const im = tex.image, w = im.width, h = im.height, big = document.createElement('canvas'); big.width = w * 3; big.height = h * 3;
  const gb = big.getContext('2d'); gb.filter = 'blur(' + px + 'px)';
  for (let i = 0; i < 3; i++) for (let j = 0; j < 3; j++) gb.drawImage(im, i * w, j * h);
  const c = document.createElement('canvas'); c.width = w; c.height = h; c.getContext('2d').drawImage(big, w, h, w, h, 0, 0, w, h);
  const t = tex.clone(); t.image = c; t.source = new T.Source(c); t.needsUpdate = true;
  PT_SOFT.set(tex, t); return t;
}
function ptMaterial(m, mesh) {
  if (mesh.userData.mirror || (m && (m.isShaderMaterial || m.type === 'ShaderMaterial'))) return MIRROR_PT();
  if (m && m.vertexColors && m.map && (m.normalMap || m.sheen)) {   // an upholstered surface: velvet, linen or leather
    const f = m.clone(); f.map = ptSoft(m.map, 1.6); if (m.normalMap) f.normalMap = ptSoft(m.normalMap, 1.1); f.userData.pt = true; return f;
  }
  if (m && m.isMeshBasicMaterial) { const e = new T.MeshStandardMaterial({ color: 0x000000, emissive: m.color.clone(), emissiveIntensity: 5, roughness: 1 }); e.userData.pt = true; return e; }
  return m;
}
/** Stars are points in the live view; here each one is a tiny glowing bead, so the starlight ceiling lights itself. */
function ptStars(P, ts) {
  const pos = P.geometry.attributes.position, beads = [], bead = new T.IcosahedronGeometry(0.18, 1);
  P.updateMatrixWorld(true);
  for (let i = 0; i < pos.count; i++) {
    const g = bead.clone(), v = new T.Vector3().fromBufferAttribute(pos, i).applyMatrix4(P.matrixWorld);
    g.translate(v.x, v.y, v.z); beads.push(g);
  }
  if (!beads.length) return;
  const merged = BGU.mergeGeometries(beads.map(ptGeometry)); beads.forEach(b => b.dispose());
  const sm = new T.MeshStandardMaterial({ color: 0x000000, emissive: new T.Color(0xfff3dc), emissiveIntensity: 14 }); sm.userData.pt = true;
  ts.add(new T.Mesh(merged, sm));
}
function buildTraceScene(PTm) {
  const ts = new T.Scene(), th = state.light === 'theater';
  cull(R3.camera.position);
  R3.scene.updateMatrixWorld(true);
  R3.scene.traverse(o => {
    if (!isShown(o)) return;
    if (o.isPoints) { ptStars(o, ts); return; }
    if (o.isMesh && !o.isInstancedMesh) {
      const mat = Array.isArray(o.material) ? o.material.map(m => ptMaterial(m, o)) : ptMaterial(o.material, o);
      const c = new T.Mesh(ptGeometry(o.geometry), mat);
      o.matrixWorld.decompose(c.position, c.quaternion, c.scale);
      ts.add(c);
    } else if (o.isLight && (o.isPointLight || o.isSpotLight) && o.intensity > 0) {   // no directional sun: its hard window-frame stripe reads as a flaw in a photo
      const l = o.clone(); o.matrixWorld.decompose(l.position, l.quaternion, l.scale);
      if (o.target) { const t = new T.Object3D(); o.target.getWorldPosition(t.position); ts.add(t); l.target = t; }
      ts.add(l);
    }
  });
  const H = state.room.H;
  if (!th) {
    // Day: each recessed downlight becomes a real soft spot, and three grazers wash the wall being looked at, which is
    // what shows the padding and the seams the way a showroom light does.
    if (R3.cove && isShown(R3.cove)) R3.cove.traverse(o => {
      if (!(o.isMesh && o.geometry.type === 'CircleGeometry')) return;
      const p = new T.Vector3(); o.getWorldPosition(p);
      const s = new PTm.pt.PhysicalSpotLight(0xffe2c4, 5200, 0, Math.PI / 3.2, 0.95, 2); s.radius = 2.2;
      s.position.copy(p).add(new T.Vector3(0, -1, 0));
      const t = new T.Object3D(); t.position.copy(p).add(new T.Vector3(0, -100, 0)); ts.add(t); s.target = t; ts.add(s);
    });
    if (!isCeil(ui.wall)) {
      const f = wallFrame(ui.wall), o = new T.Vector3(...f.o), u = new T.Vector3(...f.u), n = new T.Vector3(...f.n);
      for (const k of [0.2, 0.5, 0.8]) {
        const at = o.clone().addScaledVector(u, f.width * k);
        const s = new PTm.pt.PhysicalSpotLight(0xffe0bd, 8000, 0, Math.PI / 4.5, 1, 2); s.radius = 1.6;
        s.position.copy(at).addScaledVector(n, 13).setY(H - 1.5);
        const t = new T.Object3D(); t.position.copy(at).setY(20); ts.add(t); s.target = t; ts.add(s);
      }
    }
  }
  // the open side of the room (the walls culled for the camera) lets in soft daylight, like a photographer's set
  const sky = new PTm.pt.GradientEquirectTexture(); sky.topColor.set(th ? 0x0d0f14 : 0xf4f1ec); sky.bottomColor.set(th ? 0x050506 : 0xd9d2c8); sky.update();
  ts.environment = sky; ts.environmentIntensity = th ? 0.04 : 0.8;
  ts.background = new T.Color(LOOK.bg);
  return ts;
}
function disposeTraceScene(ts) {
  if (!ts) return;
  // geometry is the trace copy's own; a material is disposed only if the copy made it (the rest belong to the live room)
  ts.traverse(o => { if (o.isMesh) { o.geometry.dispose(); (Array.isArray(o.material) ? o.material : [o.material]).forEach(m => { if (m.userData.pt) m.dispose(); }); } });
  if (ts.environment && ts.environment.dispose) ts.environment.dispose();
}
async function photoOpen() {
  if (!R3.ready || PHOTO.busy) { if (!R3.ready) toast('The room is still loading'); return; }
  if (ui.mode === 'wall') { saveDrawing(); return; }
  PHOTO.on = true; PHOTO.err = ''; renderPhotoCard('prep');
  try {
    PHOTO.busy = true;
    const PTm = await ptModules();
    await new Promise(r => requestAnimationFrame(() => setTimeout(r, 30)));   // let the card paint before the heavy step
    if (!PHOTO.on) return;
    photoTrace(PTm);
  } catch (e) {
    PHOTO.err = 'The photo render could not start on this device. The HD image still works.'; renderPhotoCard('error');
  } finally { PHOTO.busy = false; }
}
function photoTrace(PTm) {
  const r = R3.renderer;
  if (!PHOTO.pt) {
    const pt = new PTm.pt.WebGLPathTracer(r);
    pt.tiles.set(LOW ? 3 : 2, LOW ? 3 : 2); pt.minSamples = 1; pt.renderDelay = 0; pt.fadeDuration = 0; pt.bounces = 6; pt.filterGlossyFactor = 0.5;
    pt.renderScale = Math.min(1, (LOW ? 1 : 1.5) / r.getPixelRatio());
    const dm = new PTm.pt.DenoiseMaterial({ map: null, blending: T.NoBlending, premultipliedAlpha: r.getContextAttributes().premultipliedAlpha });
    PHOTO.quad = new PTm.Quad(dm); PHOTO.dn = dm;
    pt.renderToCanvasCallback = (target, renderer) => {
      // the denoiser does the most when the picture is youngest, and steps back as the samples gather
      const k = Math.min(1, pt.samples / PHOTO.goal);
      dm.map = target.texture; dm.sigma = 5 - 2.5 * k; dm.threshold = 0.035 - 0.015 * k; dm.kSigma = 1;
      const ac = renderer.autoClear; renderer.autoClear = false; PHOTO.quad.render(renderer); renderer.autoClear = ac;
    };
    PHOTO.pt = pt;
  }
  disposeTraceScene(PHOTO.ts);
  PHOTO.ts = buildTraceScene(PTm);
  PHOTO.pt.setScene(PHOTO.ts, R3.camera);
  PHOTO.live = false; PHOTO.camKey = camKey();
  cancelAnimationFrame(PHOTO.raf);
  let last = 0;
  const step = () => {
    if (!PHOTO.on) return;
    if (PHOTO.pt.samples < PHOTO.goal) { PHOTO.pt.renderSample(); PHOTO.raf = requestAnimationFrame(step); }
    const now = performance.now();
    if (now - last > 250 || PHOTO.pt.samples >= PHOTO.goal) { last = now; renderPhotoCard(PHOTO.pt.samples >= PHOTO.goal ? 'done' : 'run'); }
  };
  step();
}
/** The camera moved during a render: show the live room while it moves, then trace again from the new view. */
function photoCameraMoved() {
  PHOTO.live = true; cancelAnimationFrame(PHOTO.raf);
  renderPhotoCard('moving');
  clearTimeout(PHOTO.restart);
  PHOTO.restart = setTimeout(() => { if (PHOTO.on && PT_MODS.pt) photoTrace(PT_MODS); }, 450);
}
function photoClose() {
  if (!PHOTO.on) return;
  PHOTO.on = false; cancelAnimationFrame(PHOTO.raf); clearTimeout(PHOTO.restart);
  disposeTraceScene(PHOTO.ts); PHOTO.ts = null;
  const card = $('#photoCard'); if (card) card.hidden = true;
  document.body.classList.remove('photo-on');
  requestRender();
  const b = $('#snap'); if (b) b.focus({ preventScroll: true });
}
function photoSave() {
  if (!PHOTO.pt || PHOTO.pt.samples < PHOTO.saveAt) return;
  stampAndSave(R3.renderer.domElement, 'rivers-refined-photo.png', 'Soft wall design, photo render');
  toast('Photo saved');
}
function renderPhotoCard(phase) {
  let c = $('#photoCard');
  if (!c) {
    c = document.createElement('div'); c.id = 'photoCard'; c.className = 'photo-card'; c.setAttribute('role', 'region'); c.setAttribute('aria-label', 'Photo render');
    c.innerHTML = '<div class="pc-head"><span class="pc-title">Photo render</span><span class="pc-state" aria-live="polite"></span></div>' +
      '<div class="pc-bar" aria-hidden="true"><span></span></div>' +
      '<p class="pc-note"></p>' +
      '<div class="pc-actions"><button type="button" class="pc-link" id="photoOnWall">On your own photo</button><button type="button" class="pc-close" id="photoClose">Close</button><button type="button" class="pc-save" id="photoSave">' + ICON.image + '<span>Save photo</span></button></div>';
    $('.stage').appendChild(c);
    c.addEventListener('click', e => { const b = e.target.closest('button'); if (!b) return; if (b.id === 'photoClose') photoClose(); else if (b.id === 'photoSave') photoSave(); else if (b.id === 'photoOnWall') onWallOpen(); });
  }
  c.hidden = false; document.body.classList.add('photo-on');
  const n = PHOTO.pt ? Math.floor(PHOTO.pt.samples) : 0, pct = Math.min(100, Math.round(n / PHOTO.goal * 100));
  const words = {
    prep: ['Setting up the light', 'We trace the light through your room on this device. Nothing is uploaded.'],
    run: [pct < 15 ? 'Rendering' : 'Refining, ' + pct + '%', 'Keep this view still and the picture sharpens. Drag the room and it starts again from the new view.'],
    moving: ['Following the camera', 'The photo starts again when you let go.'],
    done: ['Finished', 'Save the photo, or move the room and render another view.'],
    error: ['Not available here', PHOTO.err],
  }[phase];
  $('.pc-state', c).textContent = words[0];
  $('.pc-note', c).textContent = words[1];
  $('.pc-bar span', c).style.transform = 'scaleX(' + (phase === 'done' ? 1 : phase === 'prep' || phase === 'moving' ? 0 : pct / 100) + ')';
  c.dataset.phase = phase;
  const save = $('#photoSave', c); save.disabled = !(PHOTO.pt && n >= PHOTO.saveAt && (phase === 'run' || phase === 'done'));
}
// ------------------------------------------------------------ On your wall
// The visitor's own photo, with our exact wall laid on it: they mark the wall's four corners, and the wall we built in
// 3D (rendered square-on, real fabric, real padding, real seams) is warped onto those corners with a true perspective
// map. Nothing is invented and nothing leaves the device: no upload, no AI. A picture of the design, labelled as one.
var WP = { on: false, img: null, wall: 'front', tex: null, pts: null, drag: -1, light: 0.35, raf: 0 };
const onWallKey = () => isCeil(ui.wall) ? 'front' : ui.wall;
const wallWidthOf = k => (k === 'front' || k === 'back') ? state.room.W : state.room.L;
/** The wall square-on: an orthographic render of that one wall's group, exactly its width by the room's height. */
function renderWallTexture(k) {
  const r = R3.renderer, f = wallFrame(k), W = f.width, H = state.room.H, wg = R3.walls[k] && R3.walls[k].group;
  if (!wg) return null;
  const px = Math.min(2048, r.capabilities.maxTextureSize || 2048), tw = W >= H ? px : Math.round(px * W / H), th = W >= H ? Math.round(px * H / W) : px;
  const cam = new T.OrthographicCamera(-W / 2, W / 2, H / 2, -H / 2, 1, 6000);
  const n = new T.Vector3(...f.n), c = new T.Vector3(...f.o).addScaledVector(new T.Vector3(...f.u), W / 2).setY(H / 2);
  cam.position.copy(c).addScaledVector(n, 1200); cam.up.set(0, 1, 0); cam.lookAt(c); cam.updateMatrixWorld();
  const saved = R3.room.children.map(o => o.visible), pr = r.getPixelRatio(), { w, h } = viewSize();
  const out = document.createElement('canvas'); out.width = tw; out.height = th;
  try {
    R3.room.children.forEach(o => { o.visible = o === wg; });
    r.setPixelRatio(1); r.setSize(tw, th, false); r.render(R3.scene, cam);
    out.getContext('2d').drawImage(r.domElement, 0, 0, tw, th);
  } finally {
    R3.room.children.forEach((o, i) => { o.visible = saved[i]; });
    r.setPixelRatio(pr); r.setSize(w, h, false); requestRender();
  }
  return out;
}
/** Unit square to the marked quad (TL, TR, BR, BL), the standard projective map. */
function squareToQuad(p) {
  const [x0, y0] = p[0], [x1, y1] = p[1], [x2, y2] = p[2], [x3, y3] = p[3];
  const dx1 = x1 - x2, dx2 = x3 - x2, dy1 = y1 - y2, dy2 = y3 - y2, sx = x0 - x1 + x2 - x3, sy = y0 - y1 + y2 - y3;
  let g = 0, hh = 0;
  if (Math.abs(sx) > 1e-9 || Math.abs(sy) > 1e-9) { const den = dx1 * dy2 - dx2 * dy1 || 1e-9; g = (sx * dy2 - dx2 * sy) / den; hh = (dx1 * sy - sx * dy1) / den; }
  const a = x1 - x0 + g * x1, b = x3 - x0 + hh * x3, d = y1 - y0 + g * y1, e = y3 - y0 + hh * y3;
  return (u, v) => { const q = g * u + hh * v + 1; return [(a * u + b * v + x0) / q, (d * u + e * v + y0) / q]; };
}
/** Draw the wall texture onto the quad: a fine mesh of triangles, each an exact affine piece of the perspective map. */
function warpInto(g, src, pts, N) {
  const map = squareToQuad(pts), sw = src.width, sh = src.height, P = [];
  for (let j = 0; j <= N; j++) { P[j] = []; for (let i = 0; i <= N; i++) P[j][i] = map(i / N, j / N); }
  const tri = (s0, s1, s2, d0, d1, d2) => {
    // grow the clip a hair past the edge so neighbouring triangles leave no hairline
    const cx = (d0[0] + d1[0] + d2[0]) / 3, cy = (d0[1] + d1[1] + d2[1]) / 3, grow = q => [q[0] + (q[0] - cx) * 0.02 + Math.sign(q[0] - cx) * 0.4, q[1] + (q[1] - cy) * 0.02 + Math.sign(q[1] - cy) * 0.4];
    const D0 = grow(d0), D1 = grow(d1), D2 = grow(d2);
    const den = (s1[0] - s0[0]) * (s2[1] - s0[1]) - (s2[0] - s0[0]) * (s1[1] - s0[1]); if (!den) return;
    const a = ((d1[0] - d0[0]) * (s2[1] - s0[1]) - (d2[0] - d0[0]) * (s1[1] - s0[1])) / den;
    const b = ((d1[1] - d0[1]) * (s2[1] - s0[1]) - (d2[1] - d0[1]) * (s1[1] - s0[1])) / den;
    const c = ((d2[0] - d0[0]) * (s1[0] - s0[0]) - (d1[0] - d0[0]) * (s2[0] - s0[0])) / den;
    const d = ((d2[1] - d0[1]) * (s1[0] - s0[0]) - (d1[1] - d0[1]) * (s2[0] - s0[0])) / den;
    g.save(); g.beginPath(); g.moveTo(D0[0], D0[1]); g.lineTo(D1[0], D1[1]); g.lineTo(D2[0], D2[1]); g.closePath(); g.clip();
    g.transform(a, b, c, d, d0[0] - a * s0[0] - c * s0[1], d0[1] - b * s0[0] - d * s0[1]);
    g.drawImage(src, 0, 0); g.restore();
  };
  for (let j = 0; j < N; j++) for (let i = 0; i < N; i++) {
    const s00 = [i / N * sw, j / N * sh], s10 = [(i + 1) / N * sw, j / N * sh], s01 = [i / N * sw, (j + 1) / N * sh], s11 = [(i + 1) / N * sw, (j + 1) / N * sh];
    tri(s00, s10, s11, P[j][i], P[j][i + 1], P[j + 1][i + 1]); tri(s00, s11, s01, P[j][i], P[j + 1][i + 1], P[j + 1][i]);
  }
}
/** The finished picture at the photo's own size: photo, wall, and the room's light borrowed back from the photo. */
function composeOnWall(N) {
  const im = WP.img, c = document.createElement('canvas'); c.width = im.naturalWidth; c.height = im.naturalHeight;
  const g = c.getContext('2d'); g.drawImage(im, 0, 0);
  const layer = document.createElement('canvas'); layer.width = c.width; layer.height = c.height;
  const lg = layer.getContext('2d'); warpInto(lg, WP.tex, WP.pts, N);
  if (WP.light > 0) {
    // the photo's own shading, blurred and grey, laid over the wall in soft light: the lamp-side stays brighter, the far
    // corner stays darker, and the wall stops looking pasted on
    lg.save(); lg.globalAlpha = WP.light; lg.filter = 'grayscale(1) blur(' + Math.round(c.width / 90) + 'px) contrast(1.3)';
    lg.globalCompositeOperation = 'soft-light'; lg.drawImage(im, 0, 0); lg.restore();
    // soft-light can paint outside the wall; keep only the wall
    lg.save(); lg.globalCompositeOperation = 'destination-in'; lg.beginPath(); WP.pts.forEach((p, i) => i ? lg.lineTo(p[0], p[1]) : lg.moveTo(p[0], p[1])); lg.closePath(); lg.fill(); lg.restore();
  }
  g.drawImage(layer, 0, 0);
  return c;
}
function onWallOpen() {
  if (!R3.ready) { toast('The room is still loading'); return; }
  if (PHOTO && PHOTO.on) photoClose();
  WP.on = true; WP.wall = onWallKey();
  let o = $('#onWall');
  if (!o) {
    o = document.createElement('div'); o.id = 'onWall'; o.className = 'onwall'; o.setAttribute('role', 'dialog'); o.setAttribute('aria-modal', 'false'); o.setAttribute('aria-labelledby', 'owTitle');
    o.innerHTML = '<div class="ow-stage" id="owStage"><canvas id="owCanvas" aria-label="Your photo with the wall on it"></canvas><svg id="owHandles" class="ow-handles"></svg>' +
      '<label class="ow-pick" id="owPick"><input type="file" accept="image/*" id="owFile" class="sr"><span class="ow-pick-ic">' + ICON.image + '</span><span class="ow-pick-t">Choose a photo of the wall</span><span class="ow-pick-s">Stand back, face the wall, and get all four corners in. The photo stays on this device.</span></label></div>' +
      '<div class="ow-panel"><div class="ow-head"><h2 id="owTitle" class="ow-title"></h2><button type="button" class="iconbtn" id="owClose" aria-label="Close">' + ICON.close + '</button></div>' +
      '<p class="ow-note" id="owNote"></p>' +
      '<div class="ow-controls" id="owControls" hidden>' +
      '<label class="ow-field"><span>Wall width</span><input type="text" inputmode="decimal" id="owWidth" autocomplete="off"></label>' +
      '<label class="ow-field ow-range"><span>Match the room\'s light</span><input type="range" min="0" max="0.8" step="0.05" id="owLight"></label>' +
      '<div class="ow-actions"><button type="button" class="pc-close" id="owChange">Change photo</button><button type="button" class="pc-save" id="owSave">' + ICON.image + '<span>Save image</span></button></div></div></div>';
    document.body.appendChild(o);   // not inside .stage: a fixed stage is its own stacking layer, under the design panel
    $('#owFile', o).addEventListener('change', e => { const f = e.target.files && e.target.files[0]; if (f) onWallLoad(f); e.target.value = ''; });
    o.addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b) return;
      if (b.id === 'owClose') onWallClose(); else if (b.id === 'owChange') $('#owFile').click(); else if (b.id === 'owSave') onWallSave();
    });
    $('#owLight', o).addEventListener('input', e => { WP.light = +e.target.value; onWallDraw(); });
    $('#owWidth', o).addEventListener('change', e => {
      const v = G.parseLength(e.target.value);
      if (!(isFinite(v) && v >= 24 && v <= 1200)) { e.target.value = G.fmtFtIn(wallWidthOf(WP.wall)); toast('Type a width like 14\' 6"'); return; }
      if (WP.wall === 'front' || WP.wall === 'back') state.room.W = v; else state.room.L = v;
      commit(true);
      setTimeout(() => { if (WP.on) { WP.tex = renderWallTexture(WP.wall); onWallDraw(); } }, 350);
    });
    const svg = $('#owHandles', o);
    svg.addEventListener('pointerdown', e => { const h = e.target.closest('[data-i]'); if (!h) return; WP.focus = null; WP.drag = +h.dataset.i; svg.setPointerCapture(e.pointerId); e.preventDefault(); });
    svg.addEventListener('pointermove', e => { if (WP.drag < 0) return; const p = toImage(e); WP.pts[WP.drag] = p; onWallDraw(true); });
    const end = () => { if (WP.drag >= 0) { WP.drag = -1; onWallDraw(); } };
    svg.addEventListener('pointerup', end); svg.addEventListener('pointercancel', end);
    svg.addEventListener('keydown', e => {
      const h = e.target.closest('[data-i]'); if (!h) return;
      const k = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] }[e.key]; if (!k) return;
      e.preventDefault(); WP.focus = +h.dataset.i; const s = (e.shiftKey ? 10 : 2) * WP.scaleInv; const p = WP.pts[+h.dataset.i]; p[0] += k[0] * s; p[1] += k[1] * s; onWallDraw();
    });
    new ResizeObserver(() => { if (WP.on) onWallDraw(); }).observe($('#owStage', o));
  }
  o.hidden = false; document.body.classList.add('onwall-on');
  $('#owTitle', o).textContent = (wallLabel(WP.wall)) + ' wall on your photo';
  $('#owWidth', o).value = G.fmtFtIn(wallWidthOf(WP.wall));
  $('#owLight', o).value = WP.light;
  WP.tex = renderWallTexture(WP.wall);
  onWallDraw();
  if (!WP.img) $('#owPick', o).focus();
}
function onWallLoad(file) {
  const url = URL.createObjectURL(file), im = new Image();
  im.onload = () => {
    WP.img = im; const w = im.naturalWidth, h = im.naturalHeight, mx = w * 0.22, my = h * 0.2;
    WP.pts = [[mx, my], [w - mx, my], [w - mx, h - my], [mx, h - my]];
    onWallDraw();
  };
  im.onerror = () => { URL.revokeObjectURL(url); toast('That file could not be opened as a photo'); };
  im.src = url;
}
function toImage(e) {
  const r = $('#owCanvas').getBoundingClientRect();
  return [Math.max(0, Math.min(WP.img.naturalWidth, (e.clientX - r.left) * WP.scaleInv)), Math.max(0, Math.min(WP.img.naturalHeight, (e.clientY - r.top) * WP.scaleInv))];
}
/** Draw at screen size: a coarse mesh while a corner is being dragged, the fine one when it is let go. */
function onWallDraw(fast) {
  const o = $('#onWall'); if (!o || !WP.on) return;
  const has = !!WP.img, cv = $('#owCanvas', o), svg = $('#owHandles', o), st = $('#owStage', o);
  $('#owPick', o).hidden = has; $('#owControls', o).hidden = !has; cv.hidden = !has; svg.style.display = has ? '' : 'none';
  $('#owNote', o).textContent = has ? 'Drag the four gold corners onto the corners of your wall. If furniture hides a corner, put it where the corner would be.'
    : 'See this design on a photo of your own room.';
  if (!has || !WP.tex) return;
  const im = WP.img, sr = st.getBoundingClientRect(), k = Math.min((sr.width - 24) / im.naturalWidth, (sr.height - 24) / im.naturalHeight);
  const dw = Math.round(im.naturalWidth * k), dh = Math.round(im.naturalHeight * k), dpr = Math.min(2, window.devicePixelRatio || 1);
  WP.scaleInv = 1 / k;
  cv.style.width = dw + 'px'; cv.style.height = dh + 'px'; cv.width = Math.round(dw * dpr); cv.height = Math.round(dh * dpr);
  cancelAnimationFrame(WP.raf);
  WP.raf = requestAnimationFrame(() => {
    const g = cv.getContext('2d'), s = k * dpr; g.setTransform(1, 0, 0, 1, 0, 0); g.clearRect(0, 0, cv.width, cv.height);
    g.drawImage(im, 0, 0, cv.width, cv.height);
    const pts = WP.pts.map(p => [p[0] * s, p[1] * s]);
    const layer = document.createElement('canvas'); layer.width = cv.width; layer.height = cv.height;
    const lg = layer.getContext('2d'); warpInto(lg, WP.tex, pts, fast ? 10 : 22);
    if (WP.light > 0 && !fast) {
      lg.save(); lg.globalAlpha = WP.light; lg.filter = 'grayscale(1) blur(' + Math.max(2, Math.round(cv.width / 90)) + 'px) contrast(1.3)';
      lg.globalCompositeOperation = 'soft-light'; lg.drawImage(im, 0, 0, cv.width, cv.height); lg.restore();
      lg.save(); lg.globalCompositeOperation = 'destination-in'; lg.beginPath(); pts.forEach((p, i) => i ? lg.lineTo(p[0], p[1]) : lg.moveTo(p[0], p[1])); lg.closePath(); lg.fill(); lg.restore();
    }
    g.drawImage(layer, 0, 0);
  });
  svg.setAttribute('width', dw); svg.setAttribute('height', dh); svg.setAttribute('viewBox', '0 0 ' + dw + ' ' + dh);
  svg.style.left = cv.offsetLeft + 'px'; svg.style.top = cv.offsetTop + 'px';
  const q = WP.pts.map(p => [p[0] * k, p[1] * k]), names = ['Top left', 'Top right', 'Bottom right', 'Bottom left'];
  svg.innerHTML = '<path class="ow-quad" d="M' + q.map(p => p[0].toFixed(1) + ' ' + p[1].toFixed(1)).join('L') + 'Z"/>' +
    q.map((p, i) => '<g class="ow-h" data-i="' + i + '" tabindex="0" role="button" aria-label="' + names[i] + ' corner. Drag, or use the arrow keys." transform="translate(' + p[0].toFixed(1) + ' ' + p[1].toFixed(1) + ')"><circle class="ow-hit" r="22"/><circle class="ow-dot" r="9"/></g>').join('');
  if (WP.focus != null) { const el = svg.querySelector('[data-i="' + WP.focus + '"]'); if (el) el.focus(); }
}
function onWallSave() {
  if (!WP.img || !WP.tex) return;
  stampAndSave(composeOnWall(32), 'rivers-refined-on-your-wall.png', 'Your photo with our design on it, for planning. The drawing governs.');
  toast('Image saved');
}
function onWallClose() {
  WP.on = false; const o = $('#onWall'); if (o) o.hidden = true; document.body.classList.remove('onwall-on');
  const b = $('#railOnWall'); if (b) b.focus({ preventScroll: true });
}
document.addEventListener('keydown', e => { if (e.key === 'Escape' && WP && WP.on) { e.stopPropagation(); onWallClose(); } }, true);

const camKey = () => R3.camera.matrixWorld.elements.map(v => v.toFixed(3)).join(',') + '|' + R3.camera.projectionMatrix.elements[0].toFixed(4);
document.addEventListener('keydown', e => { if (e.key === 'Escape' && PHOTO.on) { e.stopPropagation(); photoClose(); } }, true);
function saveDrawing() {
  const svg = elevationSVG(ui.wall, { dims: true, parts: PARTS });
  const vb = /viewBox="([^"]+)"/.exec(svg)[1].split(' ').map(Number), Wd = 2400, Hd = Math.round(Wd * vb[3] / vb[2]);
  const blob = new Blob([svg.replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" width="' + Wd + '" height="' + Hd + '" ')], { type: 'image/svg+xml' });
  const url = URL.createObjectURL(blob), img = new Image();
  img.onload = () => {
    const c = document.createElement('canvas'); c.width = Wd; c.height = Hd + 140;
    const g = c.getContext('2d'); g.fillStyle = INK.ground; g.fillRect(0, 0, c.width, c.height); g.drawImage(img, 0, 0, Wd, Hd);
    URL.revokeObjectURL(url);
    stampAndSave(c, 'rivers-refined-' + ui.wall + '-drawing.png', (isCeil(ui.wall) ? 'Ceiling' : wallLabel(ui.wall) + ' wall') + ' drawing, planning picture');
    toast('Drawing saved');
  };
  img.onerror = () => { URL.revokeObjectURL(url); toast('The drawing could not be saved'); };
  img.src = url;
}

// Room pictures for the room-type list: a real render of each starting room, made once in a small second renderer.
function renderPresetThumbs() {
  if (!R3.ready || R3.thumbsDone) return;
  R3.thumbsDone = true;
  let tr;
  try {
    tr = new T.WebGLRenderer({ antialias: true, preserveDrawingBuffer: true });
    tr.setPixelRatio(1); tr.setSize(320, 200, false);
    tr.outputColorSpace = T.SRGBColorSpace; tr.toneMapping = T.ACESFilmicToneMapping;
    tr.shadowMap.enabled = true; tr.shadowMap.type = T.PCFSoftShadowMap;
  } catch (e) { return; }
  const saved = state, savedUi = { wall: ui.wall, view: ui.view };
  const cam = new T.PerspectiveCamera(50, 1.6, 1, 20000);
  try {
    for (const [key] of St.PRESET_LIST) {
      state = St.PRESETS[key]();
      if (LIGHT && !['theater', 'ceiling', 'studio'].includes(key)) state.room.floor = 'wood';
      const f = presetFocus(key);
      ui.wall = f === 'room' ? 'left' : f; ui.view = f === 'room' ? 'room' : 'wall';
      computeAll(); buildScene();
      let pos, target;
      if (f === 'room') ({ pos, target } = roomPose());
      else if (f === 'ceiling') ({ pos, target } = wallPose('ceiling'));
      else {
        const fr = wallFrame(ui.wall), H = state.room.H, v = Math.tan(25 * Math.PI / 180);
        const dist = Math.max((H / 2) / v * 1.02, (fr.width / 2) / (v * 1.6) * 1.04);
        const o = new T.Vector3(...fr.o), u = new T.Vector3(...fr.u), n = new T.Vector3(...fr.n), c = o.clone().addScaledVector(u, fr.width / 2).setY(H * 0.5);
        pos = c.clone().addScaledVector(n, dist).addScaledVector(u, -dist * 0.1).setY(H * 0.46); target = c;
      }
      cam.position.copy(pos); cam.lookAt(target); cam.updateMatrixWorld();
      cull(cam.position);
      tr.toneMappingExposure = R3.renderer.toneMappingExposure;
      tr.render(R3.scene, cam);
      PRESET_IMG[key] = tr.domElement.toDataURL('image/jpeg', 0.84);
    }
  } catch (e) { R3.thumbError = String(e && e.message || e); }
  state = saved; ui.wall = savedUi.wall; ui.view = savedUi.view;
  computeAll(); buildScene();
  if (R3.key.shadow.map) { R3.key.shadow.map.dispose(); R3.key.shadow.map = null; }
  tr.dispose(); tr.forceContextLoss && tr.forceContextLoss();
  renderRoom(); requestRender();
}

async function init3D() {
  const host = $('#viewport'), msg = $('#viewportMsg');
  try {
    const [three, oc, bgu, envMod, reflMod, rboxMod] = await Promise.all([import('three'), import('three/addons/controls/OrbitControls.js'), import('three/addons/utils/BufferGeometryUtils.js'),
      import('three/addons/environments/RoomEnvironment.js').catch(() => null), import('three/addons/objects/Reflector.js').catch(() => null),
      import('three/addons/geometries/RoundedBoxGeometry.js').catch(() => null)]);
    T = three; BGU = bgu; REFL = reflMod && reflMod.Reflector; RBOX = rboxMod && rboxMod.RoundedBoxGeometry;
    const renderer = new T.WebGLRenderer({ antialias: true, preserveDrawingBuffer: true, powerPreference: 'high-performance' });
    renderer.setPixelRatio(Math.min(LOW ? 1.75 : 2, window.devicePixelRatio || 1));
    renderer.outputColorSpace = T.SRGBColorSpace;
    renderer.toneMapping = T.ACESFilmicToneMapping; renderer.toneMappingExposure = 1;
    renderer.shadowMap.enabled = true; renderer.shadowMap.type = T.PCFSoftShadowMap;
    host.appendChild(renderer.domElement);
    const scene = new T.Scene(); scene.background = new T.Color(LOOK.bg);
    if (envMod && envMod.RoomEnvironment) {
      try { const pm = new T.PMREMGenerator(renderer); ENV = pm.fromScene(new envMod.RoomEnvironment(), 0.04).texture; pm.dispose(); } catch (e) { ENV = null; }
    }
    scene.environment = ENV;
    R3.cubeRT = new T.WebGLCubeRenderTarget(LOW ? 128 : 256, { type: T.HalfFloatType });
    R3.cubeCam = new T.CubeCamera(1, 6000, R3.cubeRT);
    const camera = new T.PerspectiveCamera(45, 1, 1, 20000);
    const controls = new oc.OrbitControls(camera, renderer.domElement);
    controls.enableDamping = false; controls.enablePan = false; controls.rotateSpeed = 0.55;
    controls.maxPolarAngle = Math.PI * 0.495; controls.minDistance = 24; controls.maxDistance = 3000;
    controls.addEventListener('change', () => { clampCamera(); requestRender(); });
    controls.addEventListener('start', () => { R3.tween = null; R3.userMove = true; });
    controls.addEventListener('end', () => updateMirrors());
    const hemi = new T.HemisphereLight(0xfff4e8, 0x9a8f84, 1.5); scene.add(hemi);
    const key = new T.DirectionalLight(0xffe6c8, 2.4); key.castShadow = true;
    key.shadow.mapSize.set(LOW ? 1024 : 2048, LOW ? 1024 : 2048); key.shadow.bias = -0.0003; key.shadow.normalBias = 0.35; key.shadow.radius = 5;
    scene.add(key); scene.add(key.target);
    const fill = new T.DirectionalLight(0xdfe8ff, 0.6); scene.add(fill); scene.add(fill.target);
    const coves = [0, 1, 2, 3].map(() => { const l = new T.PointLight(0xffd6ad, 150, 0, 1.2); scene.add(l); return l; });
    const screenLight = new T.PointLight(0x9db3d0, 60, 0, 1.2); scene.add(screenLight);
    Object.assign(R3, { renderer, scene, camera, controls, hemi, key, fill, coves, screenLight, ready: true });
    makeTextures();
    const resize = () => {
      const w = host.clientWidth, h = host.clientHeight;
      if (!w || !h) return;
      renderer.setSize(w, h, false);
      R3.safe = measureSafe(); setSafeVars(R3.safe); applyProjection(); requestRender();
    };
    new ResizeObserver(() => { resize(); onChromeChange(); }).observe(host);
    const studio = $('#studio'); if (studio) new ResizeObserver(onChromeChange).observe(studio);
    // a tap on the room (not a drag) puts the flyout away so the room has the screen
    let down = null;
    renderer.domElement.addEventListener('pointerdown', (e) => { down = [e.clientX, e.clientY]; });
    renderer.domElement.addEventListener('pointerup', (e) => {
      if (down && Math.hypot(e.clientX - down[0], e.clientY - down[1]) < 5 && SHELL === 'C' && ui.open && !PHONE()) { ui.open = false; renderSteps(); onChromeChange(); }
      down = null;
    });
    resize();
    msg.remove();
    buildScene();
    if (ui.view === 'room') viewRoom(false); else focusWall(ui.wall, false);
    setTimeout(renderPresetThumbs, 450);
  } catch (err) {
    msg.textContent = 'The 3D view could not load. The flat drawing still works.';
    R3.error = String(err && err.message || err);
  }
}



// ------------------------------------------------------------ the design assistant
// A chat in the flyout that sets the design up as the visitor describes it. The reply's actions go
// through RRAssist.applyActions, which checks every value, so nothing the server says can put the
// designer in a state its own controls could not. The server (design-assist) holds the key and the
// scope guard; this page only ever talks to it and, when the visitor asks, to the inbound webhook.
// Unreachable (a local preview), it runs an offline demo with prepared answers and says so.
const ASSIST = {
  url: 'https://zhvxjlhjzaalnhkghygo.supabase.co/functions/v1/design-assist',
  inbound: 'https://zhvxjlhjzaalnhkghygo.supabase.co/functions/v1/inbound-webhook?channel=design_request',
  token: '6e3059bce74a4881ad14410629c73518be4606c29608410f81e4857d24db18af', // the website's public form token, not a secret
  siteKey: '0x4AAAAAAEnNsY90UIE1iSTa', // Cloudflare Turnstile site key, public by design
  turnstile: 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit',
};
const A = window.RRAssist;
const chat = { mode: 'checking', session: '', msgs: [], busy: false, applied: 0, ready: false, form: false, sending: false, sent: '', error: '', draft: '' };
try { const b = new Uint8Array(12); crypto.getRandomValues(b); chat.session = Array.from(b, x => x.toString(16).padStart(2, '0')).join(''); } catch (e) { chat.session = String(Date.now()) + Math.random().toString(16).slice(2); }

/** The only network call in the page. Never throws: a failure comes back as { ok: false }. */
async function assistFetch(url, body, ms) {
  const ac = new AbortController(), timer = setTimeout(() => ac.abort(), ms || 30000);
  try {
    const r = await fetch(url, body === undefined ? { signal: ac.signal } : { method: 'POST', signal: ac.signal, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    let j = null; try { j = await r.json(); } catch (e) { j = null; }
    return { ok: r.ok, status: r.status, json: j };
  } catch (e) { return { ok: false, status: 0, json: null }; }
  finally { clearTimeout(timer); }
}
async function checkAssistant() {
  const r = await assistFetch(ASSIST.url + '?status=1&token=' + ASSIST.token, undefined, 5000);
  if (r.ok && r.json && r.json.enabled === false) chat.mode = 'off';
  else if (r.ok && r.json && r.json.enabled === true) chat.mode = 'live';
  else chat.mode = 'demo';
  $$('.assist-only').forEach(el => { el.hidden = chat.mode === 'off'; });
  if (chat.mode === 'off' && ui.step === 'assistant') setStep('design');
  renderAssistant(); renderDesign();
}

function chatLine(m) {
  const who = m.role === 'user' ? 'You' : 'Rivers Refined';
  return '<li class="msg ' + (m.role === 'user' ? 'me' : 'them') + '"><span class="sr">' + who + ': </span><p>' + esc(m.text) + '</p>' +
    (m.note ? '<p class="msg-note">' + esc(m.note) + '</p>' : '') + '</li>';
}
const ASSIST_CHIPS = ['A home theater with channels and gold lines', 'A bedroom wall with a mirror in the middle', 'Describe a pattern you do not show'];
function assistantHTML() {
  const status = chat.mode === 'demo' ? '<p class="assist-status off" role="status">The assistant is offline here. You are trying a demo with prepared answers; nothing is sent anywhere.</p>'
    : chat.mode === 'checking' ? '<p class="assist-status" role="status">Connecting</p>' : '';
  let h = '<div class="group"><h3>Describe it and we will build it</h3>' +
    '<p class="lead">Tell us about the room and the look you want. We set it up in the designer as we talk, and we can draw a pattern we do not show. We keep this conversation to the design; price and timing we go over with you directly.</p>' + status + '</div>';
  h += '<div class="group assist-chat"><ol class="assist-log" id="assistLog" aria-live="polite" aria-label="Conversation">' + chat.msgs.map(chatLine).join('') +
    (chat.busy ? '<li class="msg them busy"><p>Working on it</p></li>' : '') + '</ol>';
  if (!chat.msgs.length) h += '<div class="chips" role="group" aria-label="Ideas to start from">' + ASSIST_CHIPS.map((c, i) => '<button type="button" class="chip" data-assist-chip="' + i + '">' + esc(c) + '</button>').join('') + '</div>';
  h += '<form class="assist-input" id="assistForm"><label class="sr" for="assistText">Your message</label>' +
    '<textarea id="assistText" rows="2" maxlength="1500" placeholder="For example: tall channels in a dark green velvet, with wood slats either side">' + esc(chat.draft) + '</textarea>' +
    '<button type="submit" class="primary" id="assistSend"' + (chat.busy ? ' disabled' : '') + '>Send</button></form></div>';
  if (chat.applied || chat.ready) h += assistSendHTML();
  return h;
}
function assistSendHTML() {
  const mail = '<a class="ghost block" id="assistMail" href="' + esc(St.mailtoHref(state, shareLink())) + '">' + ICON.mail + '<span>Email it from your own account instead</span></a>';
  if (chat.sent) return '<div class="group assist-send"><h3>Sent to Rivers Refined</h3><p class="lead">Your design, this conversation and your details are with us. We will reply to ' + esc(chat.sent) + ' with your quote.</p>' +
    '<a class="ghost block" id="assistMail" href="' + esc(St.mailtoHref(state, shareLink())) + '">' + ICON.mail + '<span>Keep a copy in your email</span></a></div>';
  if (!chat.form) return '<div class="group assist-send"><h3>' + (chat.ready ? 'Ready when you are' : 'Happy with it?') + '</h3>' +
    '<button type="button" class="' + (chat.ready ? 'primary' : 'ghost') + ' block" id="assistOpenSend">' + ICON.mail + '<span>Send this design to Rivers Refined for a quote</span></button></div>';
  const f = (id, label, type, ac, req) => '<div class="field"><label class="label" for="' + id + '">' + label + '</label><input class="input" id="' + id + '" type="' + type + '" autocomplete="' + ac + '"' + (req ? ' required' : '') + '></div>';
  return '<div class="group assist-send"><h3>Send this design to Rivers Refined</h3>' +
    (chat.mode === 'live' ? '<p class="lead">The link to this design, a summary and this conversation go with your details. We prepare the quote ourselves.</p>' :
      '<p class="lead">Sending from this preview is not connected. Use your own email below; the link and summary are filled in.</p>') +
    '<form id="assistSendForm" class="assist-form" novalidate>' + f('asName', 'Name', 'text', 'name', true) + f('asEmail', 'Email', 'email', 'email', true) + f('asPhone', 'Phone (optional)', 'tel', 'tel', false) +
    '<div class="field"><label class="label" for="asNotes">Anything else we should know (optional)</label><textarea class="input" id="asNotes" rows="3" maxlength="2000"></textarea></div>' +
    '<div class="hp" aria-hidden="true"><label for="asWebsite">Leave this empty</label><input id="asWebsite" tabindex="-1" autocomplete="off"></div>' +
    '<div id="assistTs" class="ts-box"></div>' +
    (chat.error ? '<p class="form-error" role="alert">' + esc(chat.error) + '</p>' : '') +
    (chat.mode === 'live' ? '<button type="submit" class="primary block" id="assistSubmit"' + (chat.sending ? ' disabled' : '') + '>' + (chat.sending ? 'Sending' : 'Send to Rivers Refined') + '</button>' : '') +
    '</form>' + mail + '</div>';
}
function renderAssistant() {
  const p = $('#paneAssistant'); if (!p) return;
  const ta = $('#assistText'); if (ta) chat.draft = ta.value;
  const had = document.activeElement && document.activeElement.id;
  p.innerHTML = assistantHTML();
  const log = $('#assistLog'); if (log) log.scrollTop = log.scrollHeight;
  if (had === 'assistText') { const t = $('#assistText'); if (t) t.focus({ preventScroll: true }); }
}

/** One turn: the visitor's words out, a reply and its design actions back. */
async function assistSend(text, retryError) {
  text = String(text || '').trim().slice(0, 1500);
  if (!text || chat.busy) return;
  if (!retryError) { chat.msgs.push({ role: 'user', text }); chat.draft = ''; const ta = $('#assistText'); if (ta) ta.value = ''; }
  chat.busy = true; renderAssistant();
  let res;
  if (chat.mode === 'live') {
    const r = await assistFetch(ASSIST.url + '?token=' + ASSIST.token, {
      session: chat.session, messages: chat.msgs.slice(-16).map(m => ({ role: m.role, text: m.text })),
      design: St.encodeState(state), wall: ui.wall, summary: St.summaryLines(state).join('\n'), retry_error: retryError || '',
    }, 45000);
    if (r.ok && r.json && typeof r.json.reply === 'string') res = r.json;
    else if (r.status === 429) res = { reply: 'We have had a lot of messages from this connection. Please try again in a little while; the designer itself keeps working.', actions: null };
    else if (r.json && r.json.off) { chat.mode = 'off'; chat.busy = false; checkAssistant(); return; }
    else res = { reply: 'We could not reach the assistant just now. Please try again, or keep designing with the menu.', actions: null };
  } else {
    await new Promise(r => setTimeout(r, 450));
    res = A.demoReply(text);
  }
  chat.busy = false;
  assistApply(res, text, !!retryError);
}
function assistApply(res, lastText, wasRetry) {
  const msg = { role: 'assistant', text: String(res.reply || '').slice(0, 2000) };
  const out = res.actions ? A.applyActions(state, res.actions, { wall: ui.wall }) : null;
  if (out && out.custom && !out.custom.ok) {
    // the engine refused the pattern: one more try with the reason, then the closest pattern we show
    if (!wasRetry && chat.mode === 'live') { assistSend(lastText, out.custom.errors.join(' ')); return; }
    const closest = res.actions.closest && A.allowed('pattern').includes(res.actions.closest) ? res.actions.closest : 'grid';
    const fallback = A.applyActions(state, { wall: res.actions.wall, set: [{ path: 'pattern', value: closest }] }, { wall: ui.wall });
    msg.text = 'We could not make that pattern work at a size we can build: ' + out.custom.errors[0] + ' We have set up the closest pattern we show, ' + St.PATTERN_WORDS[closest].toLowerCase() + ', and we can look at the custom version with you when we prepare your quote.';
    assistCommit(fallback);
  } else if (out && out.applied.length) {
    assistCommit(out);
    const hb = out.skipped.find(x => x === A.HEADBOARD_HIDES_SECTIONS);
    msg.note = hb ? 'Set up in the designer, except ' + hb + '. For a mirror centre behind a bed, choose Mirror centre, banded sides under Room.'
      : 'Set up in the designer' + (out.skipped.length ? '; some of it could not be applied' : '') + '.';
  }
  if (res.ready) { chat.ready = true; chat.form = true; }
  chat.msgs.push(msg);
  renderAssistant();
}
function assistCommit(out) {
  if (!out.applied.length) return;
  state = out.state; chat.applied++;
  ui.wall = out.wall; ui.zone = 0; ui.view = 'wall';
  commit(true);
  focusWall(ui.wall, true);
}

let tsLoading = null, tsId = null, tsWait = null;
function loadTurnstile() {
  if (tsLoading) return tsLoading;
  tsLoading = new Promise(resolve => {
    const s = document.createElement('script'); s.src = ASSIST.turnstile; s.async = true; s.onload = () => resolve(true); s.onerror = () => resolve(false);
    document.head.appendChild(s);
  });
  return tsLoading;
}
async function turnstileToken() {
  if (!(await loadTurnstile())) return '';
  for (let n = 0; n < 50 && !(window.turnstile && window.turnstile.render); n++) await new Promise(r => setTimeout(r, 100));
  if (!window.turnstile) return '';
  const box = $('#assistTs'); if (!box) return '';
  try {
    if (tsId === null || !box.firstChild) tsId = window.turnstile.render(box, { sitekey: ASSIST.siteKey, theme: LIGHT ? 'light' : 'dark', size: 'flexible', appearance: 'interaction-only', execution: 'execute',
      callback: t => { if (tsWait) tsWait(t); }, 'error-callback': () => { if (tsWait) tsWait(''); return true; }, 'timeout-callback': () => { if (tsWait) tsWait(''); } });
  } catch (e) { return ''; }
  for (let attempt = 0; attempt < 2; attempt++) {
    const t = await new Promise(resolve => { let done = false; tsWait = (v) => { if (!done) { done = true; tsWait = null; resolve(v || ''); } }; setTimeout(() => tsWait && tsWait(''), 15000);
      try { window.turnstile.reset(tsId); window.turnstile.execute(tsId); } catch (e) { tsWait(''); } });
    if (t) return t;
  }
  return '';
}
async function assistSubmit() {
  const val = (id) => ($('#' + id) || {}).value || '';
  const form = { name: val('asName'), email: val('asEmail'), phone: val('asPhone'), notes: val('asNotes'), website: val('asWebsite') };
  const errs = A.validRequest(form);
  if (errs.length) { chat.error = errs.join(' '); renderAssistant(); restoreForm(form); return; }
  chat.sending = true; chat.error = ''; renderAssistant(); restoreForm(form);
  const body = A.requestPayload(form, shareLink(), St.summaryLines(state).join('\n'), chat.msgs);
  body['cf-turnstile-response'] = await turnstileToken();
  const r = await assistFetch(ASSIST.inbound + '&token=' + ASSIST.token, body, 30000);
  chat.sending = false;
  if (r.ok) { chat.sent = form.email.trim(); chat.form = false; }
  else chat.error = r.status === 403 ? 'We could not confirm this request was sent by a person. Please use the email link below; everything is filled in.'
    : r.status === 429 ? 'We have had several requests from this connection. Please use the email link below.'
    : 'We could not send this just now. Please use the email link below; everything is filled in.';
  renderAssistant();
  if (!r.ok) restoreForm(form);
}
function restoreForm(form) {
  const set = (id, v) => { const el = $('#' + id); if (el) el.value = v; };
  set('asName', form.name); set('asEmail', form.email); set('asPhone', form.phone); set('asNotes', form.notes);
}
function bindAssistant() {
  document.addEventListener('submit', (e) => {
    if (e.target.id === 'assistForm') { e.preventDefault(); const t = $('#assistText'); if (t) assistSend(t.value); }
    if (e.target.id === 'assistSendForm') { e.preventDefault(); if (chat.mode === 'live' && !chat.sending) assistSubmit(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.target && e.target.id === 'assistText' && e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); assistSend(e.target.value); }
  });
  document.addEventListener('click', (e) => {
    const t = e.target.closest && e.target.closest('button, a');
    if (!t) return;
    if (t.dataset.assistChip != null) {
      const c = ASSIST_CHIPS[+t.dataset.assistChip];
      if (/do not show/.test(c)) { chat.draft = 'I would like a pattern you do not show: '; renderAssistant(); const ta = $('#assistText'); if (ta) { ta.focus(); ta.setSelectionRange(ta.value.length, ta.value.length); } }
      else assistSend(c);
    }
    if (t.id === 'assistOpenSend') { chat.form = true; renderAssistant(); const n = $('#asName'); if (n) n.focus(); if (chat.mode === 'live') loadTurnstile(); }
    if (t.dataset.assistPrompt != null) {
      chat.draft = 'I would like a pattern you do not show: ';
      setStep('assistant');
      const ta = $('#assistText'); if (ta) { ta.focus(); ta.setSelectionRange(ta.value.length, ta.value.length); }
    }
  });
}

// ------------------------------------------------------------ start

try { if (localStorage.getItem('rr-rail-mini') === '1') document.body.classList.add('rail-mini'); } catch (e) { /* ignore */ }
setOverlayKind();
computeAll();

renderForms();
renderElevation();
bindEvents();
bindSheet();
bindAssistant();
renderAssistant();
checkAssistant();
window.addEventListener('hashchange', () => {
  const s = hashState();
  if (s && St.encodeState(s) !== St.encodeState(state)) { state = s; commit(true); refocus(true); }
});
window.addEventListener('resize', onChromeChange);
init3D();
})();

